var fa = Object.defineProperty;
var da = (n, t, e) => t in n ? fa(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var L = (n, t, e) => da(n, typeof t != "symbol" ? t + "" : t, e);
import St, { createContext as Nn, useContext as _n, createRef as ga, useState as Qo, useCallback as pa, Fragment as ma, useEffect as ba } from "react";
import "@for-it/domain-lib";
var Ue = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function tl(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ws = { exports: {} }, an = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gi;
function ya() {
  if (Gi) return an;
  Gi = 1;
  var n = St, t = Symbol.for("react.element"), e = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, h) {
    var f, b = {}, d = null, m = null;
    h !== void 0 && (d = "" + h), c.key !== void 0 && (d = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (f in c) r.call(c, f) && !i.hasOwnProperty(f) && (b[f] = c[f]);
    if (a && a.defaultProps) for (f in c = a.defaultProps, c) b[f] === void 0 && (b[f] = c[f]);
    return { $$typeof: t, type: a, key: d, ref: m, props: b, _owner: s.current };
  }
  return an.Fragment = e, an.jsx = o, an.jsxs = o, an;
}
var cn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wi;
function va() {
  return Wi || (Wi = 1, process.env.NODE_ENV !== "production" && function() {
    var n = St, t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), y = Symbol.iterator, v = "@@iterator";
    function w(g) {
      if (g === null || typeof g != "object")
        return null;
      var N = y && g[y] || g[v];
      return typeof N == "function" ? N : null;
    }
    var E = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(g) {
      {
        for (var N = arguments.length, S = new Array(N > 1 ? N - 1 : 0), M = 1; M < N; M++)
          S[M - 1] = arguments[M];
        _("error", g, S);
      }
    }
    function _(g, N, S) {
      {
        var M = E.ReactDebugCurrentFrame, F = M.getStackAddendum();
        F !== "" && (N += "%s", S = S.concat([F]));
        var B = S.map(function($) {
          return String($);
        });
        B.unshift("Warning: " + N), Function.prototype.apply.call(console[g], console, B);
      }
    }
    var C = !1, O = !1, j = !1, U = !1, W = !1, xt;
    xt = Symbol.for("react.module.reference");
    function Zt(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || W || g === s || g === h || g === f || U || g === m || C || O || j || typeof g == "object" && g !== null && (g.$$typeof === d || g.$$typeof === b || g.$$typeof === o || g.$$typeof === a || g.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === xt || g.getModuleId !== void 0));
    }
    function ce(g, N, S) {
      var M = g.displayName;
      if (M)
        return M;
      var F = N.displayName || N.name || "";
      return F !== "" ? S + "(" + F + ")" : S;
    }
    function Yt(g) {
      return g.displayName || "Context";
    }
    function Et(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case e:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case h:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case a:
            var N = g;
            return Yt(N) + ".Consumer";
          case o:
            var S = g;
            return Yt(S._context) + ".Provider";
          case c:
            return ce(g, g.render, "ForwardRef");
          case b:
            var M = g.displayName || null;
            return M !== null ? M : Et(g.type) || "Memo";
          case d: {
            var F = g, B = F._payload, $ = F._init;
            try {
              return Et($(B));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Nt = Object.assign, Xt = 0, pr, mr, br, yr, K, vr, Er;
    function bt() {
    }
    bt.__reactDisabledLog = !0;
    function wr() {
      {
        if (Xt === 0) {
          pr = console.log, mr = console.info, br = console.warn, yr = console.error, K = console.group, vr = console.groupCollapsed, Er = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: bt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        Xt++;
      }
    }
    function V() {
      {
        if (Xt--, Xt === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Nt({}, g, {
              value: pr
            }),
            info: Nt({}, g, {
              value: mr
            }),
            warn: Nt({}, g, {
              value: br
            }),
            error: Nt({}, g, {
              value: yr
            }),
            group: Nt({}, g, {
              value: K
            }),
            groupCollapsed: Nt({}, g, {
              value: vr
            }),
            groupEnd: Nt({}, g, {
              value: Er
            })
          });
        }
        Xt < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var xe = E.ReactCurrentDispatcher, We;
    function ct(g, N, S) {
      {
        if (We === void 0)
          try {
            throw Error();
          } catch (F) {
            var M = F.stack.trim().match(/\n( *(at )?)/);
            We = M && M[1] || "";
          }
        return `
` + We + g;
      }
    }
    var Ne = !1, ue;
    {
      var Ze = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new Ze();
    }
    function _e(g, N) {
      if (!g || Ne)
        return "";
      {
        var S = ue.get(g);
        if (S !== void 0)
          return S;
      }
      var M;
      Ne = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var B;
      B = xe.current, xe.current = null, wr();
      try {
        if (N) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (it) {
              M = it;
            }
            Reflect.construct(g, [], $);
          } else {
            try {
              $.call();
            } catch (it) {
              M = it;
            }
            g.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (it) {
            M = it;
          }
          g();
        }
      } catch (it) {
        if (it && M && typeof it.stack == "string") {
          for (var D = it.stack.split(`
`), rt = M.stack.split(`
`), X = D.length - 1, Q = rt.length - 1; X >= 1 && Q >= 0 && D[X] !== rt[Q]; )
            Q--;
          for (; X >= 1 && Q >= 0; X--, Q--)
            if (D[X] !== rt[Q]) {
              if (X !== 1 || Q !== 1)
                do
                  if (X--, Q--, Q < 0 || D[X] !== rt[Q]) {
                    var Z = `
` + D[X].replace(" at new ", " at ");
                    return g.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", g.displayName)), typeof g == "function" && ue.set(g, Z), Z;
                  }
                while (X >= 1 && Q >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, xe.current = B, V(), Error.prepareStackTrace = F;
      }
      var Qt = g ? g.displayName || g.name : "", Pt = Qt ? ct(Qt) : "";
      return typeof g == "function" && ue.set(g, Pt), Pt;
    }
    function Ar(g, N, S) {
      return _e(g, !1);
    }
    function Ye(g) {
      var N = g.prototype;
      return !!(N && N.isReactComponent);
    }
    function he(g, N, S) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return _e(g, Ye(g));
      if (typeof g == "string")
        return ct(g);
      switch (g) {
        case h:
          return ct("Suspense");
        case f:
          return ct("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case c:
            return Ar(g.render);
          case b:
            return he(g.type, N, S);
          case d: {
            var M = g, F = M._payload, B = M._init;
            try {
              return he(B(F), N, S);
            } catch {
            }
          }
        }
      return "";
    }
    var It = Object.prototype.hasOwnProperty, Xe = {}, Tr = E.ReactDebugCurrentFrame;
    function Se(g) {
      if (g) {
        var N = g._owner, S = he(g.type, g._source, N ? N.type : null);
        Tr.setExtraStackFrame(S);
      } else
        Tr.setExtraStackFrame(null);
    }
    function Oe(g, N, S, M, F) {
      {
        var B = Function.call.bind(It);
        for (var $ in g)
          if (B(g, $)) {
            var D = void 0;
            try {
              if (typeof g[$] != "function") {
                var rt = Error((M || "React class") + ": " + S + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw rt.name = "Invariant Violation", rt;
              }
              D = g[$](N, $, M, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (X) {
              D = X;
            }
            D && !(D instanceof Error) && (Se(F), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", S, $, typeof D), Se(null)), D instanceof Error && !(D.message in Xe) && (Xe[D.message] = !0, Se(F), x("Failed %s type: %s", S, D.message), Se(null));
          }
      }
    }
    var Je = Array.isArray;
    function Le(g) {
      return Je(g);
    }
    function xr(g) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, S = N && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return S;
      }
    }
    function _t(g) {
      try {
        return fe(g), !1;
      } catch {
        return !0;
      }
    }
    function fe(g) {
      return "" + g;
    }
    function Nr(g) {
      if (_t(g))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xr(g)), fe(g);
    }
    var Jt = E.ReactCurrentOwner, Ce = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, qe, gt;
    function _r(g) {
      if (It.call(g, "ref")) {
        var N = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function Sr(g) {
      if (It.call(g, "key")) {
        var N = Object.getOwnPropertyDescriptor(g, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function Jr(g, N) {
      typeof g.ref == "string" && Jt.current;
    }
    function Qe(g, N) {
      {
        var S = function() {
          qe || (qe = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        S.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function Re(g, N) {
      {
        var S = function() {
          gt || (gt = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        S.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var Or = function(g, N, S, M, F, B, $) {
      var D = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: N,
        ref: S,
        props: $,
        // Record the component responsible for creating this element.
        _owner: B
      };
      return D._store = {}, Object.defineProperty(D._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(D, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.defineProperty(D, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(D.props), Object.freeze(D)), D;
    };
    function Ie(g, N, S, M, F) {
      {
        var B, $ = {}, D = null, rt = null;
        S !== void 0 && (Nr(S), D = "" + S), Sr(N) && (Nr(N.key), D = "" + N.key), _r(N) && (rt = N.ref, Jr(N, F));
        for (B in N)
          It.call(N, B) && !Ce.hasOwnProperty(B) && ($[B] = N[B]);
        if (g && g.defaultProps) {
          var X = g.defaultProps;
          for (B in X)
            $[B] === void 0 && ($[B] = X[B]);
        }
        if (D || rt) {
          var Q = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          D && Qe($, Q), rt && Re($, Q);
        }
        return Or(g, D, rt, F, M, Jt.current, $);
      }
    }
    var kt = E.ReactCurrentOwner, yt = E.ReactDebugCurrentFrame;
    function wt(g) {
      if (g) {
        var N = g._owner, S = he(g.type, g._source, N ? N.type : null);
        yt.setExtraStackFrame(S);
      } else
        yt.setExtraStackFrame(null);
    }
    var de;
    de = !1;
    function Mt(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function ke() {
      {
        if (kt.current) {
          var g = Et(kt.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function ge(g) {
      return "";
    }
    var Me = {};
    function tr(g) {
      {
        var N = ke();
        if (!N) {
          var S = typeof g == "string" ? g : g.displayName || g.name;
          S && (N = `

Check the top-level render call using <` + S + ">.");
        }
        return N;
      }
    }
    function je(g, N) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var S = tr(N);
        if (Me[S])
          return;
        Me[S] = !0;
        var M = "";
        g && g._owner && g._owner !== kt.current && (M = " It was passed a child from " + Et(g._owner.type) + "."), wt(g), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, M), wt(null);
      }
    }
    function jt(g, N) {
      {
        if (typeof g != "object")
          return;
        if (Le(g))
          for (var S = 0; S < g.length; S++) {
            var M = g[S];
            Mt(M) && je(M, N);
          }
        else if (Mt(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var F = w(g);
          if (typeof F == "function" && F !== g.entries)
            for (var B = F.call(g), $; !($ = B.next()).done; )
              Mt($.value) && je($.value, N);
        }
      }
    }
    function Lr(g) {
      {
        var N = g.type;
        if (N == null || typeof N == "string")
          return;
        var S;
        if (typeof N == "function")
          S = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === b))
          S = N.propTypes;
        else
          return;
        if (S) {
          var M = Et(N);
          Oe(S, g.props, "prop", M, g);
        } else if (N.PropTypes !== void 0 && !de) {
          de = !0;
          var F = Et(N);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Bt(g) {
      {
        for (var N = Object.keys(g.props), S = 0; S < N.length; S++) {
          var M = N[S];
          if (M !== "children" && M !== "key") {
            wt(g), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", M), wt(null);
            break;
          }
        }
        g.ref !== null && (wt(g), x("Invalid attribute `ref` supplied to `React.Fragment`."), wt(null));
      }
    }
    var Cr = {};
    function qr(g, N, S, M, F, B) {
      {
        var $ = Zt(g);
        if (!$) {
          var D = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (D += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var rt = ge();
          rt ? D += rt : D += ke();
          var X;
          g === null ? X = "null" : Le(g) ? X = "array" : g !== void 0 && g.$$typeof === t ? (X = "<" + (Et(g.type) || "Unknown") + " />", D = " Did you accidentally export a JSX literal instead of a component?") : X = typeof g, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", X, D);
        }
        var Q = Ie(g, N, S, F, B);
        if (Q == null)
          return Q;
        if ($) {
          var Z = N.children;
          if (Z !== void 0)
            if (M)
              if (Le(Z)) {
                for (var Qt = 0; Qt < Z.length; Qt++)
                  jt(Z[Qt], g);
                Object.freeze && Object.freeze(Z);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jt(Z, g);
        }
        if (It.call(N, "key")) {
          var Pt = Et(g), it = Object.keys(N).filter(function(Be) {
            return Be !== "key";
          }), rr = it.length > 0 ? "{key: someKey, " + it.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cr[Pt + rr]) {
            var tn = it.length > 0 ? "{" + it.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rr, Pt, tn, Pt), Cr[Pt + rr] = !0;
          }
        }
        return g === r ? Bt(Q) : Lr(Q), Q;
      }
    }
    function Qr(g, N, S) {
      return qr(g, N, S, !0);
    }
    function Rr(g, N, S) {
      return qr(g, N, S, !1);
    }
    var er = Rr, et = Qr;
    cn.Fragment = r, cn.jsx = er, cn.jsxs = et;
  }()), cn;
}
process.env.NODE_ENV === "production" ? Ws.exports = ya() : Ws.exports = va();
var ot = Ws.exports;
const Cp = Nn({
  notifyError: () => {
  }
}), Ea = Nn({
  showConfirmationModal: () => {
  },
  async withLoadingModal() {
  }
});
function wi(...n) {
  return n.filter(
    (t) => typeof t == "string" && t.length > 0
  ).map((t) => t.trim()).join(" ");
}
const wa = Nn({
  isTouched: !1,
  isLoading: !1,
  value: {},
  errors: {},
  updateFormValue: () => {
  }
});
function Aa({
  className: n,
  disabled: t,
  onClick: e,
  children: r,
  title: s,
  type: i = "button",
  flavor: o = "raised",
  color: a = "none"
}) {
  return /* @__PURE__ */ ot.jsx(
    "button",
    {
      type: i,
      className: wi(
        "p-2 flex justify-center items-center gap-2 rounded",
        (o === "raised" || o === "outline") && "shadow-slate-300 hover:shadow-slate-400 hover:shadow-md",
        o === "raised" && "shadow-md shadow-slate-300 hover:shadow-slate-400",
        o === "outline" && "border border-slate-600",
        o === "raised" && a === "primary" && "bg-primary-400",
        o === "raised" && a === "danger" && "bg-red-400",
        o === "raised" && a === "success" && "bg-green-400",
        o === "raised" && a === "warning" && "bg-yellow-400",
        o === "clear" && a == "primary" && "text-primary-700",
        o === "clear" && a === "danger" && "text-red-700",
        o === "clear" && a === "success" && "text-green-700",
        o === "clear" && a === "warning" && "text-yellow-700",
        o === "outline" && a === "primary" && "text-primary-700 !border-primary-700",
        o === "outline" && a === "danger" && "text-red-700 !border-red-700",
        o === "outline" && a === "success" && "text-green-700 !border-green-700",
        o === "outline" && a === "warning" && "text-yellow-700 !border-yellow-700",
        t && "opacity-50 cursor-not-allowed",
        n
      ),
      disabled: t,
      onClick: (c) => {
        c.stopPropagation(), e == null || e();
      },
      title: s,
      children: r
    }
  );
}
function Ta({ name: n, className: t = "" }) {
  return /* @__PURE__ */ ot.jsx("i", { className: wi("bx", n, t) });
}
function el({ className: n }) {
  return /* @__PURE__ */ ot.jsx(
    "div",
    {
      className: wi(
        "flex justify-center items-center text-3xl p-2",
        n
      ),
      children: /* @__PURE__ */ ot.jsx(Ta, { className: "animate-spin", name: "bx-loader-alt" })
    }
  );
}
function Zi({
  children: n,
  type: t = "submit",
  flavor: e = "raised",
  color: r = "primary",
  ...s
}) {
  const { isLoading: i } = _n(wa);
  return /* @__PURE__ */ ot.jsxs(
    Aa,
    {
      disabled: i,
      type: t,
      flavor: e,
      color: r,
      ...s,
      children: [
        i && /* @__PURE__ */ ot.jsx(el, {}),
        n
      ]
    }
  );
}
var rl = typeof global == "object" && global && global.Object === Object && global, xa = typeof self == "object" && self && self.Object === Object && self, ae = rl || xa || Function("return this")(), Ke = ae.Symbol, nl = Object.prototype, Na = nl.hasOwnProperty, _a = nl.toString, un = Ke ? Ke.toStringTag : void 0;
function Sa(n) {
  var t = Na.call(n, un), e = n[un];
  try {
    n[un] = void 0;
    var r = !0;
  } catch {
  }
  var s = _a.call(n);
  return r && (t ? n[un] = e : delete n[un]), s;
}
var Oa = Object.prototype, La = Oa.toString;
function Ca(n) {
  return La.call(n);
}
var qa = "[object Null]", Ra = "[object Undefined]", Yi = Ke ? Ke.toStringTag : void 0;
function Xr(n) {
  return n == null ? n === void 0 ? Ra : qa : Yi && Yi in Object(n) ? Sa(n) : Ca(n);
}
function ve(n) {
  return n != null && typeof n == "object";
}
var or = Array.isArray;
function Ve(n) {
  var t = typeof n;
  return n != null && (t == "object" || t == "function");
}
function sl(n) {
  return n;
}
var Ia = "[object AsyncFunction]", ka = "[object Function]", Ma = "[object GeneratorFunction]", ja = "[object Proxy]";
function Ai(n) {
  if (!Ve(n))
    return !1;
  var t = Xr(n);
  return t == ka || t == Ma || t == Ia || t == ja;
}
var Ms = ae["__core-js_shared__"], Xi = function() {
  var n = /[^.]+$/.exec(Ms && Ms.keys && Ms.keys.IE_PROTO || "");
  return n ? "Symbol(src)_1." + n : "";
}();
function Ba(n) {
  return !!Xi && Xi in n;
}
var Pa = Function.prototype, Da = Pa.toString;
function cr(n) {
  if (n != null) {
    try {
      return Da.call(n);
    } catch {
    }
    try {
      return n + "";
    } catch {
    }
  }
  return "";
}
var $a = /[\\^$.*+?()[\]{}|]/g, Ua = /^\[object .+?Constructor\]$/, Fa = Function.prototype, Ha = Object.prototype, za = Fa.toString, Ka = Ha.hasOwnProperty, Va = RegExp(
  "^" + za.call(Ka).replace($a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ga(n) {
  if (!Ve(n) || Ba(n))
    return !1;
  var t = Ai(n) ? Va : Ua;
  return t.test(cr(n));
}
function Wa(n, t) {
  return n == null ? void 0 : n[t];
}
function ur(n, t) {
  var e = Wa(n, t);
  return Ga(e) ? e : void 0;
}
var Zs = ur(ae, "WeakMap"), Ji = Object.create, Za = /* @__PURE__ */ function() {
  function n() {
  }
  return function(t) {
    if (!Ve(t))
      return {};
    if (Ji)
      return Ji(t);
    n.prototype = t;
    var e = new n();
    return n.prototype = void 0, e;
  };
}();
function Ya(n, t, e) {
  switch (e.length) {
    case 0:
      return n.call(t);
    case 1:
      return n.call(t, e[0]);
    case 2:
      return n.call(t, e[0], e[1]);
    case 3:
      return n.call(t, e[0], e[1], e[2]);
  }
  return n.apply(t, e);
}
function Xa(n, t) {
  var e = -1, r = n.length;
  for (t || (t = Array(r)); ++e < r; )
    t[e] = n[e];
  return t;
}
var Ja = 800, Qa = 16, tc = Date.now;
function ec(n) {
  var t = 0, e = 0;
  return function() {
    var r = tc(), s = Qa - (r - e);
    if (e = r, s > 0) {
      if (++t >= Ja)
        return arguments[0];
    } else
      t = 0;
    return n.apply(void 0, arguments);
  };
}
function rc(n) {
  return function() {
    return n;
  };
}
var Jn = function() {
  try {
    var n = ur(Object, "defineProperty");
    return n({}, "", {}), n;
  } catch {
  }
}(), nc = Jn ? function(n, t) {
  return Jn(n, "toString", {
    configurable: !0,
    enumerable: !1,
    value: rc(t),
    writable: !0
  });
} : sl, sc = ec(nc);
function ic(n, t) {
  for (var e = -1, r = n == null ? 0 : n.length; ++e < r && t(n[e], e, n) !== !1; )
    ;
  return n;
}
var oc = 9007199254740991, lc = /^(?:0|[1-9]\d*)$/;
function il(n, t) {
  var e = typeof n;
  return t = t ?? oc, !!t && (e == "number" || e != "symbol" && lc.test(n)) && n > -1 && n % 1 == 0 && n < t;
}
function Ti(n, t, e) {
  t == "__proto__" && Jn ? Jn(n, t, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : n[t] = e;
}
function Sn(n, t) {
  return n === t || n !== n && t !== t;
}
var ac = Object.prototype, cc = ac.hasOwnProperty;
function ol(n, t, e) {
  var r = n[t];
  (!(cc.call(n, t) && Sn(r, e)) || e === void 0 && !(t in n)) && Ti(n, t, e);
}
function uc(n, t, e, r) {
  var s = !e;
  e || (e = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var a = t[i], c = void 0;
    c === void 0 && (c = n[a]), s ? Ti(e, a, c) : ol(e, a, c);
  }
  return e;
}
var Qi = Math.max;
function hc(n, t, e) {
  return t = Qi(t === void 0 ? n.length - 1 : t, 0), function() {
    for (var r = arguments, s = -1, i = Qi(r.length - t, 0), o = Array(i); ++s < i; )
      o[s] = r[t + s];
    s = -1;
    for (var a = Array(t + 1); ++s < t; )
      a[s] = r[s];
    return a[t] = e(o), Ya(n, this, a);
  };
}
function fc(n, t) {
  return sc(hc(n, t, sl), n + "");
}
var dc = 9007199254740991;
function ll(n) {
  return typeof n == "number" && n > -1 && n % 1 == 0 && n <= dc;
}
function ss(n) {
  return n != null && ll(n.length) && !Ai(n);
}
function gc(n, t, e) {
  if (!Ve(e))
    return !1;
  var r = typeof t;
  return (r == "number" ? ss(e) && il(t, e.length) : r == "string" && t in e) ? Sn(e[t], n) : !1;
}
function pc(n) {
  return fc(function(t, e) {
    var r = -1, s = e.length, i = s > 1 ? e[s - 1] : void 0, o = s > 2 ? e[2] : void 0;
    for (i = n.length > 3 && typeof i == "function" ? (s--, i) : void 0, o && gc(e[0], e[1], o) && (i = s < 3 ? void 0 : i, s = 1), t = Object(t); ++r < s; ) {
      var a = e[r];
      a && n(t, a, r, i);
    }
    return t;
  });
}
var mc = Object.prototype;
function xi(n) {
  var t = n && n.constructor, e = typeof t == "function" && t.prototype || mc;
  return n === e;
}
function bc(n, t) {
  for (var e = -1, r = Array(n); ++e < n; )
    r[e] = t(e);
  return r;
}
var yc = "[object Arguments]";
function to(n) {
  return ve(n) && Xr(n) == yc;
}
var al = Object.prototype, vc = al.hasOwnProperty, Ec = al.propertyIsEnumerable, Ys = to(/* @__PURE__ */ function() {
  return arguments;
}()) ? to : function(n) {
  return ve(n) && vc.call(n, "callee") && !Ec.call(n, "callee");
};
function wc() {
  return !1;
}
var cl = typeof exports == "object" && exports && !exports.nodeType && exports, eo = cl && typeof module == "object" && module && !module.nodeType && module, Ac = eo && eo.exports === cl, ro = Ac ? ae.Buffer : void 0, Tc = ro ? ro.isBuffer : void 0, bn = Tc || wc, xc = "[object Arguments]", Nc = "[object Array]", _c = "[object Boolean]", Sc = "[object Date]", Oc = "[object Error]", Lc = "[object Function]", Cc = "[object Map]", qc = "[object Number]", Rc = "[object Object]", Ic = "[object RegExp]", kc = "[object Set]", Mc = "[object String]", jc = "[object WeakMap]", Bc = "[object ArrayBuffer]", Pc = "[object DataView]", Dc = "[object Float32Array]", $c = "[object Float64Array]", Uc = "[object Int8Array]", Fc = "[object Int16Array]", Hc = "[object Int32Array]", zc = "[object Uint8Array]", Kc = "[object Uint8ClampedArray]", Vc = "[object Uint16Array]", Gc = "[object Uint32Array]", J = {};
J[Dc] = J[$c] = J[Uc] = J[Fc] = J[Hc] = J[zc] = J[Kc] = J[Vc] = J[Gc] = !0;
J[xc] = J[Nc] = J[Bc] = J[_c] = J[Pc] = J[Sc] = J[Oc] = J[Lc] = J[Cc] = J[qc] = J[Rc] = J[Ic] = J[kc] = J[Mc] = J[jc] = !1;
function Wc(n) {
  return ve(n) && ll(n.length) && !!J[Xr(n)];
}
function Ni(n) {
  return function(t) {
    return n(t);
  };
}
var ul = typeof exports == "object" && exports && !exports.nodeType && exports, dn = ul && typeof module == "object" && module && !module.nodeType && module, Zc = dn && dn.exports === ul, js = Zc && rl.process, Vr = function() {
  try {
    var n = dn && dn.require && dn.require("util").types;
    return n || js && js.binding && js.binding("util");
  } catch {
  }
}(), no = Vr && Vr.isTypedArray, _i = no ? Ni(no) : Wc, Yc = Object.prototype, Xc = Yc.hasOwnProperty;
function hl(n, t) {
  var e = or(n), r = !e && Ys(n), s = !e && !r && bn(n), i = !e && !r && !s && _i(n), o = e || r || s || i, a = o ? bc(n.length, String) : [], c = a.length;
  for (var h in n)
    (t || Xc.call(n, h)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (h == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (h == "offset" || h == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (h == "buffer" || h == "byteLength" || h == "byteOffset") || // Skip index properties.
    il(h, c))) && a.push(h);
  return a;
}
function fl(n, t) {
  return function(e) {
    return n(t(e));
  };
}
var Jc = fl(Object.keys, Object), Qc = Object.prototype, tu = Qc.hasOwnProperty;
function eu(n) {
  if (!xi(n))
    return Jc(n);
  var t = [];
  for (var e in Object(n))
    tu.call(n, e) && e != "constructor" && t.push(e);
  return t;
}
function ru(n) {
  return ss(n) ? hl(n) : eu(n);
}
function nu(n) {
  var t = [];
  if (n != null)
    for (var e in Object(n))
      t.push(e);
  return t;
}
var su = Object.prototype, iu = su.hasOwnProperty;
function ou(n) {
  if (!Ve(n))
    return nu(n);
  var t = xi(n), e = [];
  for (var r in n)
    r == "constructor" && (t || !iu.call(n, r)) || e.push(r);
  return e;
}
function dl(n) {
  return ss(n) ? hl(n, !0) : ou(n);
}
var yn = ur(Object, "create");
function lu() {
  this.__data__ = yn ? yn(null) : {}, this.size = 0;
}
function au(n) {
  var t = this.has(n) && delete this.__data__[n];
  return this.size -= t ? 1 : 0, t;
}
var cu = "__lodash_hash_undefined__", uu = Object.prototype, hu = uu.hasOwnProperty;
function fu(n) {
  var t = this.__data__;
  if (yn) {
    var e = t[n];
    return e === cu ? void 0 : e;
  }
  return hu.call(t, n) ? t[n] : void 0;
}
var du = Object.prototype, gu = du.hasOwnProperty;
function pu(n) {
  var t = this.__data__;
  return yn ? t[n] !== void 0 : gu.call(t, n);
}
var mu = "__lodash_hash_undefined__";
function bu(n, t) {
  var e = this.__data__;
  return this.size += this.has(n) ? 0 : 1, e[n] = yn && t === void 0 ? mu : t, this;
}
function lr(n) {
  var t = -1, e = n == null ? 0 : n.length;
  for (this.clear(); ++t < e; ) {
    var r = n[t];
    this.set(r[0], r[1]);
  }
}
lr.prototype.clear = lu;
lr.prototype.delete = au;
lr.prototype.get = fu;
lr.prototype.has = pu;
lr.prototype.set = bu;
function yu() {
  this.__data__ = [], this.size = 0;
}
function is(n, t) {
  for (var e = n.length; e--; )
    if (Sn(n[e][0], t))
      return e;
  return -1;
}
var vu = Array.prototype, Eu = vu.splice;
function wu(n) {
  var t = this.__data__, e = is(t, n);
  if (e < 0)
    return !1;
  var r = t.length - 1;
  return e == r ? t.pop() : Eu.call(t, e, 1), --this.size, !0;
}
function Au(n) {
  var t = this.__data__, e = is(t, n);
  return e < 0 ? void 0 : t[e][1];
}
function Tu(n) {
  return is(this.__data__, n) > -1;
}
function xu(n, t) {
  var e = this.__data__, r = is(e, n);
  return r < 0 ? (++this.size, e.push([n, t])) : e[r][1] = t, this;
}
function Ae(n) {
  var t = -1, e = n == null ? 0 : n.length;
  for (this.clear(); ++t < e; ) {
    var r = n[t];
    this.set(r[0], r[1]);
  }
}
Ae.prototype.clear = yu;
Ae.prototype.delete = wu;
Ae.prototype.get = Au;
Ae.prototype.has = Tu;
Ae.prototype.set = xu;
var vn = ur(ae, "Map");
function Nu() {
  this.size = 0, this.__data__ = {
    hash: new lr(),
    map: new (vn || Ae)(),
    string: new lr()
  };
}
function _u(n) {
  var t = typeof n;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
}
function os(n, t) {
  var e = n.__data__;
  return _u(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
function Su(n) {
  var t = os(this, n).delete(n);
  return this.size -= t ? 1 : 0, t;
}
function Ou(n) {
  return os(this, n).get(n);
}
function Lu(n) {
  return os(this, n).has(n);
}
function Cu(n, t) {
  var e = os(this, n), r = e.size;
  return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
}
function hr(n) {
  var t = -1, e = n == null ? 0 : n.length;
  for (this.clear(); ++t < e; ) {
    var r = n[t];
    this.set(r[0], r[1]);
  }
}
hr.prototype.clear = Nu;
hr.prototype.delete = Su;
hr.prototype.get = Ou;
hr.prototype.has = Lu;
hr.prototype.set = Cu;
function qu(n, t) {
  for (var e = -1, r = t.length, s = n.length; ++e < r; )
    n[s + e] = t[e];
  return n;
}
var gl = fl(Object.getPrototypeOf, Object), Ru = "[object Object]", Iu = Function.prototype, ku = Object.prototype, pl = Iu.toString, Mu = ku.hasOwnProperty, ju = pl.call(Object);
function Bu(n) {
  if (!ve(n) || Xr(n) != Ru)
    return !1;
  var t = gl(n);
  if (t === null)
    return !0;
  var e = Mu.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e instanceof e && pl.call(e) == ju;
}
function Pu() {
  this.__data__ = new Ae(), this.size = 0;
}
function Du(n) {
  var t = this.__data__, e = t.delete(n);
  return this.size = t.size, e;
}
function $u(n) {
  return this.__data__.get(n);
}
function Uu(n) {
  return this.__data__.has(n);
}
var Fu = 200;
function Hu(n, t) {
  var e = this.__data__;
  if (e instanceof Ae) {
    var r = e.__data__;
    if (!vn || r.length < Fu - 1)
      return r.push([n, t]), this.size = ++e.size, this;
    e = this.__data__ = new hr(r);
  }
  return e.set(n, t), this.size = e.size, this;
}
function se(n) {
  var t = this.__data__ = new Ae(n);
  this.size = t.size;
}
se.prototype.clear = Pu;
se.prototype.delete = Du;
se.prototype.get = $u;
se.prototype.has = Uu;
se.prototype.set = Hu;
var ml = typeof exports == "object" && exports && !exports.nodeType && exports, so = ml && typeof module == "object" && module && !module.nodeType && module, zu = so && so.exports === ml, io = zu ? ae.Buffer : void 0, oo = io ? io.allocUnsafe : void 0;
function bl(n, t) {
  if (t)
    return n.slice();
  var e = n.length, r = oo ? oo(e) : new n.constructor(e);
  return n.copy(r), r;
}
function Ku(n, t) {
  for (var e = -1, r = n == null ? 0 : n.length, s = 0, i = []; ++e < r; ) {
    var o = n[e];
    t(o, e, n) && (i[s++] = o);
  }
  return i;
}
function Vu() {
  return [];
}
var Gu = Object.prototype, Wu = Gu.propertyIsEnumerable, lo = Object.getOwnPropertySymbols, Zu = lo ? function(n) {
  return n == null ? [] : (n = Object(n), Ku(lo(n), function(t) {
    return Wu.call(n, t);
  }));
} : Vu;
function Yu(n, t, e) {
  var r = t(n);
  return or(n) ? r : qu(r, e(n));
}
function Xs(n) {
  return Yu(n, ru, Zu);
}
var Js = ur(ae, "DataView"), Qs = ur(ae, "Promise"), ti = ur(ae, "Set"), ao = "[object Map]", Xu = "[object Object]", co = "[object Promise]", uo = "[object Set]", ho = "[object WeakMap]", fo = "[object DataView]", Ju = cr(Js), Qu = cr(vn), th = cr(Qs), eh = cr(ti), rh = cr(Zs), Ft = Xr;
(Js && Ft(new Js(new ArrayBuffer(1))) != fo || vn && Ft(new vn()) != ao || Qs && Ft(Qs.resolve()) != co || ti && Ft(new ti()) != uo || Zs && Ft(new Zs()) != ho) && (Ft = function(n) {
  var t = Xr(n), e = t == Xu ? n.constructor : void 0, r = e ? cr(e) : "";
  if (r)
    switch (r) {
      case Ju:
        return fo;
      case Qu:
        return ao;
      case th:
        return co;
      case eh:
        return uo;
      case rh:
        return ho;
    }
  return t;
});
var nh = Object.prototype, sh = nh.hasOwnProperty;
function ih(n) {
  var t = n.length, e = new n.constructor(t);
  return t && typeof n[0] == "string" && sh.call(n, "index") && (e.index = n.index, e.input = n.input), e;
}
var Qn = ae.Uint8Array;
function Si(n) {
  var t = new n.constructor(n.byteLength);
  return new Qn(t).set(new Qn(n)), t;
}
function oh(n, t) {
  var e = Si(n.buffer);
  return new n.constructor(e, n.byteOffset, n.byteLength);
}
var lh = /\w*$/;
function ah(n) {
  var t = new n.constructor(n.source, lh.exec(n));
  return t.lastIndex = n.lastIndex, t;
}
var go = Ke ? Ke.prototype : void 0, po = go ? go.valueOf : void 0;
function ch(n) {
  return po ? Object(po.call(n)) : {};
}
function yl(n, t) {
  var e = t ? Si(n.buffer) : n.buffer;
  return new n.constructor(e, n.byteOffset, n.length);
}
var uh = "[object Boolean]", hh = "[object Date]", fh = "[object Map]", dh = "[object Number]", gh = "[object RegExp]", ph = "[object Set]", mh = "[object String]", bh = "[object Symbol]", yh = "[object ArrayBuffer]", vh = "[object DataView]", Eh = "[object Float32Array]", wh = "[object Float64Array]", Ah = "[object Int8Array]", Th = "[object Int16Array]", xh = "[object Int32Array]", Nh = "[object Uint8Array]", _h = "[object Uint8ClampedArray]", Sh = "[object Uint16Array]", Oh = "[object Uint32Array]";
function Lh(n, t, e) {
  var r = n.constructor;
  switch (t) {
    case yh:
      return Si(n);
    case uh:
    case hh:
      return new r(+n);
    case vh:
      return oh(n);
    case Eh:
    case wh:
    case Ah:
    case Th:
    case xh:
    case Nh:
    case _h:
    case Sh:
    case Oh:
      return yl(n, e);
    case fh:
      return new r();
    case dh:
    case mh:
      return new r(n);
    case gh:
      return ah(n);
    case ph:
      return new r();
    case bh:
      return ch(n);
  }
}
function vl(n) {
  return typeof n.constructor == "function" && !xi(n) ? Za(gl(n)) : {};
}
var Ch = "[object Map]";
function qh(n) {
  return ve(n) && Ft(n) == Ch;
}
var mo = Vr && Vr.isMap, Rh = mo ? Ni(mo) : qh, Ih = "[object Set]";
function kh(n) {
  return ve(n) && Ft(n) == Ih;
}
var bo = Vr && Vr.isSet, Mh = bo ? Ni(bo) : kh, jh = 1, El = "[object Arguments]", Bh = "[object Array]", Ph = "[object Boolean]", Dh = "[object Date]", $h = "[object Error]", wl = "[object Function]", Uh = "[object GeneratorFunction]", Fh = "[object Map]", Hh = "[object Number]", Al = "[object Object]", zh = "[object RegExp]", Kh = "[object Set]", Vh = "[object String]", Gh = "[object Symbol]", Wh = "[object WeakMap]", Zh = "[object ArrayBuffer]", Yh = "[object DataView]", Xh = "[object Float32Array]", Jh = "[object Float64Array]", Qh = "[object Int8Array]", tf = "[object Int16Array]", ef = "[object Int32Array]", rf = "[object Uint8Array]", nf = "[object Uint8ClampedArray]", sf = "[object Uint16Array]", of = "[object Uint32Array]", Y = {};
Y[El] = Y[Bh] = Y[Zh] = Y[Yh] = Y[Ph] = Y[Dh] = Y[Xh] = Y[Jh] = Y[Qh] = Y[tf] = Y[ef] = Y[Fh] = Y[Hh] = Y[Al] = Y[zh] = Y[Kh] = Y[Vh] = Y[Gh] = Y[rf] = Y[nf] = Y[sf] = Y[of] = !0;
Y[$h] = Y[wl] = Y[Wh] = !1;
function Zn(n, t, e, r, s, i) {
  var o, a = t & jh;
  if (o !== void 0)
    return o;
  if (!Ve(n))
    return n;
  var c = or(n);
  if (c)
    o = ih(n);
  else {
    var h = Ft(n), f = h == wl || h == Uh;
    if (bn(n))
      return bl(n, a);
    if (h == Al || h == El || f && !s)
      o = f ? {} : vl(n);
    else {
      if (!Y[h])
        return s ? n : {};
      o = Lh(n, h, a);
    }
  }
  i || (i = new se());
  var b = i.get(n);
  if (b)
    return b;
  i.set(n, o), Mh(n) ? n.forEach(function(y) {
    o.add(Zn(y, t, e, y, n, i));
  }) : Rh(n) && n.forEach(function(y, v) {
    o.set(v, Zn(y, t, e, v, n, i));
  });
  var d = Xs, m = c ? void 0 : d(n);
  return ic(m || n, function(y, v) {
    m && (v = y, y = n[v]), ol(o, v, Zn(y, t, e, v, n, i));
  }), o;
}
var lf = 1, af = 4;
function Hr(n) {
  return Zn(n, lf | af);
}
var cf = "__lodash_hash_undefined__";
function uf(n) {
  return this.__data__.set(n, cf), this;
}
function hf(n) {
  return this.__data__.has(n);
}
function ts(n) {
  var t = -1, e = n == null ? 0 : n.length;
  for (this.__data__ = new hr(); ++t < e; )
    this.add(n[t]);
}
ts.prototype.add = ts.prototype.push = uf;
ts.prototype.has = hf;
function ff(n, t) {
  for (var e = -1, r = n == null ? 0 : n.length; ++e < r; )
    if (t(n[e], e, n))
      return !0;
  return !1;
}
function df(n, t) {
  return n.has(t);
}
var gf = 1, pf = 2;
function Tl(n, t, e, r, s, i) {
  var o = e & gf, a = n.length, c = t.length;
  if (a != c && !(o && c > a))
    return !1;
  var h = i.get(n), f = i.get(t);
  if (h && f)
    return h == t && f == n;
  var b = -1, d = !0, m = e & pf ? new ts() : void 0;
  for (i.set(n, t), i.set(t, n); ++b < a; ) {
    var y = n[b], v = t[b];
    if (r)
      var w = o ? r(v, y, b, t, n, i) : r(y, v, b, n, t, i);
    if (w !== void 0) {
      if (w)
        continue;
      d = !1;
      break;
    }
    if (m) {
      if (!ff(t, function(E, x) {
        if (!df(m, x) && (y === E || s(y, E, e, r, i)))
          return m.push(x);
      })) {
        d = !1;
        break;
      }
    } else if (!(y === v || s(y, v, e, r, i))) {
      d = !1;
      break;
    }
  }
  return i.delete(n), i.delete(t), d;
}
function mf(n) {
  var t = -1, e = Array(n.size);
  return n.forEach(function(r, s) {
    e[++t] = [s, r];
  }), e;
}
function bf(n) {
  var t = -1, e = Array(n.size);
  return n.forEach(function(r) {
    e[++t] = r;
  }), e;
}
var yf = 1, vf = 2, Ef = "[object Boolean]", wf = "[object Date]", Af = "[object Error]", Tf = "[object Map]", xf = "[object Number]", Nf = "[object RegExp]", _f = "[object Set]", Sf = "[object String]", Of = "[object Symbol]", Lf = "[object ArrayBuffer]", Cf = "[object DataView]", yo = Ke ? Ke.prototype : void 0, Bs = yo ? yo.valueOf : void 0;
function qf(n, t, e, r, s, i, o) {
  switch (e) {
    case Cf:
      if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset)
        return !1;
      n = n.buffer, t = t.buffer;
    case Lf:
      return !(n.byteLength != t.byteLength || !i(new Qn(n), new Qn(t)));
    case Ef:
    case wf:
    case xf:
      return Sn(+n, +t);
    case Af:
      return n.name == t.name && n.message == t.message;
    case Nf:
    case Sf:
      return n == t + "";
    case Tf:
      var a = mf;
    case _f:
      var c = r & yf;
      if (a || (a = bf), n.size != t.size && !c)
        return !1;
      var h = o.get(n);
      if (h)
        return h == t;
      r |= vf, o.set(n, t);
      var f = Tl(a(n), a(t), r, s, i, o);
      return o.delete(n), f;
    case Of:
      if (Bs)
        return Bs.call(n) == Bs.call(t);
  }
  return !1;
}
var Rf = 1, If = Object.prototype, kf = If.hasOwnProperty;
function Mf(n, t, e, r, s, i) {
  var o = e & Rf, a = Xs(n), c = a.length, h = Xs(t), f = h.length;
  if (c != f && !o)
    return !1;
  for (var b = c; b--; ) {
    var d = a[b];
    if (!(o ? d in t : kf.call(t, d)))
      return !1;
  }
  var m = i.get(n), y = i.get(t);
  if (m && y)
    return m == t && y == n;
  var v = !0;
  i.set(n, t), i.set(t, n);
  for (var w = o; ++b < c; ) {
    d = a[b];
    var E = n[d], x = t[d];
    if (r)
      var _ = o ? r(x, E, d, t, n, i) : r(E, x, d, n, t, i);
    if (!(_ === void 0 ? E === x || s(E, x, e, r, i) : _)) {
      v = !1;
      break;
    }
    w || (w = d == "constructor");
  }
  if (v && !w) {
    var C = n.constructor, O = t.constructor;
    C != O && "constructor" in n && "constructor" in t && !(typeof C == "function" && C instanceof C && typeof O == "function" && O instanceof O) && (v = !1);
  }
  return i.delete(n), i.delete(t), v;
}
var jf = 1, vo = "[object Arguments]", Eo = "[object Array]", Hn = "[object Object]", Bf = Object.prototype, wo = Bf.hasOwnProperty;
function Pf(n, t, e, r, s, i) {
  var o = or(n), a = or(t), c = o ? Eo : Ft(n), h = a ? Eo : Ft(t);
  c = c == vo ? Hn : c, h = h == vo ? Hn : h;
  var f = c == Hn, b = h == Hn, d = c == h;
  if (d && bn(n)) {
    if (!bn(t))
      return !1;
    o = !0, f = !1;
  }
  if (d && !f)
    return i || (i = new se()), o || _i(n) ? Tl(n, t, e, r, s, i) : qf(n, t, c, e, r, s, i);
  if (!(e & jf)) {
    var m = f && wo.call(n, "__wrapped__"), y = b && wo.call(t, "__wrapped__");
    if (m || y) {
      var v = m ? n.value() : n, w = y ? t.value() : t;
      return i || (i = new se()), s(v, w, e, r, i);
    }
  }
  return d ? (i || (i = new se()), Mf(n, t, e, r, s, i)) : !1;
}
function xl(n, t, e, r, s) {
  return n === t ? !0 : n == null || t == null || !ve(n) && !ve(t) ? n !== n && t !== t : Pf(n, t, e, r, xl, s);
}
function Df(n) {
  return function(t, e, r) {
    for (var s = -1, i = Object(t), o = r(t), a = o.length; a--; ) {
      var c = o[++s];
      if (e(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var $f = Df();
function ei(n, t, e) {
  (e !== void 0 && !Sn(n[t], e) || e === void 0 && !(t in n)) && Ti(n, t, e);
}
function Uf(n) {
  return ve(n) && ss(n);
}
function ri(n, t) {
  if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__")
    return n[t];
}
function Ff(n) {
  return uc(n, dl(n));
}
function Hf(n, t, e, r, s, i, o) {
  var a = ri(n, e), c = ri(t, e), h = o.get(c);
  if (h) {
    ei(n, e, h);
    return;
  }
  var f = i ? i(a, c, e + "", n, t, o) : void 0, b = f === void 0;
  if (b) {
    var d = or(c), m = !d && bn(c), y = !d && !m && _i(c);
    f = c, d || m || y ? or(a) ? f = a : Uf(a) ? f = Xa(a) : m ? (b = !1, f = bl(c, !0)) : y ? (b = !1, f = yl(c, !0)) : f = [] : Bu(c) || Ys(c) ? (f = a, Ys(a) ? f = Ff(a) : (!Ve(a) || Ai(a)) && (f = vl(c))) : b = !1;
  }
  b && (o.set(c, f), s(f, c, r, i, o), o.delete(c)), ei(n, e, f);
}
function Nl(n, t, e, r, s) {
  n !== t && $f(t, function(i, o) {
    if (s || (s = new se()), Ve(i))
      Hf(n, t, o, e, Nl, r, s);
    else {
      var a = r ? r(ri(n, o), i, o + "", n, t, s) : void 0;
      a === void 0 && (a = i), ei(n, o, a);
    }
  }, dl);
}
function $e(n, t) {
  return xl(n, t);
}
var ze = pc(function(n, t, e) {
  Nl(n, t, e);
}), I = /* @__PURE__ */ ((n) => (n[n.TYPE = 3] = "TYPE", n[n.LEVEL = 12] = "LEVEL", n[n.ATTRIBUTE = 13] = "ATTRIBUTE", n[n.BLOT = 14] = "BLOT", n[n.INLINE = 7] = "INLINE", n[n.BLOCK = 11] = "BLOCK", n[n.BLOCK_BLOT = 10] = "BLOCK_BLOT", n[n.INLINE_BLOT = 6] = "INLINE_BLOT", n[n.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", n[n.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", n[n.ANY = 15] = "ANY", n))(I || {});
class oe {
  constructor(t, e, r = {}) {
    this.attrName = t, this.keyName = e;
    const s = I.TYPE & I.ATTRIBUTE;
    this.scope = r.scope != null ? (
      // Ignore type bits, force attribute bit
      r.scope & I.LEVEL | s
    ) : I.ATTRIBUTE, r.whitelist != null && (this.whitelist = r.whitelist);
  }
  static keys(t) {
    return Array.from(t.attributes).map((e) => e.name);
  }
  add(t, e) {
    return this.canAdd(t, e) ? (t.setAttribute(this.keyName, e), !0) : !1;
  }
  canAdd(t, e) {
    return this.whitelist == null ? !0 : typeof e == "string" ? this.whitelist.indexOf(e.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(e) > -1;
  }
  remove(t) {
    t.removeAttribute(this.keyName);
  }
  value(t) {
    const e = t.getAttribute(this.keyName);
    return this.canAdd(t, e) && e ? e : "";
  }
}
class zr extends Error {
  constructor(t) {
    t = "[Parchment] " + t, super(t), this.message = t, this.name = this.constructor.name;
  }
}
const _l = class ni {
  constructor() {
    this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
  }
  static find(t, e = !1) {
    if (t == null)
      return null;
    if (this.blots.has(t))
      return this.blots.get(t) || null;
    if (e) {
      let r = null;
      try {
        r = t.parentNode;
      } catch {
        return null;
      }
      return this.find(r, e);
    }
    return null;
  }
  create(t, e, r) {
    const s = this.query(e);
    if (s == null)
      throw new zr(`Unable to create ${e} blot`);
    const i = s, o = (
      // @ts-expect-error Fix me later
      e instanceof Node || e.nodeType === Node.TEXT_NODE ? e : i.create(r)
    ), a = new i(t, o, r);
    return ni.blots.set(a.domNode, a), a;
  }
  find(t, e = !1) {
    return ni.find(t, e);
  }
  query(t, e = I.ANY) {
    let r;
    return typeof t == "string" ? r = this.types[t] || this.attributes[t] : t instanceof Text || t.nodeType === Node.TEXT_NODE ? r = this.types.text : typeof t == "number" ? t & I.LEVEL & I.BLOCK ? r = this.types.block : t & I.LEVEL & I.INLINE && (r = this.types.inline) : t instanceof Element && ((t.getAttribute("class") || "").split(/\s+/).some((s) => (r = this.classes[s], !!r)), r = r || this.tags[t.tagName]), r == null ? null : "scope" in r && e & I.LEVEL & r.scope && e & I.TYPE & r.scope ? r : null;
  }
  register(...t) {
    return t.map((e) => {
      const r = "blotName" in e, s = "attrName" in e;
      if (!r && !s)
        throw new zr("Invalid definition");
      if (r && e.blotName === "abstract")
        throw new zr("Cannot register abstract class");
      const i = r ? e.blotName : s ? e.attrName : void 0;
      return this.types[i] = e, s ? typeof e.keyName == "string" && (this.attributes[e.keyName] = e) : r && (e.className && (this.classes[e.className] = e), e.tagName && (Array.isArray(e.tagName) ? e.tagName = e.tagName.map((o) => o.toUpperCase()) : e.tagName = e.tagName.toUpperCase(), (Array.isArray(e.tagName) ? e.tagName : [e.tagName]).forEach((o) => {
        (this.tags[o] == null || e.className == null) && (this.tags[o] = e);
      }))), e;
    });
  }
};
_l.blots = /* @__PURE__ */ new WeakMap();
let Gr = _l;
function Ao(n, t) {
  return (n.getAttribute("class") || "").split(/\s+/).filter((e) => e.indexOf(`${t}-`) === 0);
}
class zf extends oe {
  static keys(t) {
    return (t.getAttribute("class") || "").split(/\s+/).map((e) => e.split("-").slice(0, -1).join("-"));
  }
  add(t, e) {
    return this.canAdd(t, e) ? (this.remove(t), t.classList.add(`${this.keyName}-${e}`), !0) : !1;
  }
  remove(t) {
    Ao(t, this.keyName).forEach((e) => {
      t.classList.remove(e);
    }), t.classList.length === 0 && t.removeAttribute("class");
  }
  value(t) {
    const e = (Ao(t, this.keyName)[0] || "").slice(this.keyName.length + 1);
    return this.canAdd(t, e) ? e : "";
  }
}
const Vt = zf;
function Ps(n) {
  const t = n.split("-"), e = t.slice(1).map((r) => r[0].toUpperCase() + r.slice(1)).join("");
  return t[0] + e;
}
class Kf extends oe {
  static keys(t) {
    return (t.getAttribute("style") || "").split(";").map((e) => e.split(":")[0].trim());
  }
  add(t, e) {
    return this.canAdd(t, e) ? (t.style[Ps(this.keyName)] = e, !0) : !1;
  }
  remove(t) {
    t.style[Ps(this.keyName)] = "", t.getAttribute("style") || t.removeAttribute("style");
  }
  value(t) {
    const e = t.style[Ps(this.keyName)];
    return this.canAdd(t, e) ? e : "";
  }
}
const Ge = Kf;
class Vf {
  constructor(t) {
    this.attributes = {}, this.domNode = t, this.build();
  }
  attribute(t, e) {
    e ? t.add(this.domNode, e) && (t.value(this.domNode) != null ? this.attributes[t.attrName] = t : delete this.attributes[t.attrName]) : (t.remove(this.domNode), delete this.attributes[t.attrName]);
  }
  build() {
    this.attributes = {};
    const t = Gr.find(this.domNode);
    if (t == null)
      return;
    const e = oe.keys(this.domNode), r = Vt.keys(this.domNode), s = Ge.keys(this.domNode);
    e.concat(r).concat(s).forEach((i) => {
      const o = t.scroll.query(i, I.ATTRIBUTE);
      o instanceof oe && (this.attributes[o.attrName] = o);
    });
  }
  copy(t) {
    Object.keys(this.attributes).forEach((e) => {
      const r = this.attributes[e].value(this.domNode);
      t.format(e, r);
    });
  }
  move(t) {
    this.copy(t), Object.keys(this.attributes).forEach((e) => {
      this.attributes[e].remove(this.domNode);
    }), this.attributes = {};
  }
  values() {
    return Object.keys(this.attributes).reduce(
      (t, e) => (t[e] = this.attributes[e].value(this.domNode), t),
      {}
    );
  }
}
const ls = Vf, Sl = class {
  constructor(t, e) {
    this.scroll = t, this.domNode = e, Gr.blots.set(e, this), this.prev = null, this.next = null;
  }
  static create(t) {
    if (this.tagName == null)
      throw new zr("Blot definition missing tagName");
    let e, r;
    return Array.isArray(this.tagName) ? (typeof t == "string" ? (r = t.toUpperCase(), parseInt(r, 10).toString() === r && (r = parseInt(r, 10))) : typeof t == "number" && (r = t), typeof r == "number" ? e = document.createElement(this.tagName[r - 1]) : r && this.tagName.indexOf(r) > -1 ? e = document.createElement(r) : e = document.createElement(this.tagName[0])) : e = document.createElement(this.tagName), this.className && e.classList.add(this.className), e;
  }
  // Hack for accessing inherited static methods
  get statics() {
    return this.constructor;
  }
  attach() {
  }
  clone() {
    const t = this.domNode.cloneNode(!1);
    return this.scroll.create(t);
  }
  detach() {
    this.parent != null && this.parent.removeChild(this), Gr.blots.delete(this.domNode);
  }
  deleteAt(t, e) {
    this.isolate(t, e).remove();
  }
  formatAt(t, e, r, s) {
    const i = this.isolate(t, e);
    if (this.scroll.query(r, I.BLOT) != null && s)
      i.wrap(r, s);
    else if (this.scroll.query(r, I.ATTRIBUTE) != null) {
      const o = this.scroll.create(this.statics.scope);
      i.wrap(o), o.format(r, s);
    }
  }
  insertAt(t, e, r) {
    const s = r == null ? this.scroll.create("text", e) : this.scroll.create(e, r), i = this.split(t);
    this.parent.insertBefore(s, i || void 0);
  }
  isolate(t, e) {
    const r = this.split(t);
    if (r == null)
      throw new Error("Attempt to isolate at end");
    return r.split(e), r;
  }
  length() {
    return 1;
  }
  offset(t = this.parent) {
    return this.parent == null || this === t ? 0 : this.parent.children.offset(this) + this.parent.offset(t);
  }
  optimize(t) {
    this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
  }
  remove() {
    this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
  }
  replaceWith(t, e) {
    const r = typeof t == "string" ? this.scroll.create(t, e) : t;
    return this.parent != null && (this.parent.insertBefore(r, this.next || void 0), this.remove()), r;
  }
  split(t, e) {
    return t === 0 ? this : this.next;
  }
  update(t, e) {
  }
  wrap(t, e) {
    const r = typeof t == "string" ? this.scroll.create(t, e) : t;
    if (this.parent != null && this.parent.insertBefore(r, this.next || void 0), typeof r.appendChild != "function")
      throw new zr(`Cannot wrap ${t}`);
    return r.appendChild(this), r;
  }
};
Sl.blotName = "abstract";
let Ol = Sl;
const Ll = class extends Ol {
  /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */
  static value(t) {
    return !0;
  }
  /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */
  index(t, e) {
    return this.domNode === t || this.domNode.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(e, 1) : -1;
  }
  /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */
  position(t, e) {
    let r = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
    return t > 0 && (r += 1), [this.parent.domNode, r];
  }
  /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */
  value() {
    return {
      [this.statics.blotName]: this.statics.value(this.domNode) || !0
    };
  }
};
Ll.scope = I.INLINE_BLOT;
let Gf = Ll;
const ft = Gf;
class Wf {
  constructor() {
    this.head = null, this.tail = null, this.length = 0;
  }
  append(...t) {
    if (this.insertBefore(t[0], null), t.length > 1) {
      const e = t.slice(1);
      this.append(...e);
    }
  }
  at(t) {
    const e = this.iterator();
    let r = e();
    for (; r && t > 0; )
      t -= 1, r = e();
    return r;
  }
  contains(t) {
    const e = this.iterator();
    let r = e();
    for (; r; ) {
      if (r === t)
        return !0;
      r = e();
    }
    return !1;
  }
  indexOf(t) {
    const e = this.iterator();
    let r = e(), s = 0;
    for (; r; ) {
      if (r === t)
        return s;
      s += 1, r = e();
    }
    return -1;
  }
  insertBefore(t, e) {
    t != null && (this.remove(t), t.next = e, e != null ? (t.prev = e.prev, e.prev != null && (e.prev.next = t), e.prev = t, e === this.head && (this.head = t)) : this.tail != null ? (this.tail.next = t, t.prev = this.tail, this.tail = t) : (t.prev = null, this.head = this.tail = t), this.length += 1);
  }
  offset(t) {
    let e = 0, r = this.head;
    for (; r != null; ) {
      if (r === t)
        return e;
      e += r.length(), r = r.next;
    }
    return -1;
  }
  remove(t) {
    this.contains(t) && (t.prev != null && (t.prev.next = t.next), t.next != null && (t.next.prev = t.prev), t === this.head && (this.head = t.next), t === this.tail && (this.tail = t.prev), this.length -= 1);
  }
  iterator(t = this.head) {
    return () => {
      const e = t;
      return t != null && (t = t.next), e;
    };
  }
  find(t, e = !1) {
    const r = this.iterator();
    let s = r();
    for (; s; ) {
      const i = s.length();
      if (t < i || e && t === i && (s.next == null || s.next.length() !== 0))
        return [s, t];
      t -= i, s = r();
    }
    return [null, 0];
  }
  forEach(t) {
    const e = this.iterator();
    let r = e();
    for (; r; )
      t(r), r = e();
  }
  forEachAt(t, e, r) {
    if (e <= 0)
      return;
    const [s, i] = this.find(t);
    let o = t - i;
    const a = this.iterator(s);
    let c = a();
    for (; c && o < t + e; ) {
      const h = c.length();
      t > o ? r(
        c,
        t - o,
        Math.min(e, o + h - t)
      ) : r(c, 0, Math.min(h, t + e - o)), o += h, c = a();
    }
  }
  map(t) {
    return this.reduce((e, r) => (e.push(t(r)), e), []);
  }
  reduce(t, e) {
    const r = this.iterator();
    let s = r();
    for (; s; )
      e = t(e, s), s = r();
    return e;
  }
}
function To(n, t) {
  const e = t.find(n);
  if (e)
    return e;
  try {
    return t.create(n);
  } catch {
    const r = t.create(I.INLINE);
    return Array.from(n.childNodes).forEach((s) => {
      r.domNode.appendChild(s);
    }), n.parentNode && n.parentNode.replaceChild(r.domNode, n), r.attach(), r;
  }
}
const Cl = class De extends Ol {
  constructor(t, e) {
    super(t, e), this.uiNode = null, this.build();
  }
  appendChild(t) {
    this.insertBefore(t);
  }
  attach() {
    super.attach(), this.children.forEach((t) => {
      t.attach();
    });
  }
  attachUI(t) {
    this.uiNode != null && this.uiNode.remove(), this.uiNode = t, De.uiClass && this.uiNode.classList.add(De.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
  }
  /**
   * Called during construction, should fill its own children LinkedList.
   */
  build() {
    this.children = new Wf(), Array.from(this.domNode.childNodes).filter((t) => t !== this.uiNode).reverse().forEach((t) => {
      try {
        const e = To(t, this.scroll);
        this.insertBefore(e, this.children.head || void 0);
      } catch (e) {
        if (e instanceof zr)
          return;
        throw e;
      }
    });
  }
  deleteAt(t, e) {
    if (t === 0 && e === this.length())
      return this.remove();
    this.children.forEachAt(t, e, (r, s, i) => {
      r.deleteAt(s, i);
    });
  }
  descendant(t, e = 0) {
    const [r, s] = this.children.find(e);
    return t.blotName == null && t(r) || t.blotName != null && r instanceof t ? [r, s] : r instanceof De ? r.descendant(t, s) : [null, -1];
  }
  descendants(t, e = 0, r = Number.MAX_VALUE) {
    let s = [], i = r;
    return this.children.forEachAt(
      e,
      r,
      (o, a, c) => {
        (t.blotName == null && t(o) || t.blotName != null && o instanceof t) && s.push(o), o instanceof De && (s = s.concat(
          o.descendants(t, a, i)
        )), i -= c;
      }
    ), s;
  }
  detach() {
    this.children.forEach((t) => {
      t.detach();
    }), super.detach();
  }
  enforceAllowedChildren() {
    let t = !1;
    this.children.forEach((e) => {
      t || this.statics.allowedChildren.some(
        (r) => e instanceof r
      ) || (e.statics.scope === I.BLOCK_BLOT ? (e.next != null && this.splitAfter(e), e.prev != null && this.splitAfter(e.prev), e.parent.unwrap(), t = !0) : e instanceof De ? e.unwrap() : e.remove());
    });
  }
  formatAt(t, e, r, s) {
    this.children.forEachAt(t, e, (i, o, a) => {
      i.formatAt(o, a, r, s);
    });
  }
  insertAt(t, e, r) {
    const [s, i] = this.children.find(t);
    if (s)
      s.insertAt(i, e, r);
    else {
      const o = r == null ? this.scroll.create("text", e) : this.scroll.create(e, r);
      this.appendChild(o);
    }
  }
  insertBefore(t, e) {
    t.parent != null && t.parent.children.remove(t);
    let r = null;
    this.children.insertBefore(t, e || null), t.parent = this, e != null && (r = e.domNode), (this.domNode.parentNode !== t.domNode || this.domNode.nextSibling !== r) && this.domNode.insertBefore(t.domNode, r), t.attach();
  }
  length() {
    return this.children.reduce((t, e) => t + e.length(), 0);
  }
  moveChildren(t, e) {
    this.children.forEach((r) => {
      t.insertBefore(r, e);
    });
  }
  optimize(t) {
    if (super.optimize(t), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0)
      if (this.statics.defaultChild != null) {
        const e = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(e);
      } else
        this.remove();
  }
  path(t, e = !1) {
    const [r, s] = this.children.find(t, e), i = [[this, t]];
    return r instanceof De ? i.concat(r.path(s, e)) : (r != null && i.push([r, s]), i);
  }
  removeChild(t) {
    this.children.remove(t);
  }
  replaceWith(t, e) {
    const r = typeof t == "string" ? this.scroll.create(t, e) : t;
    return r instanceof De && this.moveChildren(r), super.replaceWith(r);
  }
  split(t, e = !1) {
    if (!e) {
      if (t === 0)
        return this;
      if (t === this.length())
        return this.next;
    }
    const r = this.clone();
    return this.parent && this.parent.insertBefore(r, this.next || void 0), this.children.forEachAt(t, this.length(), (s, i, o) => {
      const a = s.split(i, e);
      a != null && r.appendChild(a);
    }), r;
  }
  splitAfter(t) {
    const e = this.clone();
    for (; t.next != null; )
      e.appendChild(t.next);
    return this.parent && this.parent.insertBefore(e, this.next || void 0), e;
  }
  unwrap() {
    this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
  }
  update(t, e) {
    const r = [], s = [];
    t.forEach((i) => {
      i.target === this.domNode && i.type === "childList" && (r.push(...i.addedNodes), s.push(...i.removedNodes));
    }), s.forEach((i) => {
      if (i.parentNode != null && // @ts-expect-error Fix me later
      i.tagName !== "IFRAME" && document.body.compareDocumentPosition(i) & Node.DOCUMENT_POSITION_CONTAINED_BY)
        return;
      const o = this.scroll.find(i);
      o != null && (o.domNode.parentNode == null || o.domNode.parentNode === this.domNode) && o.detach();
    }), r.filter((i) => i.parentNode === this.domNode && i !== this.uiNode).sort((i, o) => i === o ? 0 : i.compareDocumentPosition(o) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((i) => {
      let o = null;
      i.nextSibling != null && (o = this.scroll.find(i.nextSibling));
      const a = To(i, this.scroll);
      (a.next !== o || a.next == null) && (a.parent != null && a.parent.removeChild(this), this.insertBefore(a, o || void 0));
    }), this.enforceAllowedChildren();
  }
};
Cl.uiClass = "";
let Zf = Cl;
const zt = Zf;
function Yf(n, t) {
  if (Object.keys(n).length !== Object.keys(t).length)
    return !1;
  for (const e in n)
    if (n[e] !== t[e])
      return !1;
  return !0;
}
const Br = class Pr extends zt {
  static create(t) {
    return super.create(t);
  }
  static formats(t, e) {
    const r = e.query(Pr.blotName);
    if (!(r != null && t.tagName === r.tagName)) {
      if (typeof this.tagName == "string")
        return !0;
      if (Array.isArray(this.tagName))
        return t.tagName.toLowerCase();
    }
  }
  constructor(t, e) {
    super(t, e), this.attributes = new ls(this.domNode);
  }
  format(t, e) {
    if (t === this.statics.blotName && !e)
      this.children.forEach((r) => {
        r instanceof Pr || (r = r.wrap(Pr.blotName, !0)), this.attributes.copy(r);
      }), this.unwrap();
    else {
      const r = this.scroll.query(t, I.INLINE);
      if (r == null)
        return;
      r instanceof oe ? this.attributes.attribute(r, e) : e && (t !== this.statics.blotName || this.formats()[t] !== e) && this.replaceWith(t, e);
    }
  }
  formats() {
    const t = this.attributes.values(), e = this.statics.formats(this.domNode, this.scroll);
    return e != null && (t[this.statics.blotName] = e), t;
  }
  formatAt(t, e, r, s) {
    this.formats()[r] != null || this.scroll.query(r, I.ATTRIBUTE) ? this.isolate(t, e).format(r, s) : super.formatAt(t, e, r, s);
  }
  optimize(t) {
    super.optimize(t);
    const e = this.formats();
    if (Object.keys(e).length === 0)
      return this.unwrap();
    const r = this.next;
    r instanceof Pr && r.prev === this && Yf(e, r.formats()) && (r.moveChildren(this), r.remove());
  }
  replaceWith(t, e) {
    const r = super.replaceWith(t, e);
    return this.attributes.copy(r), r;
  }
  update(t, e) {
    super.update(t, e), t.some(
      (r) => r.target === this.domNode && r.type === "attributes"
    ) && this.attributes.build();
  }
  wrap(t, e) {
    const r = super.wrap(t, e);
    return r instanceof Pr && this.attributes.move(r), r;
  }
};
Br.allowedChildren = [Br, ft], Br.blotName = "inline", Br.scope = I.INLINE_BLOT, Br.tagName = "SPAN";
let Xf = Br;
const Oi = Xf, Dr = class si extends zt {
  static create(t) {
    return super.create(t);
  }
  static formats(t, e) {
    const r = e.query(si.blotName);
    if (!(r != null && t.tagName === r.tagName)) {
      if (typeof this.tagName == "string")
        return !0;
      if (Array.isArray(this.tagName))
        return t.tagName.toLowerCase();
    }
  }
  constructor(t, e) {
    super(t, e), this.attributes = new ls(this.domNode);
  }
  format(t, e) {
    const r = this.scroll.query(t, I.BLOCK);
    r != null && (r instanceof oe ? this.attributes.attribute(r, e) : t === this.statics.blotName && !e ? this.replaceWith(si.blotName) : e && (t !== this.statics.blotName || this.formats()[t] !== e) && this.replaceWith(t, e));
  }
  formats() {
    const t = this.attributes.values(), e = this.statics.formats(this.domNode, this.scroll);
    return e != null && (t[this.statics.blotName] = e), t;
  }
  formatAt(t, e, r, s) {
    this.scroll.query(r, I.BLOCK) != null ? this.format(r, s) : super.formatAt(t, e, r, s);
  }
  insertAt(t, e, r) {
    if (r == null || this.scroll.query(e, I.INLINE) != null)
      super.insertAt(t, e, r);
    else {
      const s = this.split(t);
      if (s != null) {
        const i = this.scroll.create(e, r);
        s.parent.insertBefore(i, s);
      } else
        throw new Error("Attempt to insertAt after block boundaries");
    }
  }
  replaceWith(t, e) {
    const r = super.replaceWith(t, e);
    return this.attributes.copy(r), r;
  }
  update(t, e) {
    super.update(t, e), t.some(
      (r) => r.target === this.domNode && r.type === "attributes"
    ) && this.attributes.build();
  }
};
Dr.blotName = "block", Dr.scope = I.BLOCK_BLOT, Dr.tagName = "P", Dr.allowedChildren = [
  Oi,
  Dr,
  ft
];
let Jf = Dr;
const En = Jf, ii = class extends zt {
  checkMerge() {
    return this.next !== null && this.next.statics.blotName === this.statics.blotName;
  }
  deleteAt(t, e) {
    super.deleteAt(t, e), this.enforceAllowedChildren();
  }
  formatAt(t, e, r, s) {
    super.formatAt(t, e, r, s), this.enforceAllowedChildren();
  }
  insertAt(t, e, r) {
    super.insertAt(t, e, r), this.enforceAllowedChildren();
  }
  optimize(t) {
    super.optimize(t), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
  }
};
ii.blotName = "container", ii.scope = I.BLOCK_BLOT;
let Qf = ii;
const as = Qf;
class td extends ft {
  static formats(t, e) {
  }
  format(t, e) {
    super.formatAt(0, this.length(), t, e);
  }
  formatAt(t, e, r, s) {
    t === 0 && e === this.length() ? this.format(r, s) : super.formatAt(t, e, r, s);
  }
  formats() {
    return this.statics.formats(this.domNode, this.scroll);
  }
}
const Tt = td, ed = {
  attributes: !0,
  characterData: !0,
  characterDataOldValue: !0,
  childList: !0,
  subtree: !0
}, rd = 100, $r = class extends zt {
  constructor(t, e) {
    super(null, e), this.registry = t, this.scroll = this, this.build(), this.observer = new MutationObserver((r) => {
      this.update(r);
    }), this.observer.observe(this.domNode, ed), this.attach();
  }
  create(t, e) {
    return this.registry.create(this, t, e);
  }
  find(t, e = !1) {
    const r = this.registry.find(t, e);
    return r ? r.scroll === this ? r : e ? this.find(r.scroll.domNode.parentNode, !0) : null : null;
  }
  query(t, e = I.ANY) {
    return this.registry.query(t, e);
  }
  register(...t) {
    return this.registry.register(...t);
  }
  build() {
    this.scroll != null && super.build();
  }
  detach() {
    super.detach(), this.observer.disconnect();
  }
  deleteAt(t, e) {
    this.update(), t === 0 && e === this.length() ? this.children.forEach((r) => {
      r.remove();
    }) : super.deleteAt(t, e);
  }
  formatAt(t, e, r, s) {
    this.update(), super.formatAt(t, e, r, s);
  }
  insertAt(t, e, r) {
    this.update(), super.insertAt(t, e, r);
  }
  optimize(t = [], e = {}) {
    super.optimize(e);
    const r = e.mutationsMap || /* @__PURE__ */ new WeakMap();
    let s = Array.from(this.observer.takeRecords());
    for (; s.length > 0; )
      t.push(s.pop());
    const i = (c, h = !0) => {
      c == null || c === this || c.domNode.parentNode != null && (r.has(c.domNode) || r.set(c.domNode, []), h && i(c.parent));
    }, o = (c) => {
      r.has(c.domNode) && (c instanceof zt && c.children.forEach(o), r.delete(c.domNode), c.optimize(e));
    };
    let a = t;
    for (let c = 0; a.length > 0; c += 1) {
      if (c >= rd)
        throw new Error("[Parchment] Maximum optimize iterations reached");
      for (a.forEach((h) => {
        const f = this.find(h.target, !0);
        f != null && (f.domNode === h.target && (h.type === "childList" ? (i(this.find(h.previousSibling, !1)), Array.from(h.addedNodes).forEach((b) => {
          const d = this.find(b, !1);
          i(d, !1), d instanceof zt && d.children.forEach((m) => {
            i(m, !1);
          });
        })) : h.type === "attributes" && i(f.prev)), i(f));
      }), this.children.forEach(o), a = Array.from(this.observer.takeRecords()), s = a.slice(); s.length > 0; )
        t.push(s.pop());
    }
  }
  update(t, e = {}) {
    t = t || this.observer.takeRecords();
    const r = /* @__PURE__ */ new WeakMap();
    t.map((s) => {
      const i = this.find(s.target, !0);
      return i == null ? null : r.has(i.domNode) ? (r.get(i.domNode).push(s), null) : (r.set(i.domNode, [s]), i);
    }).forEach((s) => {
      s != null && s !== this && r.has(s.domNode) && s.update(r.get(s.domNode) || [], e);
    }), e.mutationsMap = r, r.has(this.domNode) && super.update(r.get(this.domNode), e), this.optimize(t, e);
  }
};
$r.blotName = "scroll", $r.defaultChild = En, $r.allowedChildren = [En, as], $r.scope = I.BLOCK_BLOT, $r.tagName = "DIV";
let nd = $r;
const Li = nd, oi = class ql extends ft {
  static create(t) {
    return document.createTextNode(t);
  }
  static value(t) {
    return t.data;
  }
  constructor(t, e) {
    super(t, e), this.text = this.statics.value(this.domNode);
  }
  deleteAt(t, e) {
    this.domNode.data = this.text = this.text.slice(0, t) + this.text.slice(t + e);
  }
  index(t, e) {
    return this.domNode === t ? e : -1;
  }
  insertAt(t, e, r) {
    r == null ? (this.text = this.text.slice(0, t) + e + this.text.slice(t), this.domNode.data = this.text) : super.insertAt(t, e, r);
  }
  length() {
    return this.text.length;
  }
  optimize(t) {
    super.optimize(t), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof ql && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
  }
  position(t, e = !1) {
    return [this.domNode, t];
  }
  split(t, e = !1) {
    if (!e) {
      if (t === 0)
        return this;
      if (t === this.length())
        return this.next;
    }
    const r = this.scroll.create(this.domNode.splitText(t));
    return this.parent.insertBefore(r, this.next || void 0), this.text = this.statics.value(this.domNode), r;
  }
  update(t, e) {
    t.some((r) => r.type === "characterData" && r.target === this.domNode) && (this.text = this.statics.value(this.domNode));
  }
  value() {
    return this.text;
  }
};
oi.blotName = "text", oi.scope = I.INLINE_BLOT;
let sd = oi;
const es = sd, id = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Attributor: oe,
  AttributorStore: ls,
  BlockBlot: En,
  ClassAttributor: Vt,
  ContainerBlot: as,
  EmbedBlot: Tt,
  InlineBlot: Oi,
  LeafBlot: ft,
  ParentBlot: zt,
  Registry: Gr,
  Scope: I,
  ScrollBlot: Li,
  StyleAttributor: Ge,
  TextBlot: es
}, Symbol.toStringTag, { value: "Module" }));
var li = { exports: {} }, At = -1, mt = 1, st = 0;
function wn(n, t, e, r, s) {
  if (n === t)
    return n ? [[st, n]] : [];
  if (e != null) {
    var i = gd(n, t, e);
    if (i)
      return i;
  }
  var o = Ci(n, t), a = n.substring(0, o);
  n = n.substring(o), t = t.substring(o), o = cs(n, t);
  var c = n.substring(n.length - o);
  n = n.substring(0, n.length - o), t = t.substring(0, t.length - o);
  var h = od(n, t);
  return a && h.unshift([st, a]), c && h.push([st, c]), qi(h, s), r && cd(h), h;
}
function od(n, t) {
  var e;
  if (!n)
    return [[mt, t]];
  if (!t)
    return [[At, n]];
  var r = n.length > t.length ? n : t, s = n.length > t.length ? t : n, i = r.indexOf(s);
  if (i !== -1)
    return e = [
      [mt, r.substring(0, i)],
      [st, s],
      [mt, r.substring(i + s.length)]
    ], n.length > t.length && (e[0][0] = e[2][0] = At), e;
  if (s.length === 1)
    return [
      [At, n],
      [mt, t]
    ];
  var o = ad(n, t);
  if (o) {
    var a = o[0], c = o[1], h = o[2], f = o[3], b = o[4], d = wn(a, h), m = wn(c, f);
    return d.concat([[st, b]], m);
  }
  return ld(n, t);
}
function ld(n, t) {
  for (var e = n.length, r = t.length, s = Math.ceil((e + r) / 2), i = s, o = 2 * s, a = new Array(o), c = new Array(o), h = 0; h < o; h++)
    a[h] = -1, c[h] = -1;
  a[i + 1] = 0, c[i + 1] = 0;
  for (var f = e - r, b = f % 2 !== 0, d = 0, m = 0, y = 0, v = 0, w = 0; w < s; w++) {
    for (var E = -w + d; E <= w - m; E += 2) {
      var x = i + E, _;
      E === -w || E !== w && a[x - 1] < a[x + 1] ? _ = a[x + 1] : _ = a[x - 1] + 1;
      for (var C = _ - E; _ < e && C < r && n.charAt(_) === t.charAt(C); )
        _++, C++;
      if (a[x] = _, _ > e)
        m += 2;
      else if (C > r)
        d += 2;
      else if (b) {
        var O = i + f - E;
        if (O >= 0 && O < o && c[O] !== -1) {
          var j = e - c[O];
          if (_ >= j)
            return xo(n, t, _, C);
        }
      }
    }
    for (var U = -w + y; U <= w - v; U += 2) {
      var O = i + U, j;
      U === -w || U !== w && c[O - 1] < c[O + 1] ? j = c[O + 1] : j = c[O - 1] + 1;
      for (var W = j - U; j < e && W < r && n.charAt(e - j - 1) === t.charAt(r - W - 1); )
        j++, W++;
      if (c[O] = j, j > e)
        v += 2;
      else if (W > r)
        y += 2;
      else if (!b) {
        var x = i + f - U;
        if (x >= 0 && x < o && a[x] !== -1) {
          var _ = a[x], C = i + _ - x;
          if (j = e - j, _ >= j)
            return xo(n, t, _, C);
        }
      }
    }
  }
  return [
    [At, n],
    [mt, t]
  ];
}
function xo(n, t, e, r) {
  var s = n.substring(0, e), i = t.substring(0, r), o = n.substring(e), a = t.substring(r), c = wn(s, i), h = wn(o, a);
  return c.concat(h);
}
function Ci(n, t) {
  if (!n || !t || n.charAt(0) !== t.charAt(0))
    return 0;
  for (var e = 0, r = Math.min(n.length, t.length), s = r, i = 0; e < s; )
    n.substring(i, s) == t.substring(i, s) ? (e = s, i = e) : r = s, s = Math.floor((r - e) / 2 + e);
  return Rl(n.charCodeAt(s - 1)) && s--, s;
}
function No(n, t) {
  var e = n.length, r = t.length;
  if (e == 0 || r == 0)
    return 0;
  e > r ? n = n.substring(e - r) : e < r && (t = t.substring(0, e));
  var s = Math.min(e, r);
  if (n == t)
    return s;
  for (var i = 0, o = 1; ; ) {
    var a = n.substring(s - o), c = t.indexOf(a);
    if (c == -1)
      return i;
    o += c, (c == 0 || n.substring(s - o) == t.substring(0, o)) && (i = o, o++);
  }
}
function cs(n, t) {
  if (!n || !t || n.slice(-1) !== t.slice(-1))
    return 0;
  for (var e = 0, r = Math.min(n.length, t.length), s = r, i = 0; e < s; )
    n.substring(n.length - s, n.length - i) == t.substring(t.length - s, t.length - i) ? (e = s, i = e) : r = s, s = Math.floor((r - e) / 2 + e);
  return Il(n.charCodeAt(n.length - s)) && s--, s;
}
function ad(n, t) {
  var e = n.length > t.length ? n : t, r = n.length > t.length ? t : n;
  if (e.length < 4 || r.length * 2 < e.length)
    return null;
  function s(m, y, v) {
    for (var w = m.substring(v, v + Math.floor(m.length / 4)), E = -1, x = "", _, C, O, j; (E = y.indexOf(w, E + 1)) !== -1; ) {
      var U = Ci(
        m.substring(v),
        y.substring(E)
      ), W = cs(
        m.substring(0, v),
        y.substring(0, E)
      );
      x.length < W + U && (x = y.substring(E - W, E) + y.substring(E, E + U), _ = m.substring(0, v - W), C = m.substring(v + U), O = y.substring(0, E - W), j = y.substring(E + U));
    }
    return x.length * 2 >= m.length ? [
      _,
      C,
      O,
      j,
      x
    ] : null;
  }
  var i = s(
    e,
    r,
    Math.ceil(e.length / 4)
  ), o = s(
    e,
    r,
    Math.ceil(e.length / 2)
  ), a;
  if (!i && !o)
    return null;
  o ? i ? a = i[4].length > o[4].length ? i : o : a = o : a = i;
  var c, h, f, b;
  n.length > t.length ? (c = a[0], h = a[1], f = a[2], b = a[3]) : (f = a[0], b = a[1], c = a[2], h = a[3]);
  var d = a[4];
  return [c, h, f, b, d];
}
function cd(n) {
  for (var t = !1, e = [], r = 0, s = null, i = 0, o = 0, a = 0, c = 0, h = 0; i < n.length; )
    n[i][0] == st ? (e[r++] = i, o = c, a = h, c = 0, h = 0, s = n[i][1]) : (n[i][0] == mt ? c += n[i][1].length : h += n[i][1].length, s && s.length <= Math.max(o, a) && s.length <= Math.max(c, h) && (n.splice(e[r - 1], 0, [
      At,
      s
    ]), n[e[r - 1] + 1][0] = mt, r--, r--, i = r > 0 ? e[r - 1] : -1, o = 0, a = 0, c = 0, h = 0, s = null, t = !0)), i++;
  for (t && qi(n), fd(n), i = 1; i < n.length; ) {
    if (n[i - 1][0] == At && n[i][0] == mt) {
      var f = n[i - 1][1], b = n[i][1], d = No(f, b), m = No(b, f);
      d >= m ? (d >= f.length / 2 || d >= b.length / 2) && (n.splice(i, 0, [
        st,
        b.substring(0, d)
      ]), n[i - 1][1] = f.substring(
        0,
        f.length - d
      ), n[i + 1][1] = b.substring(d), i++) : (m >= f.length / 2 || m >= b.length / 2) && (n.splice(i, 0, [
        st,
        f.substring(0, m)
      ]), n[i - 1][0] = mt, n[i - 1][1] = b.substring(
        0,
        b.length - m
      ), n[i + 1][0] = At, n[i + 1][1] = f.substring(m), i++), i++;
    }
    i++;
  }
}
var _o = /[^a-zA-Z0-9]/, So = /\s/, Oo = /[\r\n]/, ud = /\n\r?\n$/, hd = /^\r?\n\r?\n/;
function fd(n) {
  function t(m, y) {
    if (!m || !y)
      return 6;
    var v = m.charAt(m.length - 1), w = y.charAt(0), E = v.match(_o), x = w.match(_o), _ = E && v.match(So), C = x && w.match(So), O = _ && v.match(Oo), j = C && w.match(Oo), U = O && m.match(ud), W = j && y.match(hd);
    return U || W ? 5 : O || j ? 4 : E && !_ && C ? 3 : _ || C ? 2 : E || x ? 1 : 0;
  }
  for (var e = 1; e < n.length - 1; ) {
    if (n[e - 1][0] == st && n[e + 1][0] == st) {
      var r = n[e - 1][1], s = n[e][1], i = n[e + 1][1], o = cs(r, s);
      if (o) {
        var a = s.substring(s.length - o);
        r = r.substring(0, r.length - o), s = a + s.substring(0, s.length - o), i = a + i;
      }
      for (var c = r, h = s, f = i, b = t(r, s) + t(s, i); s.charAt(0) === i.charAt(0); ) {
        r += s.charAt(0), s = s.substring(1) + i.charAt(0), i = i.substring(1);
        var d = t(r, s) + t(s, i);
        d >= b && (b = d, c = r, h = s, f = i);
      }
      n[e - 1][1] != c && (c ? n[e - 1][1] = c : (n.splice(e - 1, 1), e--), n[e][1] = h, f ? n[e + 1][1] = f : (n.splice(e + 1, 1), e--));
    }
    e++;
  }
}
function qi(n, t) {
  n.push([st, ""]);
  for (var e = 0, r = 0, s = 0, i = "", o = "", a; e < n.length; ) {
    if (e < n.length - 1 && !n[e][1]) {
      n.splice(e, 1);
      continue;
    }
    switch (n[e][0]) {
      case mt:
        s++, o += n[e][1], e++;
        break;
      case At:
        r++, i += n[e][1], e++;
        break;
      case st:
        var c = e - s - r - 1;
        if (t) {
          if (c >= 0 && Ml(n[c][1])) {
            var h = n[c][1].slice(-1);
            if (n[c][1] = n[c][1].slice(
              0,
              -1
            ), i = h + i, o = h + o, !n[c][1]) {
              n.splice(c, 1), e--;
              var f = c - 1;
              n[f] && n[f][0] === mt && (s++, o = n[f][1] + o, f--), n[f] && n[f][0] === At && (r++, i = n[f][1] + i, f--), c = f;
            }
          }
          if (kl(n[e][1])) {
            var h = n[e][1].charAt(0);
            n[e][1] = n[e][1].slice(1), i += h, o += h;
          }
        }
        if (e < n.length - 1 && !n[e][1]) {
          n.splice(e, 1);
          break;
        }
        if (i.length > 0 || o.length > 0) {
          i.length > 0 && o.length > 0 && (a = Ci(o, i), a !== 0 && (c >= 0 ? n[c][1] += o.substring(
            0,
            a
          ) : (n.splice(0, 0, [
            st,
            o.substring(0, a)
          ]), e++), o = o.substring(a), i = i.substring(a)), a = cs(o, i), a !== 0 && (n[e][1] = o.substring(o.length - a) + n[e][1], o = o.substring(
            0,
            o.length - a
          ), i = i.substring(
            0,
            i.length - a
          )));
          var b = s + r;
          i.length === 0 && o.length === 0 ? (n.splice(e - b, b), e = e - b) : i.length === 0 ? (n.splice(e - b, b, [mt, o]), e = e - b + 1) : o.length === 0 ? (n.splice(e - b, b, [At, i]), e = e - b + 1) : (n.splice(
            e - b,
            b,
            [At, i],
            [mt, o]
          ), e = e - b + 2);
        }
        e !== 0 && n[e - 1][0] === st ? (n[e - 1][1] += n[e][1], n.splice(e, 1)) : e++, s = 0, r = 0, i = "", o = "";
        break;
    }
  }
  n[n.length - 1][1] === "" && n.pop();
  var d = !1;
  for (e = 1; e < n.length - 1; )
    n[e - 1][0] === st && n[e + 1][0] === st && (n[e][1].substring(
      n[e][1].length - n[e - 1][1].length
    ) === n[e - 1][1] ? (n[e][1] = n[e - 1][1] + n[e][1].substring(
      0,
      n[e][1].length - n[e - 1][1].length
    ), n[e + 1][1] = n[e - 1][1] + n[e + 1][1], n.splice(e - 1, 1), d = !0) : n[e][1].substring(0, n[e + 1][1].length) == n[e + 1][1] && (n[e - 1][1] += n[e + 1][1], n[e][1] = n[e][1].substring(n[e + 1][1].length) + n[e + 1][1], n.splice(e + 1, 1), d = !0)), e++;
  d && qi(n, t);
}
function Rl(n) {
  return n >= 55296 && n <= 56319;
}
function Il(n) {
  return n >= 56320 && n <= 57343;
}
function kl(n) {
  return Il(n.charCodeAt(0));
}
function Ml(n) {
  return Rl(n.charCodeAt(n.length - 1));
}
function dd(n) {
  for (var t = [], e = 0; e < n.length; e++)
    n[e][1].length > 0 && t.push(n[e]);
  return t;
}
function Ds(n, t, e, r) {
  return Ml(n) || kl(r) ? null : dd([
    [st, n],
    [At, t],
    [mt, e],
    [st, r]
  ]);
}
function gd(n, t, e) {
  var r = typeof e == "number" ? { index: e, length: 0 } : e.oldRange, s = typeof e == "number" ? null : e.newRange, i = n.length, o = t.length;
  if (r.length === 0 && (s === null || s.length === 0)) {
    var a = r.index, c = n.slice(0, a), h = n.slice(a), f = s ? s.index : null;
    t: {
      var b = a + o - i;
      if (f !== null && f !== b || b < 0 || b > o)
        break t;
      var d = t.slice(0, b), m = t.slice(b);
      if (m !== h)
        break t;
      var y = Math.min(a, b), v = c.slice(0, y), w = d.slice(0, y);
      if (v !== w)
        break t;
      var E = c.slice(y), x = d.slice(y);
      return Ds(v, E, x, h);
    }
    t: {
      if (f !== null && f !== a)
        break t;
      var _ = a, d = t.slice(0, _), m = t.slice(_);
      if (d !== c)
        break t;
      var C = Math.min(i - _, o - _), O = h.slice(h.length - C), j = m.slice(m.length - C);
      if (O !== j)
        break t;
      var E = h.slice(0, h.length - C), x = m.slice(0, m.length - C);
      return Ds(c, E, x, O);
    }
  }
  if (r.length > 0 && s && s.length === 0)
    t: {
      var v = n.slice(0, r.index), O = n.slice(r.index + r.length), y = v.length, C = O.length;
      if (o < y + C)
        break t;
      var w = t.slice(0, y), j = t.slice(o - C);
      if (v !== w || O !== j)
        break t;
      var E = n.slice(y, i - C), x = t.slice(y, o - C);
      return Ds(v, E, x, O);
    }
  return null;
}
function us(n, t, e, r) {
  return wn(n, t, e, r, !0);
}
us.INSERT = mt;
us.DELETE = At;
us.EQUAL = st;
var pd = us, rs = { exports: {} };
rs.exports;
(function(n, t) {
  var e = 200, r = "__lodash_hash_undefined__", s = 9007199254740991, i = "[object Arguments]", o = "[object Array]", a = "[object Boolean]", c = "[object Date]", h = "[object Error]", f = "[object Function]", b = "[object GeneratorFunction]", d = "[object Map]", m = "[object Number]", y = "[object Object]", v = "[object Promise]", w = "[object RegExp]", E = "[object Set]", x = "[object String]", _ = "[object Symbol]", C = "[object WeakMap]", O = "[object ArrayBuffer]", j = "[object DataView]", U = "[object Float32Array]", W = "[object Float64Array]", xt = "[object Int8Array]", Zt = "[object Int16Array]", ce = "[object Int32Array]", Yt = "[object Uint8Array]", Et = "[object Uint8ClampedArray]", Nt = "[object Uint16Array]", Xt = "[object Uint32Array]", pr = /[\\^$.*+?()[\]{}|]/g, mr = /\w*$/, br = /^\[object .+?Constructor\]$/, yr = /^(?:0|[1-9]\d*)$/, K = {};
  K[i] = K[o] = K[O] = K[j] = K[a] = K[c] = K[U] = K[W] = K[xt] = K[Zt] = K[ce] = K[d] = K[m] = K[y] = K[w] = K[E] = K[x] = K[_] = K[Yt] = K[Et] = K[Nt] = K[Xt] = !0, K[h] = K[f] = K[C] = !1;
  var vr = typeof Ue == "object" && Ue && Ue.Object === Object && Ue, Er = typeof self == "object" && self && self.Object === Object && self, bt = vr || Er || Function("return this")(), wr = t && !t.nodeType && t, V = wr && !0 && n && !n.nodeType && n, xe = V && V.exports === wr;
  function We(l, u) {
    return l.set(u[0], u[1]), l;
  }
  function ct(l, u) {
    return l.add(u), l;
  }
  function Ne(l, u) {
    for (var p = -1, A = l ? l.length : 0; ++p < A && u(l[p], p, l) !== !1; )
      ;
    return l;
  }
  function ue(l, u) {
    for (var p = -1, A = u.length, P = l.length; ++p < A; )
      l[P + p] = u[p];
    return l;
  }
  function Ze(l, u, p, A) {
    for (var P = -1, k = l ? l.length : 0; ++P < k; )
      p = u(p, l[P], P, l);
    return p;
  }
  function _e(l, u) {
    for (var p = -1, A = Array(l); ++p < l; )
      A[p] = u(p);
    return A;
  }
  function Ar(l, u) {
    return l == null ? void 0 : l[u];
  }
  function Ye(l) {
    var u = !1;
    if (l != null && typeof l.toString != "function")
      try {
        u = !!(l + "");
      } catch {
      }
    return u;
  }
  function he(l) {
    var u = -1, p = Array(l.size);
    return l.forEach(function(A, P) {
      p[++u] = [P, A];
    }), p;
  }
  function It(l, u) {
    return function(p) {
      return l(u(p));
    };
  }
  function Xe(l) {
    var u = -1, p = Array(l.size);
    return l.forEach(function(A) {
      p[++u] = A;
    }), p;
  }
  var Tr = Array.prototype, Se = Function.prototype, Oe = Object.prototype, Je = bt["__core-js_shared__"], Le = function() {
    var l = /[^.]+$/.exec(Je && Je.keys && Je.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), xr = Se.toString, _t = Oe.hasOwnProperty, fe = Oe.toString, Nr = RegExp(
    "^" + xr.call(_t).replace(pr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Jt = xe ? bt.Buffer : void 0, Ce = bt.Symbol, qe = bt.Uint8Array, gt = It(Object.getPrototypeOf, Object), _r = Object.create, Sr = Oe.propertyIsEnumerable, Jr = Tr.splice, Qe = Object.getOwnPropertySymbols, Re = Jt ? Jt.isBuffer : void 0, Or = It(Object.keys, Object), Ie = Dt(bt, "DataView"), kt = Dt(bt, "Map"), yt = Dt(bt, "Promise"), wt = Dt(bt, "Set"), de = Dt(bt, "WeakMap"), Mt = Dt(Object, "create"), ke = pt(Ie), ge = pt(kt), Me = pt(yt), tr = pt(wt), je = pt(de), jt = Ce ? Ce.prototype : void 0, Lr = jt ? jt.valueOf : void 0;
  function Bt(l) {
    var u = -1, p = l ? l.length : 0;
    for (this.clear(); ++u < p; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function Cr() {
    this.__data__ = Mt ? Mt(null) : {};
  }
  function qr(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function Qr(l) {
    var u = this.__data__;
    if (Mt) {
      var p = u[l];
      return p === r ? void 0 : p;
    }
    return _t.call(u, l) ? u[l] : void 0;
  }
  function Rr(l) {
    var u = this.__data__;
    return Mt ? u[l] !== void 0 : _t.call(u, l);
  }
  function er(l, u) {
    var p = this.__data__;
    return p[l] = Mt && u === void 0 ? r : u, this;
  }
  Bt.prototype.clear = Cr, Bt.prototype.delete = qr, Bt.prototype.get = Qr, Bt.prototype.has = Rr, Bt.prototype.set = er;
  function et(l) {
    var u = -1, p = l ? l.length : 0;
    for (this.clear(); ++u < p; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function g() {
    this.__data__ = [];
  }
  function N(l) {
    var u = this.__data__, p = Ir(u, l);
    if (p < 0)
      return !1;
    var A = u.length - 1;
    return p == A ? u.pop() : Jr.call(u, p, 1), !0;
  }
  function S(l) {
    var u = this.__data__, p = Ir(u, l);
    return p < 0 ? void 0 : u[p][1];
  }
  function M(l) {
    return Ir(this.__data__, l) > -1;
  }
  function F(l, u) {
    var p = this.__data__, A = Ir(p, l);
    return A < 0 ? p.push([l, u]) : p[A][1] = u, this;
  }
  et.prototype.clear = g, et.prototype.delete = N, et.prototype.get = S, et.prototype.has = M, et.prototype.set = F;
  function B(l) {
    var u = -1, p = l ? l.length : 0;
    for (this.clear(); ++u < p; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function $() {
    this.__data__ = {
      hash: new Bt(),
      map: new (kt || et)(),
      string: new Bt()
    };
  }
  function D(l) {
    return sr(this, l).delete(l);
  }
  function rt(l) {
    return sr(this, l).get(l);
  }
  function X(l) {
    return sr(this, l).has(l);
  }
  function Q(l, u) {
    return sr(this, l).set(l, u), this;
  }
  B.prototype.clear = $, B.prototype.delete = D, B.prototype.get = rt, B.prototype.has = X, B.prototype.set = Q;
  function Z(l) {
    this.__data__ = new et(l);
  }
  function Qt() {
    this.__data__ = new et();
  }
  function Pt(l) {
    return this.__data__.delete(l);
  }
  function it(l) {
    return this.__data__.get(l);
  }
  function rr(l) {
    return this.__data__.has(l);
  }
  function tn(l, u) {
    var p = this.__data__;
    if (p instanceof et) {
      var A = p.__data__;
      if (!kt || A.length < e - 1)
        return A.push([l, u]), this;
      p = this.__data__ = new B(A);
    }
    return p.set(l, u), this;
  }
  Z.prototype.clear = Qt, Z.prototype.delete = Pt, Z.prototype.get = it, Z.prototype.has = rr, Z.prototype.set = tn;
  function Be(l, u) {
    var p = sn(l) || Mr(l) ? _e(l.length, String) : [], A = p.length, P = !!A;
    for (var k in l)
      _t.call(l, k) && !(P && (k == "length" || Ls(k, A))) && p.push(k);
    return p;
  }
  function Rn(l, u, p) {
    var A = l[u];
    (!(_t.call(l, u) && Bn(A, p)) || p === void 0 && !(u in l)) && (l[u] = p);
  }
  function Ir(l, u) {
    for (var p = l.length; p--; )
      if (Bn(l[p][0], u))
        return p;
    return -1;
  }
  function te(l, u) {
    return l && nn(u, ln(u), l);
  }
  function en(l, u, p, A, P, k, z) {
    var H;
    if (A && (H = k ? A(l, P, k, z) : A(l)), H !== void 0)
      return H;
    if (!re(l))
      return l;
    var tt = sn(l);
    if (tt) {
      if (H = Ss(l), !u)
        return xs(l, H);
    } else {
      var G = me(l), ut = G == f || G == b;
      if (Pn(l))
        return kr(l, u);
      if (G == y || G == i || ut && !k) {
        if (Ye(l))
          return k ? l : {};
        if (H = ee(ut ? {} : l), !u)
          return Ns(l, te(H, l));
      } else {
        if (!K[G])
          return k ? l : {};
        H = Os(l, G, en, u);
      }
    }
    z || (z = new Z());
    var vt = z.get(l);
    if (vt)
      return vt;
    if (z.set(l, H), !tt)
      var nt = p ? _s(l) : ln(l);
    return Ne(nt || l, function(ht, lt) {
      nt && (lt = ht, ht = l[lt]), Rn(H, lt, en(ht, u, p, A, lt, l, z));
    }), H;
  }
  function ms(l) {
    return re(l) ? _r(l) : {};
  }
  function bs(l, u, p) {
    var A = u(l);
    return sn(l) ? A : ue(A, p(l));
  }
  function ys(l) {
    return fe.call(l);
  }
  function vs(l) {
    if (!re(l) || qs(l))
      return !1;
    var u = on(l) || Ye(l) ? Nr : br;
    return u.test(pt(l));
  }
  function Es(l) {
    if (!Mn(l))
      return Or(l);
    var u = [];
    for (var p in Object(l))
      _t.call(l, p) && p != "constructor" && u.push(p);
    return u;
  }
  function kr(l, u) {
    if (u)
      return l.slice();
    var p = new l.constructor(l.length);
    return l.copy(p), p;
  }
  function rn(l) {
    var u = new l.constructor(l.byteLength);
    return new qe(u).set(new qe(l)), u;
  }
  function nr(l, u) {
    var p = u ? rn(l.buffer) : l.buffer;
    return new l.constructor(p, l.byteOffset, l.byteLength);
  }
  function In(l, u, p) {
    var A = u ? p(he(l), !0) : he(l);
    return Ze(A, We, new l.constructor());
  }
  function kn(l) {
    var u = new l.constructor(l.source, mr.exec(l));
    return u.lastIndex = l.lastIndex, u;
  }
  function ws(l, u, p) {
    var A = u ? p(Xe(l), !0) : Xe(l);
    return Ze(A, ct, new l.constructor());
  }
  function As(l) {
    return Lr ? Object(Lr.call(l)) : {};
  }
  function Ts(l, u) {
    var p = u ? rn(l.buffer) : l.buffer;
    return new l.constructor(p, l.byteOffset, l.length);
  }
  function xs(l, u) {
    var p = -1, A = l.length;
    for (u || (u = Array(A)); ++p < A; )
      u[p] = l[p];
    return u;
  }
  function nn(l, u, p, A) {
    p || (p = {});
    for (var P = -1, k = u.length; ++P < k; ) {
      var z = u[P], H = void 0;
      Rn(p, z, H === void 0 ? l[z] : H);
    }
    return p;
  }
  function Ns(l, u) {
    return nn(l, pe(l), u);
  }
  function _s(l) {
    return bs(l, ln, pe);
  }
  function sr(l, u) {
    var p = l.__data__;
    return Cs(u) ? p[typeof u == "string" ? "string" : "hash"] : p.map;
  }
  function Dt(l, u) {
    var p = Ar(l, u);
    return vs(p) ? p : void 0;
  }
  var pe = Qe ? It(Qe, Object) : Is, me = ys;
  (Ie && me(new Ie(new ArrayBuffer(1))) != j || kt && me(new kt()) != d || yt && me(yt.resolve()) != v || wt && me(new wt()) != E || de && me(new de()) != C) && (me = function(l) {
    var u = fe.call(l), p = u == y ? l.constructor : void 0, A = p ? pt(p) : void 0;
    if (A)
      switch (A) {
        case ke:
          return j;
        case ge:
          return d;
        case Me:
          return v;
        case tr:
          return E;
        case je:
          return C;
      }
    return u;
  });
  function Ss(l) {
    var u = l.length, p = l.constructor(u);
    return u && typeof l[0] == "string" && _t.call(l, "index") && (p.index = l.index, p.input = l.input), p;
  }
  function ee(l) {
    return typeof l.constructor == "function" && !Mn(l) ? ms(gt(l)) : {};
  }
  function Os(l, u, p, A) {
    var P = l.constructor;
    switch (u) {
      case O:
        return rn(l);
      case a:
      case c:
        return new P(+l);
      case j:
        return nr(l, A);
      case U:
      case W:
      case xt:
      case Zt:
      case ce:
      case Yt:
      case Et:
      case Nt:
      case Xt:
        return Ts(l, A);
      case d:
        return In(l, A, p);
      case m:
      case x:
        return new P(l);
      case w:
        return kn(l);
      case E:
        return ws(l, A, p);
      case _:
        return As(l);
    }
  }
  function Ls(l, u) {
    return u = u ?? s, !!u && (typeof l == "number" || yr.test(l)) && l > -1 && l % 1 == 0 && l < u;
  }
  function Cs(l) {
    var u = typeof l;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? l !== "__proto__" : l === null;
  }
  function qs(l) {
    return !!Le && Le in l;
  }
  function Mn(l) {
    var u = l && l.constructor, p = typeof u == "function" && u.prototype || Oe;
    return l === p;
  }
  function pt(l) {
    if (l != null) {
      try {
        return xr.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function jn(l) {
    return en(l, !0, !0);
  }
  function Bn(l, u) {
    return l === u || l !== l && u !== u;
  }
  function Mr(l) {
    return Rs(l) && _t.call(l, "callee") && (!Sr.call(l, "callee") || fe.call(l) == i);
  }
  var sn = Array.isArray;
  function jr(l) {
    return l != null && Dn(l.length) && !on(l);
  }
  function Rs(l) {
    return $n(l) && jr(l);
  }
  var Pn = Re || ks;
  function on(l) {
    var u = re(l) ? fe.call(l) : "";
    return u == f || u == b;
  }
  function Dn(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= s;
  }
  function re(l) {
    var u = typeof l;
    return !!l && (u == "object" || u == "function");
  }
  function $n(l) {
    return !!l && typeof l == "object";
  }
  function ln(l) {
    return jr(l) ? Be(l) : Es(l);
  }
  function Is() {
    return [];
  }
  function ks() {
    return !1;
  }
  n.exports = jn;
})(rs, rs.exports);
var jl = rs.exports, ns = { exports: {} };
ns.exports;
(function(n, t) {
  var e = 200, r = "__lodash_hash_undefined__", s = 1, i = 2, o = 9007199254740991, a = "[object Arguments]", c = "[object Array]", h = "[object AsyncFunction]", f = "[object Boolean]", b = "[object Date]", d = "[object Error]", m = "[object Function]", y = "[object GeneratorFunction]", v = "[object Map]", w = "[object Number]", E = "[object Null]", x = "[object Object]", _ = "[object Promise]", C = "[object Proxy]", O = "[object RegExp]", j = "[object Set]", U = "[object String]", W = "[object Symbol]", xt = "[object Undefined]", Zt = "[object WeakMap]", ce = "[object ArrayBuffer]", Yt = "[object DataView]", Et = "[object Float32Array]", Nt = "[object Float64Array]", Xt = "[object Int8Array]", pr = "[object Int16Array]", mr = "[object Int32Array]", br = "[object Uint8Array]", yr = "[object Uint8ClampedArray]", K = "[object Uint16Array]", vr = "[object Uint32Array]", Er = /[\\^$.*+?()[\]{}|]/g, bt = /^\[object .+?Constructor\]$/, wr = /^(?:0|[1-9]\d*)$/, V = {};
  V[Et] = V[Nt] = V[Xt] = V[pr] = V[mr] = V[br] = V[yr] = V[K] = V[vr] = !0, V[a] = V[c] = V[ce] = V[f] = V[Yt] = V[b] = V[d] = V[m] = V[v] = V[w] = V[x] = V[O] = V[j] = V[U] = V[Zt] = !1;
  var xe = typeof Ue == "object" && Ue && Ue.Object === Object && Ue, We = typeof self == "object" && self && self.Object === Object && self, ct = xe || We || Function("return this")(), Ne = t && !t.nodeType && t, ue = Ne && !0 && n && !n.nodeType && n, Ze = ue && ue.exports === Ne, _e = Ze && xe.process, Ar = function() {
    try {
      return _e && _e.binding && _e.binding("util");
    } catch {
    }
  }(), Ye = Ar && Ar.isTypedArray;
  function he(l, u) {
    for (var p = -1, A = l == null ? 0 : l.length, P = 0, k = []; ++p < A; ) {
      var z = l[p];
      u(z, p, l) && (k[P++] = z);
    }
    return k;
  }
  function It(l, u) {
    for (var p = -1, A = u.length, P = l.length; ++p < A; )
      l[P + p] = u[p];
    return l;
  }
  function Xe(l, u) {
    for (var p = -1, A = l == null ? 0 : l.length; ++p < A; )
      if (u(l[p], p, l))
        return !0;
    return !1;
  }
  function Tr(l, u) {
    for (var p = -1, A = Array(l); ++p < l; )
      A[p] = u(p);
    return A;
  }
  function Se(l) {
    return function(u) {
      return l(u);
    };
  }
  function Oe(l, u) {
    return l.has(u);
  }
  function Je(l, u) {
    return l == null ? void 0 : l[u];
  }
  function Le(l) {
    var u = -1, p = Array(l.size);
    return l.forEach(function(A, P) {
      p[++u] = [P, A];
    }), p;
  }
  function xr(l, u) {
    return function(p) {
      return l(u(p));
    };
  }
  function _t(l) {
    var u = -1, p = Array(l.size);
    return l.forEach(function(A) {
      p[++u] = A;
    }), p;
  }
  var fe = Array.prototype, Nr = Function.prototype, Jt = Object.prototype, Ce = ct["__core-js_shared__"], qe = Nr.toString, gt = Jt.hasOwnProperty, _r = function() {
    var l = /[^.]+$/.exec(Ce && Ce.keys && Ce.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), Sr = Jt.toString, Jr = RegExp(
    "^" + qe.call(gt).replace(Er, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Qe = Ze ? ct.Buffer : void 0, Re = ct.Symbol, Or = ct.Uint8Array, Ie = Jt.propertyIsEnumerable, kt = fe.splice, yt = Re ? Re.toStringTag : void 0, wt = Object.getOwnPropertySymbols, de = Qe ? Qe.isBuffer : void 0, Mt = xr(Object.keys, Object), ke = pe(ct, "DataView"), ge = pe(ct, "Map"), Me = pe(ct, "Promise"), tr = pe(ct, "Set"), je = pe(ct, "WeakMap"), jt = pe(Object, "create"), Lr = pt(ke), Bt = pt(ge), Cr = pt(Me), qr = pt(tr), Qr = pt(je), Rr = Re ? Re.prototype : void 0, er = Rr ? Rr.valueOf : void 0;
  function et(l) {
    var u = -1, p = l == null ? 0 : l.length;
    for (this.clear(); ++u < p; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function g() {
    this.__data__ = jt ? jt(null) : {}, this.size = 0;
  }
  function N(l) {
    var u = this.has(l) && delete this.__data__[l];
    return this.size -= u ? 1 : 0, u;
  }
  function S(l) {
    var u = this.__data__;
    if (jt) {
      var p = u[l];
      return p === r ? void 0 : p;
    }
    return gt.call(u, l) ? u[l] : void 0;
  }
  function M(l) {
    var u = this.__data__;
    return jt ? u[l] !== void 0 : gt.call(u, l);
  }
  function F(l, u) {
    var p = this.__data__;
    return this.size += this.has(l) ? 0 : 1, p[l] = jt && u === void 0 ? r : u, this;
  }
  et.prototype.clear = g, et.prototype.delete = N, et.prototype.get = S, et.prototype.has = M, et.prototype.set = F;
  function B(l) {
    var u = -1, p = l == null ? 0 : l.length;
    for (this.clear(); ++u < p; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function $() {
    this.__data__ = [], this.size = 0;
  }
  function D(l) {
    var u = this.__data__, p = kr(u, l);
    if (p < 0)
      return !1;
    var A = u.length - 1;
    return p == A ? u.pop() : kt.call(u, p, 1), --this.size, !0;
  }
  function rt(l) {
    var u = this.__data__, p = kr(u, l);
    return p < 0 ? void 0 : u[p][1];
  }
  function X(l) {
    return kr(this.__data__, l) > -1;
  }
  function Q(l, u) {
    var p = this.__data__, A = kr(p, l);
    return A < 0 ? (++this.size, p.push([l, u])) : p[A][1] = u, this;
  }
  B.prototype.clear = $, B.prototype.delete = D, B.prototype.get = rt, B.prototype.has = X, B.prototype.set = Q;
  function Z(l) {
    var u = -1, p = l == null ? 0 : l.length;
    for (this.clear(); ++u < p; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function Qt() {
    this.size = 0, this.__data__ = {
      hash: new et(),
      map: new (ge || B)(),
      string: new et()
    };
  }
  function Pt(l) {
    var u = Dt(this, l).delete(l);
    return this.size -= u ? 1 : 0, u;
  }
  function it(l) {
    return Dt(this, l).get(l);
  }
  function rr(l) {
    return Dt(this, l).has(l);
  }
  function tn(l, u) {
    var p = Dt(this, l), A = p.size;
    return p.set(l, u), this.size += p.size == A ? 0 : 1, this;
  }
  Z.prototype.clear = Qt, Z.prototype.delete = Pt, Z.prototype.get = it, Z.prototype.has = rr, Z.prototype.set = tn;
  function Be(l) {
    var u = -1, p = l == null ? 0 : l.length;
    for (this.__data__ = new Z(); ++u < p; )
      this.add(l[u]);
  }
  function Rn(l) {
    return this.__data__.set(l, r), this;
  }
  function Ir(l) {
    return this.__data__.has(l);
  }
  Be.prototype.add = Be.prototype.push = Rn, Be.prototype.has = Ir;
  function te(l) {
    var u = this.__data__ = new B(l);
    this.size = u.size;
  }
  function en() {
    this.__data__ = new B(), this.size = 0;
  }
  function ms(l) {
    var u = this.__data__, p = u.delete(l);
    return this.size = u.size, p;
  }
  function bs(l) {
    return this.__data__.get(l);
  }
  function ys(l) {
    return this.__data__.has(l);
  }
  function vs(l, u) {
    var p = this.__data__;
    if (p instanceof B) {
      var A = p.__data__;
      if (!ge || A.length < e - 1)
        return A.push([l, u]), this.size = ++p.size, this;
      p = this.__data__ = new Z(A);
    }
    return p.set(l, u), this.size = p.size, this;
  }
  te.prototype.clear = en, te.prototype.delete = ms, te.prototype.get = bs, te.prototype.has = ys, te.prototype.set = vs;
  function Es(l, u) {
    var p = Mr(l), A = !p && Bn(l), P = !p && !A && jr(l), k = !p && !A && !P && $n(l), z = p || A || P || k, H = z ? Tr(l.length, String) : [], tt = H.length;
    for (var G in l)
      gt.call(l, G) && !(z && // Safari 9 has enumerable `arguments.length` in strict mode.
      (G == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      P && (G == "offset" || G == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      k && (G == "buffer" || G == "byteLength" || G == "byteOffset") || // Skip index properties.
      Os(G, tt))) && H.push(G);
    return H;
  }
  function kr(l, u) {
    for (var p = l.length; p--; )
      if (jn(l[p][0], u))
        return p;
    return -1;
  }
  function rn(l, u, p) {
    var A = u(l);
    return Mr(l) ? A : It(A, p(l));
  }
  function nr(l) {
    return l == null ? l === void 0 ? xt : E : yt && yt in Object(l) ? me(l) : Mn(l);
  }
  function In(l) {
    return re(l) && nr(l) == a;
  }
  function kn(l, u, p, A, P) {
    return l === u ? !0 : l == null || u == null || !re(l) && !re(u) ? l !== l && u !== u : ws(l, u, p, A, kn, P);
  }
  function ws(l, u, p, A, P, k) {
    var z = Mr(l), H = Mr(u), tt = z ? c : ee(l), G = H ? c : ee(u);
    tt = tt == a ? x : tt, G = G == a ? x : G;
    var ut = tt == x, vt = G == x, nt = tt == G;
    if (nt && jr(l)) {
      if (!jr(u))
        return !1;
      z = !0, ut = !1;
    }
    if (nt && !ut)
      return k || (k = new te()), z || $n(l) ? nn(l, u, p, A, P, k) : Ns(l, u, tt, p, A, P, k);
    if (!(p & s)) {
      var ht = ut && gt.call(l, "__wrapped__"), lt = vt && gt.call(u, "__wrapped__");
      if (ht || lt) {
        var Pe = ht ? l.value() : l, be = lt ? u.value() : u;
        return k || (k = new te()), P(Pe, be, p, A, k);
      }
    }
    return nt ? (k || (k = new te()), _s(l, u, p, A, P, k)) : !1;
  }
  function As(l) {
    if (!Dn(l) || Cs(l))
      return !1;
    var u = Pn(l) ? Jr : bt;
    return u.test(pt(l));
  }
  function Ts(l) {
    return re(l) && on(l.length) && !!V[nr(l)];
  }
  function xs(l) {
    if (!qs(l))
      return Mt(l);
    var u = [];
    for (var p in Object(l))
      gt.call(l, p) && p != "constructor" && u.push(p);
    return u;
  }
  function nn(l, u, p, A, P, k) {
    var z = p & s, H = l.length, tt = u.length;
    if (H != tt && !(z && tt > H))
      return !1;
    var G = k.get(l);
    if (G && k.get(u))
      return G == u;
    var ut = -1, vt = !0, nt = p & i ? new Be() : void 0;
    for (k.set(l, u), k.set(u, l); ++ut < H; ) {
      var ht = l[ut], lt = u[ut];
      if (A)
        var Pe = z ? A(lt, ht, ut, u, l, k) : A(ht, lt, ut, l, u, k);
      if (Pe !== void 0) {
        if (Pe)
          continue;
        vt = !1;
        break;
      }
      if (nt) {
        if (!Xe(u, function(be, ir) {
          if (!Oe(nt, ir) && (ht === be || P(ht, be, p, A, k)))
            return nt.push(ir);
        })) {
          vt = !1;
          break;
        }
      } else if (!(ht === lt || P(ht, lt, p, A, k))) {
        vt = !1;
        break;
      }
    }
    return k.delete(l), k.delete(u), vt;
  }
  function Ns(l, u, p, A, P, k, z) {
    switch (p) {
      case Yt:
        if (l.byteLength != u.byteLength || l.byteOffset != u.byteOffset)
          return !1;
        l = l.buffer, u = u.buffer;
      case ce:
        return !(l.byteLength != u.byteLength || !k(new Or(l), new Or(u)));
      case f:
      case b:
      case w:
        return jn(+l, +u);
      case d:
        return l.name == u.name && l.message == u.message;
      case O:
      case U:
        return l == u + "";
      case v:
        var H = Le;
      case j:
        var tt = A & s;
        if (H || (H = _t), l.size != u.size && !tt)
          return !1;
        var G = z.get(l);
        if (G)
          return G == u;
        A |= i, z.set(l, u);
        var ut = nn(H(l), H(u), A, P, k, z);
        return z.delete(l), ut;
      case W:
        if (er)
          return er.call(l) == er.call(u);
    }
    return !1;
  }
  function _s(l, u, p, A, P, k) {
    var z = p & s, H = sr(l), tt = H.length, G = sr(u), ut = G.length;
    if (tt != ut && !z)
      return !1;
    for (var vt = tt; vt--; ) {
      var nt = H[vt];
      if (!(z ? nt in u : gt.call(u, nt)))
        return !1;
    }
    var ht = k.get(l);
    if (ht && k.get(u))
      return ht == u;
    var lt = !0;
    k.set(l, u), k.set(u, l);
    for (var Pe = z; ++vt < tt; ) {
      nt = H[vt];
      var be = l[nt], ir = u[nt];
      if (A)
        var Vi = z ? A(ir, be, nt, u, l, k) : A(be, ir, nt, l, u, k);
      if (!(Vi === void 0 ? be === ir || P(be, ir, p, A, k) : Vi)) {
        lt = !1;
        break;
      }
      Pe || (Pe = nt == "constructor");
    }
    if (lt && !Pe) {
      var Un = l.constructor, Fn = u.constructor;
      Un != Fn && "constructor" in l && "constructor" in u && !(typeof Un == "function" && Un instanceof Un && typeof Fn == "function" && Fn instanceof Fn) && (lt = !1);
    }
    return k.delete(l), k.delete(u), lt;
  }
  function sr(l) {
    return rn(l, ln, Ss);
  }
  function Dt(l, u) {
    var p = l.__data__;
    return Ls(u) ? p[typeof u == "string" ? "string" : "hash"] : p.map;
  }
  function pe(l, u) {
    var p = Je(l, u);
    return As(p) ? p : void 0;
  }
  function me(l) {
    var u = gt.call(l, yt), p = l[yt];
    try {
      l[yt] = void 0;
      var A = !0;
    } catch {
    }
    var P = Sr.call(l);
    return A && (u ? l[yt] = p : delete l[yt]), P;
  }
  var Ss = wt ? function(l) {
    return l == null ? [] : (l = Object(l), he(wt(l), function(u) {
      return Ie.call(l, u);
    }));
  } : Is, ee = nr;
  (ke && ee(new ke(new ArrayBuffer(1))) != Yt || ge && ee(new ge()) != v || Me && ee(Me.resolve()) != _ || tr && ee(new tr()) != j || je && ee(new je()) != Zt) && (ee = function(l) {
    var u = nr(l), p = u == x ? l.constructor : void 0, A = p ? pt(p) : "";
    if (A)
      switch (A) {
        case Lr:
          return Yt;
        case Bt:
          return v;
        case Cr:
          return _;
        case qr:
          return j;
        case Qr:
          return Zt;
      }
    return u;
  });
  function Os(l, u) {
    return u = u ?? o, !!u && (typeof l == "number" || wr.test(l)) && l > -1 && l % 1 == 0 && l < u;
  }
  function Ls(l) {
    var u = typeof l;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? l !== "__proto__" : l === null;
  }
  function Cs(l) {
    return !!_r && _r in l;
  }
  function qs(l) {
    var u = l && l.constructor, p = typeof u == "function" && u.prototype || Jt;
    return l === p;
  }
  function Mn(l) {
    return Sr.call(l);
  }
  function pt(l) {
    if (l != null) {
      try {
        return qe.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function jn(l, u) {
    return l === u || l !== l && u !== u;
  }
  var Bn = In(/* @__PURE__ */ function() {
    return arguments;
  }()) ? In : function(l) {
    return re(l) && gt.call(l, "callee") && !Ie.call(l, "callee");
  }, Mr = Array.isArray;
  function sn(l) {
    return l != null && on(l.length) && !Pn(l);
  }
  var jr = de || ks;
  function Rs(l, u) {
    return kn(l, u);
  }
  function Pn(l) {
    if (!Dn(l))
      return !1;
    var u = nr(l);
    return u == m || u == y || u == h || u == C;
  }
  function on(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= o;
  }
  function Dn(l) {
    var u = typeof l;
    return l != null && (u == "object" || u == "function");
  }
  function re(l) {
    return l != null && typeof l == "object";
  }
  var $n = Ye ? Se(Ye) : Ts;
  function ln(l) {
    return sn(l) ? Es(l) : xs(l);
  }
  function Is() {
    return [];
  }
  function ks() {
    return !1;
  }
  n.exports = Rs;
})(ns, ns.exports);
var Bl = ns.exports, Ri = {};
Object.defineProperty(Ri, "__esModule", { value: !0 });
const md = jl, bd = Bl;
var ai;
(function(n) {
  function t(i = {}, o = {}, a = !1) {
    typeof i != "object" && (i = {}), typeof o != "object" && (o = {});
    let c = md(o);
    a || (c = Object.keys(c).reduce((h, f) => (c[f] != null && (h[f] = c[f]), h), {}));
    for (const h in i)
      i[h] !== void 0 && o[h] === void 0 && (c[h] = i[h]);
    return Object.keys(c).length > 0 ? c : void 0;
  }
  n.compose = t;
  function e(i = {}, o = {}) {
    typeof i != "object" && (i = {}), typeof o != "object" && (o = {});
    const a = Object.keys(i).concat(Object.keys(o)).reduce((c, h) => (bd(i[h], o[h]) || (c[h] = o[h] === void 0 ? null : o[h]), c), {});
    return Object.keys(a).length > 0 ? a : void 0;
  }
  n.diff = e;
  function r(i = {}, o = {}) {
    i = i || {};
    const a = Object.keys(o).reduce((c, h) => (o[h] !== i[h] && i[h] !== void 0 && (c[h] = o[h]), c), {});
    return Object.keys(i).reduce((c, h) => (i[h] !== o[h] && o[h] === void 0 && (c[h] = null), c), a);
  }
  n.invert = r;
  function s(i, o, a = !1) {
    if (typeof i != "object")
      return o;
    if (typeof o != "object")
      return;
    if (!a)
      return o;
    const c = Object.keys(o).reduce((h, f) => (i[f] === void 0 && (h[f] = o[f]), h), {});
    return Object.keys(c).length > 0 ? c : void 0;
  }
  n.transform = s;
})(ai || (ai = {}));
Ri.default = ai;
var hs = {};
Object.defineProperty(hs, "__esModule", { value: !0 });
var ci;
(function(n) {
  function t(e) {
    return typeof e.delete == "number" ? e.delete : typeof e.retain == "number" ? e.retain : typeof e.retain == "object" && e.retain !== null ? 1 : typeof e.insert == "string" ? e.insert.length : 1;
  }
  n.length = t;
})(ci || (ci = {}));
hs.default = ci;
var Ii = {};
Object.defineProperty(Ii, "__esModule", { value: !0 });
const Lo = hs;
class yd {
  constructor(t) {
    this.ops = t, this.index = 0, this.offset = 0;
  }
  hasNext() {
    return this.peekLength() < 1 / 0;
  }
  next(t) {
    t || (t = 1 / 0);
    const e = this.ops[this.index];
    if (e) {
      const r = this.offset, s = Lo.default.length(e);
      if (t >= s - r ? (t = s - r, this.index += 1, this.offset = 0) : this.offset += t, typeof e.delete == "number")
        return { delete: t };
      {
        const i = {};
        return e.attributes && (i.attributes = e.attributes), typeof e.retain == "number" ? i.retain = t : typeof e.retain == "object" && e.retain !== null ? i.retain = e.retain : typeof e.insert == "string" ? i.insert = e.insert.substr(r, t) : i.insert = e.insert, i;
      }
    } else
      return { retain: 1 / 0 };
  }
  peek() {
    return this.ops[this.index];
  }
  peekLength() {
    return this.ops[this.index] ? Lo.default.length(this.ops[this.index]) - this.offset : 1 / 0;
  }
  peekType() {
    const t = this.ops[this.index];
    return t ? typeof t.delete == "number" ? "delete" : typeof t.retain == "number" || typeof t.retain == "object" && t.retain !== null ? "retain" : "insert" : "retain";
  }
  rest() {
    if (this.hasNext()) {
      if (this.offset === 0)
        return this.ops.slice(this.index);
      {
        const t = this.offset, e = this.index, r = this.next(), s = this.ops.slice(this.index);
        return this.offset = t, this.index = e, [r].concat(s);
      }
    } else return [];
  }
}
Ii.default = yd;
(function(n, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.AttributeMap = t.OpIterator = t.Op = void 0;
  const e = pd, r = jl, s = Bl, i = Ri;
  t.AttributeMap = i.default;
  const o = hs;
  t.Op = o.default;
  const a = Ii;
  t.OpIterator = a.default;
  const c = "\0", h = (b, d) => {
    if (typeof b != "object" || b === null)
      throw new Error(`cannot retain a ${typeof b}`);
    if (typeof d != "object" || d === null)
      throw new Error(`cannot retain a ${typeof d}`);
    const m = Object.keys(b)[0];
    if (!m || m !== Object.keys(d)[0])
      throw new Error(`embed types not matched: ${m} != ${Object.keys(d)[0]}`);
    return [m, b[m], d[m]];
  };
  class f {
    constructor(d) {
      Array.isArray(d) ? this.ops = d : d != null && Array.isArray(d.ops) ? this.ops = d.ops : this.ops = [];
    }
    static registerEmbed(d, m) {
      this.handlers[d] = m;
    }
    static unregisterEmbed(d) {
      delete this.handlers[d];
    }
    static getHandler(d) {
      const m = this.handlers[d];
      if (!m)
        throw new Error(`no handlers for embed type "${d}"`);
      return m;
    }
    insert(d, m) {
      const y = {};
      return typeof d == "string" && d.length === 0 ? this : (y.insert = d, m != null && typeof m == "object" && Object.keys(m).length > 0 && (y.attributes = m), this.push(y));
    }
    delete(d) {
      return d <= 0 ? this : this.push({ delete: d });
    }
    retain(d, m) {
      if (typeof d == "number" && d <= 0)
        return this;
      const y = { retain: d };
      return m != null && typeof m == "object" && Object.keys(m).length > 0 && (y.attributes = m), this.push(y);
    }
    push(d) {
      let m = this.ops.length, y = this.ops[m - 1];
      if (d = r(d), typeof y == "object") {
        if (typeof d.delete == "number" && typeof y.delete == "number")
          return this.ops[m - 1] = { delete: y.delete + d.delete }, this;
        if (typeof y.delete == "number" && d.insert != null && (m -= 1, y = this.ops[m - 1], typeof y != "object"))
          return this.ops.unshift(d), this;
        if (s(d.attributes, y.attributes)) {
          if (typeof d.insert == "string" && typeof y.insert == "string")
            return this.ops[m - 1] = { insert: y.insert + d.insert }, typeof d.attributes == "object" && (this.ops[m - 1].attributes = d.attributes), this;
          if (typeof d.retain == "number" && typeof y.retain == "number")
            return this.ops[m - 1] = { retain: y.retain + d.retain }, typeof d.attributes == "object" && (this.ops[m - 1].attributes = d.attributes), this;
        }
      }
      return m === this.ops.length ? this.ops.push(d) : this.ops.splice(m, 0, d), this;
    }
    chop() {
      const d = this.ops[this.ops.length - 1];
      return d && typeof d.retain == "number" && !d.attributes && this.ops.pop(), this;
    }
    filter(d) {
      return this.ops.filter(d);
    }
    forEach(d) {
      this.ops.forEach(d);
    }
    map(d) {
      return this.ops.map(d);
    }
    partition(d) {
      const m = [], y = [];
      return this.forEach((v) => {
        (d(v) ? m : y).push(v);
      }), [m, y];
    }
    reduce(d, m) {
      return this.ops.reduce(d, m);
    }
    changeLength() {
      return this.reduce((d, m) => m.insert ? d + o.default.length(m) : m.delete ? d - m.delete : d, 0);
    }
    length() {
      return this.reduce((d, m) => d + o.default.length(m), 0);
    }
    slice(d = 0, m = 1 / 0) {
      const y = [], v = new a.default(this.ops);
      let w = 0;
      for (; w < m && v.hasNext(); ) {
        let E;
        w < d ? E = v.next(d - w) : (E = v.next(m - w), y.push(E)), w += o.default.length(E);
      }
      return new f(y);
    }
    compose(d) {
      const m = new a.default(this.ops), y = new a.default(d.ops), v = [], w = y.peek();
      if (w != null && typeof w.retain == "number" && w.attributes == null) {
        let x = w.retain;
        for (; m.peekType() === "insert" && m.peekLength() <= x; )
          x -= m.peekLength(), v.push(m.next());
        w.retain - x > 0 && y.next(w.retain - x);
      }
      const E = new f(v);
      for (; m.hasNext() || y.hasNext(); )
        if (y.peekType() === "insert")
          E.push(y.next());
        else if (m.peekType() === "delete")
          E.push(m.next());
        else {
          const x = Math.min(m.peekLength(), y.peekLength()), _ = m.next(x), C = y.next(x);
          if (C.retain) {
            const O = {};
            if (typeof _.retain == "number")
              O.retain = typeof C.retain == "number" ? x : C.retain;
            else if (typeof C.retain == "number")
              _.retain == null ? O.insert = _.insert : O.retain = _.retain;
            else {
              const U = _.retain == null ? "insert" : "retain", [W, xt, Zt] = h(_[U], C.retain), ce = f.getHandler(W);
              O[U] = {
                [W]: ce.compose(xt, Zt, U === "retain")
              };
            }
            const j = i.default.compose(_.attributes, C.attributes, typeof _.retain == "number");
            if (j && (O.attributes = j), E.push(O), !y.hasNext() && s(E.ops[E.ops.length - 1], O)) {
              const U = new f(m.rest());
              return E.concat(U).chop();
            }
          } else typeof C.delete == "number" && (typeof _.retain == "number" || typeof _.retain == "object" && _.retain !== null) && E.push(C);
        }
      return E.chop();
    }
    concat(d) {
      const m = new f(this.ops.slice());
      return d.ops.length > 0 && (m.push(d.ops[0]), m.ops = m.ops.concat(d.ops.slice(1))), m;
    }
    diff(d, m) {
      if (this.ops === d.ops)
        return new f();
      const y = [this, d].map((_) => _.map((C) => {
        if (C.insert != null)
          return typeof C.insert == "string" ? C.insert : c;
        const O = _ === d ? "on" : "with";
        throw new Error("diff() called " + O + " non-document");
      }).join("")), v = new f(), w = e(y[0], y[1], m, !0), E = new a.default(this.ops), x = new a.default(d.ops);
      return w.forEach((_) => {
        let C = _[1].length;
        for (; C > 0; ) {
          let O = 0;
          switch (_[0]) {
            case e.INSERT:
              O = Math.min(x.peekLength(), C), v.push(x.next(O));
              break;
            case e.DELETE:
              O = Math.min(C, E.peekLength()), E.next(O), v.delete(O);
              break;
            case e.EQUAL:
              O = Math.min(E.peekLength(), x.peekLength(), C);
              const j = E.next(O), U = x.next(O);
              s(j.insert, U.insert) ? v.retain(O, i.default.diff(j.attributes, U.attributes)) : v.push(U).delete(O);
              break;
          }
          C -= O;
        }
      }), v.chop();
    }
    eachLine(d, m = `
`) {
      const y = new a.default(this.ops);
      let v = new f(), w = 0;
      for (; y.hasNext(); ) {
        if (y.peekType() !== "insert")
          return;
        const E = y.peek(), x = o.default.length(E) - y.peekLength(), _ = typeof E.insert == "string" ? E.insert.indexOf(m, x) - x : -1;
        if (_ < 0)
          v.push(y.next());
        else if (_ > 0)
          v.push(y.next(_));
        else {
          if (d(v, y.next(1).attributes || {}, w) === !1)
            return;
          w += 1, v = new f();
        }
      }
      v.length() > 0 && d(v, {}, w);
    }
    invert(d) {
      const m = new f();
      return this.reduce((y, v) => {
        if (v.insert)
          m.delete(o.default.length(v));
        else {
          if (typeof v.retain == "number" && v.attributes == null)
            return m.retain(v.retain), y + v.retain;
          if (v.delete || typeof v.retain == "number") {
            const w = v.delete || v.retain;
            return d.slice(y, y + w).forEach((x) => {
              v.delete ? m.push(x) : v.retain && v.attributes && m.retain(o.default.length(x), i.default.invert(v.attributes, x.attributes));
            }), y + w;
          } else if (typeof v.retain == "object" && v.retain !== null) {
            const w = d.slice(y, y + 1), E = new a.default(w.ops).next(), [x, _, C] = h(v.retain, E.insert), O = f.getHandler(x);
            return m.retain({ [x]: O.invert(_, C) }, i.default.invert(v.attributes, E.attributes)), y + 1;
          }
        }
        return y;
      }, 0), m.chop();
    }
    transform(d, m = !1) {
      if (m = !!m, typeof d == "number")
        return this.transformPosition(d, m);
      const y = d, v = new a.default(this.ops), w = new a.default(y.ops), E = new f();
      for (; v.hasNext() || w.hasNext(); )
        if (v.peekType() === "insert" && (m || w.peekType() !== "insert"))
          E.retain(o.default.length(v.next()));
        else if (w.peekType() === "insert")
          E.push(w.next());
        else {
          const x = Math.min(v.peekLength(), w.peekLength()), _ = v.next(x), C = w.next(x);
          if (_.delete)
            continue;
          if (C.delete)
            E.push(C);
          else {
            const O = _.retain, j = C.retain;
            let U = typeof j == "object" && j !== null ? j : x;
            if (typeof O == "object" && O !== null && typeof j == "object" && j !== null) {
              const W = Object.keys(O)[0];
              if (W === Object.keys(j)[0]) {
                const xt = f.getHandler(W);
                xt && (U = {
                  [W]: xt.transform(O[W], j[W], m)
                });
              }
            }
            E.retain(U, i.default.transform(_.attributes, C.attributes, m));
          }
        }
      return E.chop();
    }
    transformPosition(d, m = !1) {
      m = !!m;
      const y = new a.default(this.ops);
      let v = 0;
      for (; y.hasNext() && v <= d; ) {
        const w = y.peekLength(), E = y.peekType();
        if (y.next(), E === "delete") {
          d -= Math.min(w, d - v);
          continue;
        } else E === "insert" && (v < d || !m) && (d += w);
        v += w;
      }
      return d;
    }
  }
  f.Op = o.default, f.OpIterator = a.default, f.AttributeMap = i.default, f.handlers = {}, t.default = f, n.exports = f, n.exports.default = f;
})(li, li.exports);
var Rt = li.exports;
const R = /* @__PURE__ */ tl(Rt);
class Gt extends Tt {
  static value() {
  }
  optimize() {
    (this.prev || this.next) && this.remove();
  }
  length() {
    return 0;
  }
  value() {
    return "";
  }
}
Gt.blotName = "break";
Gt.tagName = "BR";
let Kt = class extends es {
};
const vd = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function fs(n) {
  return n.replace(/[&<>"']/g, (t) => vd[t]);
}
const ne = class ne extends Oi {
  static compare(t, e) {
    const r = ne.order.indexOf(t), s = ne.order.indexOf(e);
    return r >= 0 || s >= 0 ? r - s : t === e ? 0 : t < e ? -1 : 1;
  }
  formatAt(t, e, r, s) {
    if (ne.compare(this.statics.blotName, r) < 0 && this.scroll.query(r, I.BLOT)) {
      const i = this.isolate(t, e);
      s && i.wrap(r, s);
    } else
      super.formatAt(t, e, r, s);
  }
  optimize(t) {
    if (super.optimize(t), this.parent instanceof ne && ne.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
      const e = this.parent.isolate(this.offset(), this.length());
      this.moveChildren(e), e.wrap(this);
    }
  }
};
L(ne, "allowedChildren", [ne, Gt, Tt, Kt]), // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
L(ne, "order", [
  "cursor",
  "inline",
  // Must be lower
  "link",
  // Chrome wants <a> to be lower
  "underline",
  "strike",
  "italic",
  "bold",
  "script",
  "code"
  // Must be higher
]);
let le = ne;
const Co = 1;
class at extends En {
  constructor() {
    super(...arguments);
    L(this, "cache", {});
  }
  delta() {
    return this.cache.delta == null && (this.cache.delta = Pl(this)), this.cache.delta;
  }
  deleteAt(e, r) {
    super.deleteAt(e, r), this.cache = {};
  }
  formatAt(e, r, s, i) {
    r <= 0 || (this.scroll.query(s, I.BLOCK) ? e + r === this.length() && this.format(s, i) : super.formatAt(e, Math.min(r, this.length() - e - 1), s, i), this.cache = {});
  }
  insertAt(e, r, s) {
    if (s != null) {
      super.insertAt(e, r, s), this.cache = {};
      return;
    }
    if (r.length === 0) return;
    const i = r.split(`
`), o = i.shift();
    o.length > 0 && (e < this.length() - 1 || this.children.tail == null ? super.insertAt(Math.min(e, this.length() - 1), o) : this.children.tail.insertAt(this.children.tail.length(), o), this.cache = {});
    let a = this;
    i.reduce((c, h) => (a = a.split(c, !0), a.insertAt(0, h), h.length), e + o.length);
  }
  insertBefore(e, r) {
    const {
      head: s
    } = this.children;
    super.insertBefore(e, r), s instanceof Gt && s.remove(), this.cache = {};
  }
  length() {
    return this.cache.length == null && (this.cache.length = super.length() + Co), this.cache.length;
  }
  moveChildren(e, r) {
    super.moveChildren(e, r), this.cache = {};
  }
  optimize(e) {
    super.optimize(e), this.cache = {};
  }
  path(e) {
    return super.path(e, !0);
  }
  removeChild(e) {
    super.removeChild(e), this.cache = {};
  }
  split(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (r && (e === 0 || e >= this.length() - Co)) {
      const i = this.clone();
      return e === 0 ? (this.parent.insertBefore(i, this), this) : (this.parent.insertBefore(i, this.next), i);
    }
    const s = super.split(e, r);
    return this.cache = {}, s;
  }
}
at.blotName = "block";
at.tagName = "P";
at.defaultChild = Gt;
at.allowedChildren = [Gt, le, Tt, Kt];
class qt extends Tt {
  attach() {
    super.attach(), this.attributes = new ls(this.domNode);
  }
  delta() {
    return new R().insert(this.value(), {
      ...this.formats(),
      ...this.attributes.values()
    });
  }
  format(t, e) {
    const r = this.scroll.query(t, I.BLOCK_ATTRIBUTE);
    r != null && this.attributes.attribute(r, e);
  }
  formatAt(t, e, r, s) {
    this.format(r, s);
  }
  insertAt(t, e, r) {
    if (r != null) {
      super.insertAt(t, e, r);
      return;
    }
    const s = e.split(`
`), i = s.pop(), o = s.map((c) => {
      const h = this.scroll.create(at.blotName);
      return h.insertAt(0, c), h;
    }), a = this.split(t);
    o.forEach((c) => {
      this.parent.insertBefore(c, a);
    }), i && this.parent.insertBefore(this.scroll.create("text", i), a);
  }
}
qt.scope = I.BLOCK_BLOT;
function Pl(n) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return n.descendants(ft).reduce((e, r) => r.length() === 0 ? e : e.insert(r.value(), Lt(r, {}, t)), new R()).insert(`
`, Lt(n));
}
function Lt(n) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return n == null || ("formats" in n && typeof n.formats == "function" && (t = {
    ...t,
    ...n.formats()
  }, e && delete t["code-token"]), n.parent == null || n.parent.statics.blotName === "scroll" || n.parent.statics.scope !== n.statics.scope) ? t : Lt(n.parent, t, e);
}
const Ot = class Ot extends Tt {
  // Zero width no break space
  static value() {
  }
  constructor(t, e, r) {
    super(t, e), this.selection = r, this.textNode = document.createTextNode(Ot.CONTENTS), this.domNode.appendChild(this.textNode), this.savedLength = 0;
  }
  detach() {
    this.parent != null && this.parent.removeChild(this);
  }
  format(t, e) {
    if (this.savedLength !== 0) {
      super.format(t, e);
      return;
    }
    let r = this, s = 0;
    for (; r != null && r.statics.scope !== I.BLOCK_BLOT; )
      s += r.offset(r.parent), r = r.parent;
    r != null && (this.savedLength = Ot.CONTENTS.length, r.optimize(), r.formatAt(s, Ot.CONTENTS.length, t, e), this.savedLength = 0);
  }
  index(t, e) {
    return t === this.textNode ? 0 : super.index(t, e);
  }
  length() {
    return this.savedLength;
  }
  position() {
    return [this.textNode, this.textNode.data.length];
  }
  remove() {
    super.remove(), this.parent = null;
  }
  restore() {
    if (this.selection.composing || this.parent == null) return null;
    const t = this.selection.getNativeRange();
    for (; this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode; )
      this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
    const e = this.prev instanceof Kt ? this.prev : null, r = e ? e.length() : 0, s = this.next instanceof Kt ? this.next : null, i = s ? s.text : "", {
      textNode: o
    } = this, a = o.data.split(Ot.CONTENTS).join("");
    o.data = Ot.CONTENTS;
    let c;
    if (e)
      c = e, (a || s) && (e.insertAt(e.length(), a + i), s && s.remove());
    else if (s)
      c = s, s.insertAt(0, a);
    else {
      const h = document.createTextNode(a);
      c = this.scroll.create(h), this.parent.insertBefore(c, this);
    }
    if (this.remove(), t) {
      const h = (d, m) => e && d === e.domNode ? m : d === o ? r + m - 1 : s && d === s.domNode ? r + a.length + m : null, f = h(t.start.node, t.start.offset), b = h(t.end.node, t.end.offset);
      if (f !== null && b !== null)
        return {
          startNode: c.domNode,
          startOffset: f,
          endNode: c.domNode,
          endOffset: b
        };
    }
    return null;
  }
  update(t, e) {
    if (t.some((r) => r.type === "characterData" && r.target === this.textNode)) {
      const r = this.restore();
      r && (e.range = r);
    }
  }
  // Avoid .ql-cursor being a descendant of `<a/>`.
  // The reason is Safari pushes down `<a/>` on text insertion.
  // That will cause DOM nodes not sync with the model.
  //
  // For example ({I} is the caret), given the markup:
  //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
  // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
  //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
  // And then "x" will be inserted after `<a/>`:
  //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
  optimize(t) {
    super.optimize(t);
    let {
      parent: e
    } = this;
    for (; e; ) {
      if (e.domNode.tagName === "A") {
        this.savedLength = Ot.CONTENTS.length, e.isolate(this.offset(e), this.length()).unwrap(), this.savedLength = 0;
        break;
      }
      e = e.parent;
    }
  }
  value() {
    return "";
  }
};
L(Ot, "blotName", "cursor"), L(Ot, "className", "ql-cursor"), L(Ot, "tagName", "span"), L(Ot, "CONTENTS", "\uFEFF");
let Wr = Ot;
var Dl = { exports: {} };
(function(n) {
  var t = Object.prototype.hasOwnProperty, e = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (e = !1));
  function s(c, h, f) {
    this.fn = c, this.context = h, this.once = f || !1;
  }
  function i(c, h, f, b, d) {
    if (typeof f != "function")
      throw new TypeError("The listener must be a function");
    var m = new s(f, b || c, d), y = e ? e + h : h;
    return c._events[y] ? c._events[y].fn ? c._events[y] = [c._events[y], m] : c._events[y].push(m) : (c._events[y] = m, c._eventsCount++), c;
  }
  function o(c, h) {
    --c._eventsCount === 0 ? c._events = new r() : delete c._events[h];
  }
  function a() {
    this._events = new r(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var h = [], f, b;
    if (this._eventsCount === 0) return h;
    for (b in f = this._events)
      t.call(f, b) && h.push(e ? b.slice(1) : b);
    return Object.getOwnPropertySymbols ? h.concat(Object.getOwnPropertySymbols(f)) : h;
  }, a.prototype.listeners = function(h) {
    var f = e ? e + h : h, b = this._events[f];
    if (!b) return [];
    if (b.fn) return [b.fn];
    for (var d = 0, m = b.length, y = new Array(m); d < m; d++)
      y[d] = b[d].fn;
    return y;
  }, a.prototype.listenerCount = function(h) {
    var f = e ? e + h : h, b = this._events[f];
    return b ? b.fn ? 1 : b.length : 0;
  }, a.prototype.emit = function(h, f, b, d, m, y) {
    var v = e ? e + h : h;
    if (!this._events[v]) return !1;
    var w = this._events[v], E = arguments.length, x, _;
    if (w.fn) {
      switch (w.once && this.removeListener(h, w.fn, void 0, !0), E) {
        case 1:
          return w.fn.call(w.context), !0;
        case 2:
          return w.fn.call(w.context, f), !0;
        case 3:
          return w.fn.call(w.context, f, b), !0;
        case 4:
          return w.fn.call(w.context, f, b, d), !0;
        case 5:
          return w.fn.call(w.context, f, b, d, m), !0;
        case 6:
          return w.fn.call(w.context, f, b, d, m, y), !0;
      }
      for (_ = 1, x = new Array(E - 1); _ < E; _++)
        x[_ - 1] = arguments[_];
      w.fn.apply(w.context, x);
    } else {
      var C = w.length, O;
      for (_ = 0; _ < C; _++)
        switch (w[_].once && this.removeListener(h, w[_].fn, void 0, !0), E) {
          case 1:
            w[_].fn.call(w[_].context);
            break;
          case 2:
            w[_].fn.call(w[_].context, f);
            break;
          case 3:
            w[_].fn.call(w[_].context, f, b);
            break;
          case 4:
            w[_].fn.call(w[_].context, f, b, d);
            break;
          default:
            if (!x) for (O = 1, x = new Array(E - 1); O < E; O++)
              x[O - 1] = arguments[O];
            w[_].fn.apply(w[_].context, x);
        }
    }
    return !0;
  }, a.prototype.on = function(h, f, b) {
    return i(this, h, f, b, !1);
  }, a.prototype.once = function(h, f, b) {
    return i(this, h, f, b, !0);
  }, a.prototype.removeListener = function(h, f, b, d) {
    var m = e ? e + h : h;
    if (!this._events[m]) return this;
    if (!f)
      return o(this, m), this;
    var y = this._events[m];
    if (y.fn)
      y.fn === f && (!d || y.once) && (!b || y.context === b) && o(this, m);
    else {
      for (var v = 0, w = [], E = y.length; v < E; v++)
        (y[v].fn !== f || d && !y[v].once || b && y[v].context !== b) && w.push(y[v]);
      w.length ? this._events[m] = w.length === 1 ? w[0] : w : o(this, m);
    }
    return this;
  }, a.prototype.removeAllListeners = function(h) {
    var f;
    return h ? (f = e ? e + h : h, this._events[f] && o(this, f)) : (this._events = new r(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = e, a.EventEmitter = a, n.exports = a;
})(Dl);
var Ed = Dl.exports;
const wd = /* @__PURE__ */ tl(Ed), ui = /* @__PURE__ */ new WeakMap(), hi = ["error", "warn", "log", "info"];
let fi = "warn";
function $l(n) {
  if (fi && hi.indexOf(n) <= hi.indexOf(fi)) {
    for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      e[r - 1] = arguments[r];
    console[n](...e);
  }
}
function Te(n) {
  return hi.reduce((t, e) => (t[e] = $l.bind(console, e, n), t), {});
}
Te.level = (n) => {
  fi = n;
};
$l.level = Te.level;
const $s = Te("quill:events"), Ad = ["selectionchange", "mousedown", "mouseup", "click"];
Ad.forEach((n) => {
  document.addEventListener(n, function() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    Array.from(document.querySelectorAll(".ql-container")).forEach((s) => {
      const i = ui.get(s);
      i && i.emitter && i.emitter.handleDOM(...e);
    });
  });
});
class q extends wd {
  constructor() {
    super(), this.domListeners = {}, this.on("error", $s.error);
  }
  emit() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    return $s.log.call($s, ...e), super.emit(...e);
  }
  handleDOM(t) {
    for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), s = 1; s < e; s++)
      r[s - 1] = arguments[s];
    (this.domListeners[t.type] || []).forEach((i) => {
      let {
        node: o,
        handler: a
      } = i;
      (t.target === o || o.contains(t.target)) && a(t, ...r);
    });
  }
  listenDOM(t, e, r) {
    this.domListeners[t] || (this.domListeners[t] = []), this.domListeners[t].push({
      node: e,
      handler: r
    });
  }
}
L(q, "events", {
  EDITOR_CHANGE: "editor-change",
  SCROLL_BEFORE_UPDATE: "scroll-before-update",
  SCROLL_BLOT_MOUNT: "scroll-blot-mount",
  SCROLL_BLOT_UNMOUNT: "scroll-blot-unmount",
  SCROLL_OPTIMIZE: "scroll-optimize",
  SCROLL_UPDATE: "scroll-update",
  SCROLL_EMBED_UPDATE: "scroll-embed-update",
  SELECTION_CHANGE: "selection-change",
  TEXT_CHANGE: "text-change",
  COMPOSITION_BEFORE_START: "composition-before-start",
  COMPOSITION_START: "composition-start",
  COMPOSITION_BEFORE_END: "composition-before-end",
  COMPOSITION_END: "composition-end"
}), L(q, "sources", {
  API: "api",
  SILENT: "silent",
  USER: "user"
});
const Us = Te("quill:selection");
class ar {
  constructor(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.index = t, this.length = e;
  }
}
class Td {
  constructor(t, e) {
    this.emitter = e, this.scroll = t, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = this.scroll.create("cursor", this), this.savedRange = new ar(0, 0), this.lastRange = this.savedRange, this.lastNative = null, this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, () => {
      !this.mouseDown && !this.composing && setTimeout(this.update.bind(this, q.sources.USER), 1);
    }), this.emitter.on(q.events.SCROLL_BEFORE_UPDATE, () => {
      if (!this.hasFocus()) return;
      const r = this.getNativeRange();
      r != null && r.start.node !== this.cursor.textNode && this.emitter.once(q.events.SCROLL_UPDATE, (s, i) => {
        try {
          this.root.contains(r.start.node) && this.root.contains(r.end.node) && this.setNativeRange(r.start.node, r.start.offset, r.end.node, r.end.offset);
          const o = i.some((a) => a.type === "characterData" || a.type === "childList" || a.type === "attributes" && a.target === this.root);
          this.update(o ? q.sources.SILENT : s);
        } catch {
        }
      });
    }), this.emitter.on(q.events.SCROLL_OPTIMIZE, (r, s) => {
      if (s.range) {
        const {
          startNode: i,
          startOffset: o,
          endNode: a,
          endOffset: c
        } = s.range;
        this.setNativeRange(i, o, a, c), this.update(q.sources.SILENT);
      }
    }), this.update(q.sources.SILENT);
  }
  handleComposition() {
    this.emitter.on(q.events.COMPOSITION_BEFORE_START, () => {
      this.composing = !0;
    }), this.emitter.on(q.events.COMPOSITION_END, () => {
      if (this.composing = !1, this.cursor.parent) {
        const t = this.cursor.restore();
        if (!t) return;
        setTimeout(() => {
          this.setNativeRange(t.startNode, t.startOffset, t.endNode, t.endOffset);
        }, 1);
      }
    });
  }
  handleDragging() {
    this.emitter.listenDOM("mousedown", document.body, () => {
      this.mouseDown = !0;
    }), this.emitter.listenDOM("mouseup", document.body, () => {
      this.mouseDown = !1, this.update(q.sources.USER);
    });
  }
  focus() {
    this.hasFocus() || (this.root.focus({
      preventScroll: !0
    }), this.setRange(this.savedRange));
  }
  format(t, e) {
    this.scroll.update();
    const r = this.getNativeRange();
    if (!(r == null || !r.native.collapsed || this.scroll.query(t, I.BLOCK))) {
      if (r.start.node !== this.cursor.textNode) {
        const s = this.scroll.find(r.start.node, !1);
        if (s == null) return;
        if (s instanceof ft) {
          const i = s.split(r.start.offset);
          s.parent.insertBefore(this.cursor, i);
        } else
          s.insertBefore(this.cursor, r.start.node);
        this.cursor.attach();
      }
      this.cursor.format(t, e), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update();
    }
  }
  getBounds(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const r = this.scroll.length();
    t = Math.min(t, r - 1), e = Math.min(t + e, r - 1) - t;
    let s, [i, o] = this.scroll.leaf(t);
    if (i == null) return null;
    if (e > 0 && o === i.length()) {
      const [f] = this.scroll.leaf(t + 1);
      if (f) {
        const [b] = this.scroll.line(t), [d] = this.scroll.line(t + 1);
        b === d && (i = f, o = 0);
      }
    }
    [s, o] = i.position(o, !0);
    const a = document.createRange();
    if (e > 0)
      return a.setStart(s, o), [i, o] = this.scroll.leaf(t + e), i == null ? null : ([s, o] = i.position(o, !0), a.setEnd(s, o), a.getBoundingClientRect());
    let c = "left", h;
    if (s instanceof Text) {
      if (!s.data.length)
        return null;
      o < s.data.length ? (a.setStart(s, o), a.setEnd(s, o + 1)) : (a.setStart(s, o - 1), a.setEnd(s, o), c = "right"), h = a.getBoundingClientRect();
    } else {
      if (!(i.domNode instanceof Element)) return null;
      h = i.domNode.getBoundingClientRect(), o > 0 && (c = "right");
    }
    return {
      bottom: h.top + h.height,
      height: h.height,
      left: h[c],
      right: h[c],
      top: h.top,
      width: 0
    };
  }
  getNativeRange() {
    const t = document.getSelection();
    if (t == null || t.rangeCount <= 0) return null;
    const e = t.getRangeAt(0);
    if (e == null) return null;
    const r = this.normalizeNative(e);
    return Us.info("getNativeRange", r), r;
  }
  getRange() {
    const t = this.scroll.domNode;
    if ("isConnected" in t && !t.isConnected)
      return [null, null];
    const e = this.getNativeRange();
    return e == null ? [null, null] : [this.normalizedToRange(e), e];
  }
  hasFocus() {
    return document.activeElement === this.root || document.activeElement != null && Fs(this.root, document.activeElement);
  }
  normalizedToRange(t) {
    const e = [[t.start.node, t.start.offset]];
    t.native.collapsed || e.push([t.end.node, t.end.offset]);
    const r = e.map((o) => {
      const [a, c] = o, h = this.scroll.find(a, !0), f = h.offset(this.scroll);
      return c === 0 ? f : h instanceof ft ? f + h.index(a, c) : f + h.length();
    }), s = Math.min(Math.max(...r), this.scroll.length() - 1), i = Math.min(s, ...r);
    return new ar(i, s - i);
  }
  normalizeNative(t) {
    if (!Fs(this.root, t.startContainer) || !t.collapsed && !Fs(this.root, t.endContainer))
      return null;
    const e = {
      start: {
        node: t.startContainer,
        offset: t.startOffset
      },
      end: {
        node: t.endContainer,
        offset: t.endOffset
      },
      native: t
    };
    return [e.start, e.end].forEach((r) => {
      let {
        node: s,
        offset: i
      } = r;
      for (; !(s instanceof Text) && s.childNodes.length > 0; )
        if (s.childNodes.length > i)
          s = s.childNodes[i], i = 0;
        else if (s.childNodes.length === i)
          s = s.lastChild, s instanceof Text ? i = s.data.length : s.childNodes.length > 0 ? i = s.childNodes.length : i = s.childNodes.length + 1;
        else
          break;
      r.node = s, r.offset = i;
    }), e;
  }
  rangeToNative(t) {
    const e = this.scroll.length(), r = (s, i) => {
      s = Math.min(e - 1, s);
      const [o, a] = this.scroll.leaf(s);
      return o ? o.position(a, i) : [null, -1];
    };
    return [...r(t.index, !1), ...r(t.index + t.length, !0)];
  }
  setNativeRange(t, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : e, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
    if (Us.info("setNativeRange", t, e, r, s), t != null && (this.root.parentNode == null || t.parentNode == null || // @ts-expect-error Fix me later
    r.parentNode == null))
      return;
    const o = document.getSelection();
    if (o != null)
      if (t != null) {
        this.hasFocus() || this.root.focus({
          preventScroll: !0
        });
        const {
          native: a
        } = this.getNativeRange() || {};
        if (a == null || i || t !== a.startContainer || e !== a.startOffset || r !== a.endContainer || s !== a.endOffset) {
          t instanceof Element && t.tagName === "BR" && (e = Array.from(t.parentNode.childNodes).indexOf(t), t = t.parentNode), r instanceof Element && r.tagName === "BR" && (s = Array.from(r.parentNode.childNodes).indexOf(r), r = r.parentNode);
          const c = document.createRange();
          c.setStart(t, e), c.setEnd(r, s), o.removeAllRanges(), o.addRange(c);
        }
      } else
        o.removeAllRanges(), this.root.blur();
  }
  setRange(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : q.sources.API;
    if (typeof e == "string" && (r = e, e = !1), Us.info("setRange", t), t != null) {
      const s = this.rangeToNative(t);
      this.setNativeRange(...s, e);
    } else
      this.setNativeRange(null);
    this.update(r);
  }
  update() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : q.sources.USER;
    const e = this.lastRange, [r, s] = this.getRange();
    if (this.lastRange = r, this.lastNative = s, this.lastRange != null && (this.savedRange = this.lastRange), !$e(e, this.lastRange)) {
      if (!this.composing && s != null && s.native.collapsed && s.start.node !== this.cursor.textNode) {
        const o = this.cursor.restore();
        o && this.setNativeRange(o.startNode, o.startOffset, o.endNode, o.endOffset);
      }
      const i = [q.events.SELECTION_CHANGE, Hr(this.lastRange), Hr(e), t];
      this.emitter.emit(q.events.EDITOR_CHANGE, ...i), t !== q.sources.SILENT && this.emitter.emit(...i);
    }
  }
}
function Fs(n, t) {
  try {
    t.parentNode;
  } catch {
    return !1;
  }
  return n.contains(t);
}
const xd = /^[ -~]*$/;
class Nd {
  constructor(t) {
    this.scroll = t, this.delta = this.getDelta();
  }
  applyDelta(t) {
    this.scroll.update();
    let e = this.scroll.length();
    this.scroll.batchStart();
    const r = qo(t), s = new R();
    return Sd(r.ops.slice()).reduce((o, a) => {
      const c = Rt.Op.length(a);
      let h = a.attributes || {}, f = !1, b = !1;
      if (a.insert != null) {
        if (s.retain(c), typeof a.insert == "string") {
          const y = a.insert;
          b = !y.endsWith(`
`) && (e <= o || !!this.scroll.descendant(qt, o)[0]), this.scroll.insertAt(o, y);
          const [v, w] = this.scroll.line(o);
          let E = ze({}, Lt(v));
          if (v instanceof at) {
            const [x] = v.descendant(ft, w);
            x && (E = ze(E, Lt(x)));
          }
          h = Rt.AttributeMap.diff(E, h) || {};
        } else if (typeof a.insert == "object") {
          const y = Object.keys(a.insert)[0];
          if (y == null) return o;
          const v = this.scroll.query(y, I.INLINE) != null;
          if (v)
            (e <= o || this.scroll.descendant(qt, o)[0]) && (b = !0);
          else if (o > 0) {
            const [w, E] = this.scroll.descendant(ft, o - 1);
            w instanceof Kt ? w.value()[E] !== `
` && (f = !0) : w instanceof Tt && w.statics.scope === I.INLINE_BLOT && (f = !0);
          }
          if (this.scroll.insertAt(o, y, a.insert[y]), v) {
            const [w] = this.scroll.descendant(ft, o);
            if (w) {
              const E = ze({}, Lt(w));
              h = Rt.AttributeMap.diff(E, h) || {};
            }
          }
        }
        e += c;
      } else if (s.push(a), a.retain !== null && typeof a.retain == "object") {
        const y = Object.keys(a.retain)[0];
        if (y == null) return o;
        this.scroll.updateEmbedAt(o, y, a.retain[y]);
      }
      Object.keys(h).forEach((y) => {
        this.scroll.formatAt(o, c, y, h[y]);
      });
      const d = f ? 1 : 0, m = b ? 1 : 0;
      return e += d + m, s.retain(d), s.delete(m), o + c + d + m;
    }, 0), s.reduce((o, a) => typeof a.delete == "number" ? (this.scroll.deleteAt(o, a.delete), o) : o + Rt.Op.length(a), 0), this.scroll.batchEnd(), this.scroll.optimize(), this.update(r);
  }
  deleteText(t, e) {
    return this.scroll.deleteAt(t, e), this.update(new R().retain(t).delete(e));
  }
  formatLine(t, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.scroll.update(), Object.keys(r).forEach((i) => {
      this.scroll.lines(t, Math.max(e, 1)).forEach((o) => {
        o.format(i, r[i]);
      });
    }), this.scroll.optimize();
    const s = new R().retain(t).retain(e, Hr(r));
    return this.update(s);
  }
  formatText(t, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Object.keys(r).forEach((i) => {
      this.scroll.formatAt(t, e, i, r[i]);
    });
    const s = new R().retain(t).retain(e, Hr(r));
    return this.update(s);
  }
  getContents(t, e) {
    return this.delta.slice(t, t + e);
  }
  getDelta() {
    return this.scroll.lines().reduce((t, e) => t.concat(e.delta()), new R());
  }
  getFormat(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = [], s = [];
    e === 0 ? this.scroll.path(t).forEach((a) => {
      const [c] = a;
      c instanceof at ? r.push(c) : c instanceof ft && s.push(c);
    }) : (r = this.scroll.lines(t, e), s = this.scroll.descendants(ft, t, e));
    const [i, o] = [r, s].map((a) => {
      const c = a.shift();
      if (c == null) return {};
      let h = Lt(c);
      for (; Object.keys(h).length > 0; ) {
        const f = a.shift();
        if (f == null) return h;
        h = _d(Lt(f), h);
      }
      return h;
    });
    return {
      ...i,
      ...o
    };
  }
  getHTML(t, e) {
    const [r, s] = this.scroll.line(t);
    if (r) {
      const i = r.length();
      return r.length() >= s + e && !(s === 0 && e === i) ? An(r, s, e, !0) : An(this.scroll, t, e, !0);
    }
    return "";
  }
  getText(t, e) {
    return this.getContents(t, e).filter((r) => typeof r.insert == "string").map((r) => r.insert).join("");
  }
  insertContents(t, e) {
    const r = qo(e), s = new R().retain(t).concat(r);
    return this.scroll.insertContents(t, r), this.update(s);
  }
  insertEmbed(t, e, r) {
    return this.scroll.insertAt(t, e, r), this.update(new R().retain(t).insert({
      [e]: r
    }));
  }
  insertText(t, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return e = e.replace(/\r\n/g, `
`).replace(/\r/g, `
`), this.scroll.insertAt(t, e), Object.keys(r).forEach((s) => {
      this.scroll.formatAt(t, e.length, s, r[s]);
    }), this.update(new R().retain(t).insert(e, Hr(r)));
  }
  isBlank() {
    if (this.scroll.children.length === 0) return !0;
    if (this.scroll.children.length > 1) return !1;
    const t = this.scroll.children.head;
    if ((t == null ? void 0 : t.statics.blotName) !== at.blotName) return !1;
    const e = t;
    return e.children.length > 1 ? !1 : e.children.head instanceof Gt;
  }
  removeFormat(t, e) {
    const r = this.getText(t, e), [s, i] = this.scroll.line(t + e);
    let o = 0, a = new R();
    s != null && (o = s.length() - i, a = s.delta().slice(i, i + o - 1).insert(`
`));
    const h = this.getContents(t, e + o).diff(new R().insert(r).concat(a)), f = new R().retain(t).concat(h);
    return this.applyDelta(f);
  }
  update(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    const s = this.delta;
    if (e.length === 1 && e[0].type === "characterData" && // @ts-expect-error Fix me later
    e[0].target.data.match(xd) && this.scroll.find(e[0].target)) {
      const i = this.scroll.find(e[0].target), o = Lt(i), a = i.offset(this.scroll), c = e[0].oldValue.replace(Wr.CONTENTS, ""), h = new R().insert(c), f = new R().insert(i.value()), b = r && {
        oldRange: Ro(r.oldRange, -a),
        newRange: Ro(r.newRange, -a)
      };
      t = new R().retain(a).concat(h.diff(f, b)).reduce((m, y) => y.insert ? m.insert(y.insert, o) : m.push(y), new R()), this.delta = s.compose(t);
    } else
      this.delta = this.getDelta(), (!t || !$e(s.compose(t), this.delta)) && (t = s.diff(this.delta, r));
    return t;
  }
}
function Ur(n, t, e) {
  if (n.length === 0) {
    const [m] = Hs(e.pop());
    return t <= 0 ? `</li></${m}>` : `</li></${m}>${Ur([], t - 1, e)}`;
  }
  const [{
    child: r,
    offset: s,
    length: i,
    indent: o,
    type: a
  }, ...c] = n, [h, f] = Hs(a);
  if (o > t)
    return e.push(a), o === t + 1 ? `<${h}><li${f}>${An(r, s, i)}${Ur(c, o, e)}` : `<${h}><li>${Ur(n, t + 1, e)}`;
  const b = e[e.length - 1];
  if (o === t && a === b)
    return `</li><li${f}>${An(r, s, i)}${Ur(c, o, e)}`;
  const [d] = Hs(e.pop());
  return `</li></${d}>${Ur(n, t - 1, e)}`;
}
function An(n, t, e) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if ("html" in n && typeof n.html == "function")
    return n.html(t, e);
  if (n instanceof Kt)
    return fs(n.value().slice(t, t + e)).replaceAll(" ", "&nbsp;");
  if (n instanceof zt) {
    if (n.statics.blotName === "list-container") {
      const h = [];
      return n.children.forEachAt(t, e, (f, b, d) => {
        const m = "formats" in f && typeof f.formats == "function" ? f.formats() : {};
        h.push({
          child: f,
          offset: b,
          length: d,
          indent: m.indent || 0,
          type: m.list
        });
      }), Ur(h, -1, []);
    }
    const s = [];
    if (n.children.forEachAt(t, e, (h, f, b) => {
      s.push(An(h, f, b));
    }), r || n.statics.blotName === "list")
      return s.join("");
    const {
      outerHTML: i,
      innerHTML: o
    } = n.domNode, [a, c] = i.split(`>${o}<`);
    return a === "<table" ? `<table style="border: 1px solid #000;">${s.join("")}<${c}` : `${a}>${s.join("")}<${c}`;
  }
  return n.domNode instanceof Element ? n.domNode.outerHTML : "";
}
function _d(n, t) {
  return Object.keys(t).reduce((e, r) => {
    if (n[r] == null) return e;
    const s = t[r];
    return s === n[r] ? e[r] = s : Array.isArray(s) ? s.indexOf(n[r]) < 0 ? e[r] = s.concat([n[r]]) : e[r] = s : e[r] = [s, n[r]], e;
  }, {});
}
function Hs(n) {
  const t = n === "ordered" ? "ol" : "ul";
  switch (n) {
    case "checked":
      return [t, ' data-list="checked"'];
    case "unchecked":
      return [t, ' data-list="unchecked"'];
    default:
      return [t, ""];
  }
}
function qo(n) {
  return n.reduce((t, e) => {
    if (typeof e.insert == "string") {
      const r = e.insert.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
      return t.insert(r, e.attributes);
    }
    return t.push(e);
  }, new R());
}
function Ro(n, t) {
  let {
    index: e,
    length: r
  } = n;
  return new ar(e + t, r);
}
function Sd(n) {
  const t = [];
  return n.forEach((e) => {
    typeof e.insert == "string" ? e.insert.split(`
`).forEach((s, i) => {
      i && t.push({
        insert: `
`,
        attributes: e.attributes
      }), s && t.push({
        insert: s,
        attributes: e.attributes
      });
    }) : t.push(e);
  }), t;
}
class Wt {
  constructor(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.quill = t, this.options = e;
  }
}
L(Wt, "DEFAULTS", {});
const zn = "\uFEFF";
class ki extends Tt {
  constructor(t, e) {
    super(t, e), this.contentNode = document.createElement("span"), this.contentNode.setAttribute("contenteditable", "false"), Array.from(this.domNode.childNodes).forEach((r) => {
      this.contentNode.appendChild(r);
    }), this.leftGuard = document.createTextNode(zn), this.rightGuard = document.createTextNode(zn), this.domNode.appendChild(this.leftGuard), this.domNode.appendChild(this.contentNode), this.domNode.appendChild(this.rightGuard);
  }
  index(t, e) {
    return t === this.leftGuard ? 0 : t === this.rightGuard ? 1 : super.index(t, e);
  }
  restore(t) {
    let e = null, r;
    const s = t.data.split(zn).join("");
    if (t === this.leftGuard)
      if (this.prev instanceof Kt) {
        const i = this.prev.length();
        this.prev.insertAt(i, s), e = {
          startNode: this.prev.domNode,
          startOffset: i + s.length
        };
      } else
        r = document.createTextNode(s), this.parent.insertBefore(this.scroll.create(r), this), e = {
          startNode: r,
          startOffset: s.length
        };
    else t === this.rightGuard && (this.next instanceof Kt ? (this.next.insertAt(0, s), e = {
      startNode: this.next.domNode,
      startOffset: s.length
    }) : (r = document.createTextNode(s), this.parent.insertBefore(this.scroll.create(r), this.next), e = {
      startNode: r,
      startOffset: s.length
    }));
    return t.data = zn, e;
  }
  update(t, e) {
    t.forEach((r) => {
      if (r.type === "characterData" && (r.target === this.leftGuard || r.target === this.rightGuard)) {
        const s = this.restore(r.target);
        s && (e.range = s);
      }
    });
  }
}
class Od {
  constructor(t, e) {
    L(this, "isComposing", !1);
    this.scroll = t, this.emitter = e, this.setupListeners();
  }
  setupListeners() {
    this.scroll.domNode.addEventListener("compositionstart", (t) => {
      this.isComposing || this.handleCompositionStart(t);
    }), this.scroll.domNode.addEventListener("compositionend", (t) => {
      this.isComposing && queueMicrotask(() => {
        this.handleCompositionEnd(t);
      });
    });
  }
  handleCompositionStart(t) {
    const e = t.target instanceof Node ? this.scroll.find(t.target, !0) : null;
    e && !(e instanceof ki) && (this.emitter.emit(q.events.COMPOSITION_BEFORE_START, t), this.scroll.batchStart(), this.emitter.emit(q.events.COMPOSITION_START, t), this.isComposing = !0);
  }
  handleCompositionEnd(t) {
    this.emitter.emit(q.events.COMPOSITION_BEFORE_END, t), this.scroll.batchEnd(), this.emitter.emit(q.events.COMPOSITION_END, t), this.isComposing = !1;
  }
}
const pn = class pn {
  constructor(t, e) {
    L(this, "modules", {});
    this.quill = t, this.options = e;
  }
  init() {
    Object.keys(this.options.modules).forEach((t) => {
      this.modules[t] == null && this.addModule(t);
    });
  }
  addModule(t) {
    const e = this.quill.constructor.import(`modules/${t}`);
    return this.modules[t] = new e(this.quill, this.options.modules[t] || {}), this.modules[t];
  }
};
L(pn, "DEFAULTS", {
  modules: {}
}), L(pn, "themes", {
  default: pn
});
let Zr = pn;
const Ld = (n) => n.parentElement || n.getRootNode().host || null, Cd = (n) => {
  const t = n.getBoundingClientRect(), e = "offsetWidth" in n && Math.abs(t.width) / n.offsetWidth || 1, r = "offsetHeight" in n && Math.abs(t.height) / n.offsetHeight || 1;
  return {
    top: t.top,
    right: t.left + n.clientWidth * e,
    bottom: t.top + n.clientHeight * r,
    left: t.left
  };
}, Kn = (n) => {
  const t = parseInt(n, 10);
  return Number.isNaN(t) ? 0 : t;
}, Io = (n, t, e, r, s, i) => n < e && t > r ? 0 : n < e ? -(e - n + s) : t > r ? t - n > r - e ? n + s - e : t - r + i : 0, qd = (n, t) => {
  var i, o, a;
  const e = n.ownerDocument;
  let r = t, s = n;
  for (; s; ) {
    const c = s === e.body, h = c ? {
      top: 0,
      right: ((i = window.visualViewport) == null ? void 0 : i.width) ?? e.documentElement.clientWidth,
      bottom: ((o = window.visualViewport) == null ? void 0 : o.height) ?? e.documentElement.clientHeight,
      left: 0
    } : Cd(s), f = getComputedStyle(s), b = Io(r.left, r.right, h.left, h.right, Kn(f.scrollPaddingLeft), Kn(f.scrollPaddingRight)), d = Io(r.top, r.bottom, h.top, h.bottom, Kn(f.scrollPaddingTop), Kn(f.scrollPaddingBottom));
    if (b || d)
      if (c)
        (a = e.defaultView) == null || a.scrollBy(b, d);
      else {
        const {
          scrollLeft: m,
          scrollTop: y
        } = s;
        d && (s.scrollTop += d), b && (s.scrollLeft += b);
        const v = s.scrollLeft - m, w = s.scrollTop - y;
        r = {
          left: r.left - v,
          top: r.top - w,
          right: r.right - v,
          bottom: r.bottom - w
        };
      }
    s = c || f.position === "fixed" ? null : Ld(s);
  }
}, Rd = 100, Id = ["block", "break", "cursor", "inline", "scroll", "text"], kd = (n, t, e) => {
  const r = new Gr();
  return Id.forEach((s) => {
    const i = t.query(s);
    i && r.register(i);
  }), n.forEach((s) => {
    let i = t.query(s);
    i || e.error(`Cannot register "${s}" specified in "formats" config. Are you sure it was registered?`);
    let o = 0;
    for (; i; )
      if (r.register(i), i = "blotName" in i ? i.requiredContainer ?? null : null, o += 1, o > Rd) {
        e.error(`Cycle detected in registering blot requiredContainer: "${s}"`);
        break;
      }
  }), r;
}, Kr = Te("quill"), Vn = new Gr();
zt.uiClass = "ql-ui";
const Ut = class Ut {
  static debug(t) {
    t === !0 && (t = "log"), Te.level(t);
  }
  static find(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return ui.get(t) || Vn.find(t, e);
  }
  static import(t) {
    return this.imports[t] == null && Kr.error(`Cannot import ${t}. Are you sure it was registered?`), this.imports[t];
  }
  static register() {
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) != "string") {
      const t = arguments.length <= 0 ? void 0 : arguments[0], e = !!(!(arguments.length <= 1) && arguments[1]), r = "attrName" in t ? t.attrName : t.blotName;
      typeof r == "string" ? this.register(`formats/${r}`, t, e) : Object.keys(t).forEach((s) => {
        this.register(s, t[s], e);
      });
    } else {
      const t = arguments.length <= 0 ? void 0 : arguments[0], e = arguments.length <= 1 ? void 0 : arguments[1], r = !!(!(arguments.length <= 2) && arguments[2]);
      this.imports[t] != null && !r && Kr.warn(`Overwriting ${t} with`, e), this.imports[t] = e, (t.startsWith("blots/") || t.startsWith("formats/")) && e && typeof e != "boolean" && e.blotName !== "abstract" && Vn.register(e), typeof e.register == "function" && e.register(Vn);
    }
  }
  constructor(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.options = Md(t, e), this.container = this.options.container, this.container == null) {
      Kr.error("Invalid Quill container", t);
      return;
    }
    this.options.debug && Ut.debug(this.options.debug);
    const r = this.container.innerHTML.trim();
    this.container.classList.add("ql-container"), this.container.innerHTML = "", ui.set(this.container, this), this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.emitter = new q();
    const s = Li.blotName, i = this.options.registry.query(s);
    if (!i || !("blotName" in i))
      throw new Error(`Cannot initialize Quill without "${s}" blot`);
    if (this.scroll = new i(this.options.registry, this.root, {
      emitter: this.emitter
    }), this.editor = new Nd(this.scroll), this.selection = new Td(this.scroll, this.emitter), this.composition = new Od(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.uploader = this.theme.addModule("uploader"), this.theme.addModule("input"), this.theme.addModule("uiNode"), this.theme.init(), this.emitter.on(q.events.EDITOR_CHANGE, (o) => {
      o === q.events.TEXT_CHANGE && this.root.classList.toggle("ql-blank", this.editor.isBlank());
    }), this.emitter.on(q.events.SCROLL_UPDATE, (o, a) => {
      const c = this.selection.lastRange, [h] = this.selection.getRange(), f = c && h ? {
        oldRange: c,
        newRange: h
      } : void 0;
      $t.call(this, () => this.editor.update(null, a, f), o);
    }), this.emitter.on(q.events.SCROLL_EMBED_UPDATE, (o, a) => {
      const c = this.selection.lastRange, [h] = this.selection.getRange(), f = c && h ? {
        oldRange: c,
        newRange: h
      } : void 0;
      $t.call(this, () => {
        const b = new R().retain(o.offset(this)).retain({
          [o.statics.blotName]: a
        });
        return this.editor.update(b, [], f);
      }, Ut.sources.USER);
    }), r) {
      const o = this.clipboard.convert({
        html: `${r}<p><br></p>`,
        text: `
`
      });
      this.setContents(o);
    }
    this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable(), this.allowReadOnlyEdits = !1;
  }
  addContainer(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (typeof t == "string") {
      const r = t;
      t = document.createElement("div"), t.classList.add(r);
    }
    return this.container.insertBefore(t, e), t;
  }
  blur() {
    this.selection.setRange(null);
  }
  deleteText(t, e, r) {
    return [t, e, , r] = ye(t, e, r), $t.call(this, () => this.editor.deleteText(t, e), r, t, -1 * e);
  }
  disable() {
    this.enable(!1);
  }
  editReadOnly(t) {
    this.allowReadOnlyEdits = !0;
    const e = t();
    return this.allowReadOnlyEdits = !1, e;
  }
  enable() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.scroll.enable(t), this.container.classList.toggle("ql-disabled", !t);
  }
  focus() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.selection.focus(), t.preventScroll || this.scrollSelectionIntoView();
  }
  format(t, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : q.sources.API;
    return $t.call(this, () => {
      const s = this.getSelection(!0);
      let i = new R();
      if (s == null) return i;
      if (this.scroll.query(t, I.BLOCK))
        i = this.editor.formatLine(s.index, s.length, {
          [t]: e
        });
      else {
        if (s.length === 0)
          return this.selection.format(t, e), i;
        i = this.editor.formatText(s.index, s.length, {
          [t]: e
        });
      }
      return this.setSelection(s, q.sources.SILENT), i;
    }, r);
  }
  formatLine(t, e, r, s, i) {
    let o;
    return [t, e, o, i] = ye(
      t,
      e,
      // @ts-expect-error
      r,
      s,
      i
    ), $t.call(this, () => this.editor.formatLine(t, e, o), i, t, 0);
  }
  formatText(t, e, r, s, i) {
    let o;
    return [t, e, o, i] = ye(
      // @ts-expect-error
      t,
      e,
      r,
      s,
      i
    ), $t.call(this, () => this.editor.formatText(t, e, o), i, t, 0);
  }
  getBounds(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = null;
    if (typeof t == "number" ? r = this.selection.getBounds(t, e) : r = this.selection.getBounds(t.index, t.length), !r) return null;
    const s = this.container.getBoundingClientRect();
    return {
      bottom: r.bottom - s.top,
      height: r.height,
      left: r.left - s.left,
      right: r.right - s.left,
      top: r.top - s.top,
      width: r.width
    };
  }
  getContents() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - t;
    return [t, e] = ye(t, e), this.editor.getContents(t, e);
  }
  getFormat() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(!0), e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return typeof t == "number" ? this.editor.getFormat(t, e) : this.editor.getFormat(t.index, t.length);
  }
  getIndex(t) {
    return t.offset(this.scroll);
  }
  getLength() {
    return this.scroll.length();
  }
  getLeaf(t) {
    return this.scroll.leaf(t);
  }
  getLine(t) {
    return this.scroll.line(t);
  }
  getLines() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
    return typeof t != "number" ? this.scroll.lines(t.index, t.length) : this.scroll.lines(t, e);
  }
  getModule(t) {
    return this.theme.modules[t];
  }
  getSelection() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) && this.focus(), this.update(), this.selection.getRange()[0];
  }
  getSemanticHTML() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 ? arguments[1] : void 0;
    return typeof t == "number" && (e = e ?? this.getLength() - t), [t, e] = ye(t, e), this.editor.getHTML(t, e);
  }
  getText() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 ? arguments[1] : void 0;
    return typeof t == "number" && (e = e ?? this.getLength() - t), [t, e] = ye(t, e), this.editor.getText(t, e);
  }
  hasFocus() {
    return this.selection.hasFocus();
  }
  insertEmbed(t, e, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ut.sources.API;
    return $t.call(this, () => this.editor.insertEmbed(t, e, r), s, t);
  }
  insertText(t, e, r, s, i) {
    let o;
    return [t, , o, i] = ye(t, 0, r, s, i), $t.call(this, () => this.editor.insertText(t, e, o), i, t, e.length);
  }
  isEnabled() {
    return this.scroll.isEnabled();
  }
  off() {
    return this.emitter.off(...arguments);
  }
  on() {
    return this.emitter.on(...arguments);
  }
  once() {
    return this.emitter.once(...arguments);
  }
  removeFormat(t, e, r) {
    return [t, e, , r] = ye(t, e, r), $t.call(this, () => this.editor.removeFormat(t, e), r, t);
  }
  scrollRectIntoView(t) {
    qd(this.root, t);
  }
  /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */
  scrollIntoView() {
    console.warn("Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead."), this.scrollSelectionIntoView();
  }
  /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */
  scrollSelectionIntoView() {
    const t = this.selection.lastRange, e = t && this.selection.getBounds(t.index, t.length);
    e && this.scrollRectIntoView(e);
  }
  setContents(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : q.sources.API;
    return $t.call(this, () => {
      t = new R(t);
      const r = this.getLength(), s = this.editor.deleteText(0, r), i = this.editor.insertContents(0, t), o = this.editor.deleteText(this.getLength() - 1, 1);
      return s.compose(i).compose(o);
    }, e);
  }
  setSelection(t, e, r) {
    t == null ? this.selection.setRange(null, e || Ut.sources.API) : ([t, e, , r] = ye(t, e, r), this.selection.setRange(new ar(Math.max(0, t), e), r), r !== q.sources.SILENT && this.scrollSelectionIntoView());
  }
  setText(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : q.sources.API;
    const r = new R().insert(t);
    return this.setContents(r, e);
  }
  update() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : q.sources.USER;
    const e = this.scroll.update(t);
    return this.selection.update(t), e;
  }
  updateContents(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : q.sources.API;
    return $t.call(this, () => (t = new R(t), this.editor.applyDelta(t)), e, !0);
  }
};
L(Ut, "DEFAULTS", {
  bounds: null,
  modules: {
    clipboard: !0,
    keyboard: !0,
    history: !0,
    uploader: !0
  },
  placeholder: "",
  readOnly: !1,
  registry: Vn,
  theme: "default"
}), L(Ut, "events", q.events), L(Ut, "sources", q.sources), L(Ut, "version", "2.0.3"), L(Ut, "imports", {
  delta: R,
  parchment: id,
  "core/module": Wt,
  "core/theme": Zr
});
let T = Ut;
function ko(n) {
  return typeof n == "string" ? document.querySelector(n) : n;
}
function zs(n) {
  return Object.entries(n ?? {}).reduce((t, e) => {
    let [r, s] = e;
    return {
      ...t,
      [r]: s === !0 ? {} : s
    };
  }, {});
}
function Mo(n) {
  return Object.fromEntries(Object.entries(n).filter((t) => t[1] !== void 0));
}
function Md(n, t) {
  const e = ko(n);
  if (!e)
    throw new Error("Invalid Quill container");
  const s = !t.theme || t.theme === T.DEFAULTS.theme ? Zr : T.import(`themes/${t.theme}`);
  if (!s)
    throw new Error(`Invalid theme ${t.theme}. Did you register it?`);
  const {
    modules: i,
    ...o
  } = T.DEFAULTS, {
    modules: a,
    ...c
  } = s.DEFAULTS;
  let h = zs(t.modules);
  h != null && h.toolbar && h.toolbar.constructor !== Object && (h = {
    ...h,
    toolbar: {
      container: h.toolbar
    }
  });
  const f = ze({}, zs(i), zs(a), h), b = {
    ...o,
    ...Mo(c),
    ...Mo(t)
  };
  let d = t.registry;
  return d ? t.formats && Kr.warn('Ignoring "formats" option because "registry" is specified') : d = t.formats ? kd(t.formats, b.registry, Kr) : b.registry, {
    ...b,
    registry: d,
    container: e,
    theme: s,
    modules: Object.entries(f).reduce((m, y) => {
      let [v, w] = y;
      if (!w) return m;
      const E = T.import(`modules/${v}`);
      return E == null ? (Kr.error(`Cannot load ${v} module. Are you sure you registered it?`), m) : {
        ...m,
        // @ts-expect-error
        [v]: ze({}, E.DEFAULTS || {}, w)
      };
    }, {}),
    bounds: ko(b.bounds)
  };
}
function $t(n, t, e, r) {
  if (!this.isEnabled() && t === q.sources.USER && !this.allowReadOnlyEdits)
    return new R();
  let s = e == null ? null : this.getSelection();
  const i = this.editor.delta, o = n();
  if (s != null && (e === !0 && (e = s.index), r == null ? s = jo(s, o, t) : r !== 0 && (s = jo(s, e, r, t)), this.setSelection(s, q.sources.SILENT)), o.length() > 0) {
    const a = [q.events.TEXT_CHANGE, o, i, t];
    this.emitter.emit(q.events.EDITOR_CHANGE, ...a), t !== q.sources.SILENT && this.emitter.emit(...a);
  }
  return o;
}
function ye(n, t, e, r, s) {
  let i = {};
  return typeof n.index == "number" && typeof n.length == "number" ? typeof t != "number" ? (s = r, r = e, e = t, t = n.length, n = n.index) : (t = n.length, n = n.index) : typeof t != "number" && (s = r, r = e, e = t, t = 0), typeof e == "object" ? (i = e, s = r) : typeof e == "string" && (r != null ? i[e] = r : s = e), s = s || q.sources.API, [n, t, i, s];
}
function jo(n, t, e, r) {
  const s = typeof e == "number" ? e : 0;
  if (n == null) return null;
  let i, o;
  return t && typeof t.transformPosition == "function" ? [i, o] = [n.index, n.index + n.length].map((a) => (
    // @ts-expect-error -- TODO: add a better type guard around `index`
    t.transformPosition(a, r !== q.sources.USER)
  )) : [i, o] = [n.index, n.index + n.length].map((a) => a < t || a === t && r === q.sources.USER ? a : s >= 0 ? a + s : Math.max(t, a + s)), new ar(i, o - i);
}
class fr extends as {
}
function Bo(n) {
  return n instanceof at || n instanceof qt;
}
function Po(n) {
  return typeof n.updateContent == "function";
}
class Fr extends Li {
  constructor(t, e, r) {
    let {
      emitter: s
    } = r;
    super(t, e), this.emitter = s, this.batch = !1, this.optimize(), this.enable(), this.domNode.addEventListener("dragstart", (i) => this.handleDragStart(i));
  }
  batchStart() {
    Array.isArray(this.batch) || (this.batch = []);
  }
  batchEnd() {
    if (!this.batch) return;
    const t = this.batch;
    this.batch = !1, this.update(t);
  }
  emitMount(t) {
    this.emitter.emit(q.events.SCROLL_BLOT_MOUNT, t);
  }
  emitUnmount(t) {
    this.emitter.emit(q.events.SCROLL_BLOT_UNMOUNT, t);
  }
  emitEmbedUpdate(t, e) {
    this.emitter.emit(q.events.SCROLL_EMBED_UPDATE, t, e);
  }
  deleteAt(t, e) {
    const [r, s] = this.line(t), [i] = this.line(t + e);
    if (super.deleteAt(t, e), i != null && r !== i && s > 0) {
      if (r instanceof qt || i instanceof qt) {
        this.optimize();
        return;
      }
      const o = i.children.head instanceof Gt ? null : i.children.head;
      r.moveChildren(i, o), r.remove();
    }
    this.optimize();
  }
  enable() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.domNode.setAttribute("contenteditable", t ? "true" : "false");
  }
  formatAt(t, e, r, s) {
    super.formatAt(t, e, r, s), this.optimize();
  }
  insertAt(t, e, r) {
    if (t >= this.length())
      if (r == null || this.scroll.query(e, I.BLOCK) == null) {
        const s = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(s), r == null && e.endsWith(`
`) ? s.insertAt(0, e.slice(0, -1), r) : s.insertAt(0, e, r);
      } else {
        const s = this.scroll.create(e, r);
        this.appendChild(s);
      }
    else
      super.insertAt(t, e, r);
    this.optimize();
  }
  insertBefore(t, e) {
    if (t.statics.scope === I.INLINE_BLOT) {
      const r = this.scroll.create(this.statics.defaultChild.blotName);
      r.appendChild(t), super.insertBefore(r, e);
    } else
      super.insertBefore(t, e);
  }
  insertContents(t, e) {
    const r = this.deltaToRenderBlocks(e.concat(new R().insert(`
`))), s = r.pop();
    if (s == null) return;
    this.batchStart();
    const i = r.shift();
    if (i) {
      const c = i.type === "block" && (i.delta.length() === 0 || !this.descendant(qt, t)[0] && t < this.length()), h = i.type === "block" ? i.delta : new R().insert({
        [i.key]: i.value
      });
      Ks(this, t, h);
      const f = i.type === "block" ? 1 : 0, b = t + h.length() + f;
      c && this.insertAt(b - 1, `
`);
      const d = Lt(this.line(t)[0]), m = Rt.AttributeMap.diff(d, i.attributes) || {};
      Object.keys(m).forEach((y) => {
        this.formatAt(b - 1, 1, y, m[y]);
      }), t = b;
    }
    let [o, a] = this.children.find(t);
    if (r.length && (o && (o = o.split(a), a = 0), r.forEach((c) => {
      if (c.type === "block") {
        const h = this.createBlock(c.attributes, o || void 0);
        Ks(h, 0, c.delta);
      } else {
        const h = this.create(c.key, c.value);
        this.insertBefore(h, o || void 0), Object.keys(c.attributes).forEach((f) => {
          h.format(f, c.attributes[f]);
        });
      }
    })), s.type === "block" && s.delta.length()) {
      const c = o ? o.offset(o.scroll) + a : this.length();
      Ks(this, c, s.delta);
    }
    this.batchEnd(), this.optimize();
  }
  isEnabled() {
    return this.domNode.getAttribute("contenteditable") === "true";
  }
  leaf(t) {
    const e = this.path(t).pop();
    if (!e)
      return [null, -1];
    const [r, s] = e;
    return r instanceof ft ? [r, s] : [null, -1];
  }
  line(t) {
    return t === this.length() ? this.line(t - 1) : this.descendant(Bo, t);
  }
  lines() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
    const r = (s, i, o) => {
      let a = [], c = o;
      return s.children.forEachAt(i, o, (h, f, b) => {
        Bo(h) ? a.push(h) : h instanceof as && (a = a.concat(r(h, f, c))), c -= b;
      }), a;
    };
    return r(this, t, e);
  }
  optimize() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.batch || (super.optimize(t, e), t.length > 0 && this.emitter.emit(q.events.SCROLL_OPTIMIZE, t, e));
  }
  path(t) {
    return super.path(t).slice(1);
  }
  remove() {
  }
  update(t) {
    if (this.batch) {
      Array.isArray(t) && (this.batch = this.batch.concat(t));
      return;
    }
    let e = q.sources.USER;
    typeof t == "string" && (e = t), Array.isArray(t) || (t = this.observer.takeRecords()), t = t.filter((r) => {
      let {
        target: s
      } = r;
      const i = this.find(s, !0);
      return i && !Po(i);
    }), t.length > 0 && this.emitter.emit(q.events.SCROLL_BEFORE_UPDATE, e, t), super.update(t.concat([])), t.length > 0 && this.emitter.emit(q.events.SCROLL_UPDATE, e, t);
  }
  updateEmbedAt(t, e, r) {
    const [s] = this.descendant((i) => i instanceof qt, t);
    s && s.statics.blotName === e && Po(s) && s.updateContent(r);
  }
  handleDragStart(t) {
    t.preventDefault();
  }
  deltaToRenderBlocks(t) {
    const e = [];
    let r = new R();
    return t.forEach((s) => {
      const i = s == null ? void 0 : s.insert;
      if (i)
        if (typeof i == "string") {
          const o = i.split(`
`);
          o.slice(0, -1).forEach((c) => {
            r.insert(c, s.attributes), e.push({
              type: "block",
              delta: r,
              attributes: s.attributes ?? {}
            }), r = new R();
          });
          const a = o[o.length - 1];
          a && r.insert(a, s.attributes);
        } else {
          const o = Object.keys(i)[0];
          if (!o) return;
          this.query(o, I.INLINE) ? r.push(s) : (r.length() && e.push({
            type: "block",
            delta: r,
            attributes: {}
          }), r = new R(), e.push({
            type: "blockEmbed",
            key: o,
            value: i[o],
            attributes: s.attributes ?? {}
          }));
        }
    }), r.length() && e.push({
      type: "block",
      delta: r,
      attributes: {}
    }), e;
  }
  createBlock(t, e) {
    let r;
    const s = {};
    Object.entries(t).forEach((a) => {
      let [c, h] = a;
      this.query(c, I.BLOCK & I.BLOT) != null ? r = c : s[c] = h;
    });
    const i = this.create(r || this.statics.defaultChild.blotName, r ? t[r] : void 0);
    this.insertBefore(i, e || void 0);
    const o = i.length();
    return Object.entries(s).forEach((a) => {
      let [c, h] = a;
      i.formatAt(0, o, c, h);
    }), i;
  }
}
L(Fr, "blotName", "scroll"), L(Fr, "className", "ql-editor"), L(Fr, "tagName", "DIV"), L(Fr, "defaultChild", at), L(Fr, "allowedChildren", [at, qt, fr]);
function Ks(n, t, e) {
  e.reduce((r, s) => {
    const i = Rt.Op.length(s);
    let o = s.attributes || {};
    if (s.insert != null) {
      if (typeof s.insert == "string") {
        const a = s.insert;
        n.insertAt(r, a);
        const [c] = n.descendant(ft, r), h = Lt(c);
        o = Rt.AttributeMap.diff(h, o) || {};
      } else if (typeof s.insert == "object") {
        const a = Object.keys(s.insert)[0];
        if (a == null) return r;
        if (n.insertAt(r, a, s.insert[a]), n.scroll.query(a, I.INLINE) != null) {
          const [h] = n.descendant(ft, r), f = Lt(h);
          o = Rt.AttributeMap.diff(f, o) || {};
        }
      }
    }
    return Object.keys(o).forEach((a) => {
      n.formatAt(r, i, a, o[a]);
    }), r + i;
  }, t);
}
const Mi = {
  scope: I.BLOCK,
  whitelist: ["right", "center", "justify"]
}, jd = new oe("align", "align", Mi), Ul = new Vt("align", "ql-align", Mi), Fl = new Ge("align", "text-align", Mi);
class Hl extends Ge {
  value(t) {
    let e = super.value(t);
    return e.startsWith("rgb(") ? (e = e.replace(/^[^\d]+/, "").replace(/[^\d]+$/, ""), `#${e.split(",").map((s) => `00${parseInt(s, 10).toString(16)}`.slice(-2)).join("")}`) : e;
  }
}
const Bd = new Vt("color", "ql-color", {
  scope: I.INLINE
}), ji = new Hl("color", "color", {
  scope: I.INLINE
}), Pd = new Vt("background", "ql-bg", {
  scope: I.INLINE
}), Bi = new Hl("background", "background-color", {
  scope: I.INLINE
});
class dr extends fr {
  static create(t) {
    const e = super.create(t);
    return e.setAttribute("spellcheck", "false"), e;
  }
  code(t, e) {
    return this.children.map((r) => r.length() <= 1 ? "" : r.domNode.innerText).join(`
`).slice(t, t + e);
  }
  html(t, e) {
    return `<pre>
${fs(this.code(t, e))}
</pre>`;
  }
}
class dt extends at {
  static register() {
    T.register(dr);
  }
}
L(dt, "TAB", "  ");
class Pi extends le {
}
Pi.blotName = "code";
Pi.tagName = "CODE";
dt.blotName = "code-block";
dt.className = "ql-code-block";
dt.tagName = "DIV";
dr.blotName = "code-block-container";
dr.className = "ql-code-block-container";
dr.tagName = "DIV";
dr.allowedChildren = [dt];
dt.allowedChildren = [Kt, Gt, Wr];
dt.requiredContainer = dr;
const Di = {
  scope: I.BLOCK,
  whitelist: ["rtl"]
}, zl = new oe("direction", "dir", Di), Kl = new Vt("direction", "ql-direction", Di), Vl = new Ge("direction", "direction", Di), Gl = {
  scope: I.INLINE,
  whitelist: ["serif", "monospace"]
}, Wl = new Vt("font", "ql-font", Gl);
class Dd extends Ge {
  value(t) {
    return super.value(t).replace(/["']/g, "");
  }
}
const Zl = new Dd("font", "font-family", Gl), Yl = new Vt("size", "ql-size", {
  scope: I.INLINE,
  whitelist: ["small", "large", "huge"]
}), Xl = new Ge("size", "font-size", {
  scope: I.INLINE,
  whitelist: ["10px", "18px", "32px"]
}), $d = Te("quill:keyboard"), Ud = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
class ds extends Wt {
  static match(t, e) {
    return ["altKey", "ctrlKey", "metaKey", "shiftKey"].some((r) => !!e[r] !== t[r] && e[r] !== null) ? !1 : e.key === t.key || e.key === t.which;
  }
  constructor(t, e) {
    super(t, e), this.bindings = {}, Object.keys(this.options.bindings).forEach((r) => {
      this.options.bindings[r] && this.addBinding(this.options.bindings[r]);
    }), this.addBinding({
      key: "Enter",
      shiftKey: null
    }, this.handleEnter), this.addBinding({
      key: "Enter",
      metaKey: null,
      ctrlKey: null,
      altKey: null
    }, () => {
    }), /Firefox/i.test(navigator.userAgent) ? (this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !0
    }, this.handleBackspace), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !0
    }, this.handleDelete)) : (this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !0,
      prefix: /^.?$/
    }, this.handleBackspace), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !0,
      suffix: /^.?$/
    }, this.handleDelete)), this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !1
    }, this.handleDeleteRange), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !1
    }, this.handleDeleteRange), this.addBinding({
      key: "Backspace",
      altKey: null,
      ctrlKey: null,
      metaKey: null,
      shiftKey: null
    }, {
      collapsed: !0,
      offset: 0
    }, this.handleBackspace), this.listen();
  }
  addBinding(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = Hd(t);
    if (s == null) {
      $d.warn("Attempted to add invalid keyboard binding", s);
      return;
    }
    typeof e == "function" && (e = {
      handler: e
    }), typeof r == "function" && (r = {
      handler: r
    }), (Array.isArray(s.key) ? s.key : [s.key]).forEach((o) => {
      const a = {
        ...s,
        key: o,
        ...e,
        ...r
      };
      this.bindings[a.key] = this.bindings[a.key] || [], this.bindings[a.key].push(a);
    });
  }
  listen() {
    this.quill.root.addEventListener("keydown", (t) => {
      if (t.defaultPrevented || t.isComposing || t.keyCode === 229 && (t.key === "Enter" || t.key === "Backspace")) return;
      const s = (this.bindings[t.key] || []).concat(this.bindings[t.which] || []).filter((E) => ds.match(t, E));
      if (s.length === 0) return;
      const i = T.find(t.target, !0);
      if (i && i.scroll !== this.quill.scroll) return;
      const o = this.quill.getSelection();
      if (o == null || !this.quill.hasFocus()) return;
      const [a, c] = this.quill.getLine(o.index), [h, f] = this.quill.getLeaf(o.index), [b, d] = o.length === 0 ? [h, f] : this.quill.getLeaf(o.index + o.length), m = h instanceof es ? h.value().slice(0, f) : "", y = b instanceof es ? b.value().slice(d) : "", v = {
        collapsed: o.length === 0,
        // @ts-expect-error Fix me later
        empty: o.length === 0 && a.length() <= 1,
        format: this.quill.getFormat(o),
        line: a,
        offset: c,
        prefix: m,
        suffix: y,
        event: t
      };
      s.some((E) => {
        if (E.collapsed != null && E.collapsed !== v.collapsed || E.empty != null && E.empty !== v.empty || E.offset != null && E.offset !== v.offset)
          return !1;
        if (Array.isArray(E.format)) {
          if (E.format.every((x) => v.format[x] == null))
            return !1;
        } else if (typeof E.format == "object" && !Object.keys(E.format).every((x) => E.format[x] === !0 ? v.format[x] != null : E.format[x] === !1 ? v.format[x] == null : $e(E.format[x], v.format[x])))
          return !1;
        return E.prefix != null && !E.prefix.test(v.prefix) || E.suffix != null && !E.suffix.test(v.suffix) ? !1 : E.handler.call(this, o, v, E) !== !0;
      }) && t.preventDefault();
    });
  }
  handleBackspace(t, e) {
    const r = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(e.prefix) ? 2 : 1;
    if (t.index === 0 || this.quill.getLength() <= 1) return;
    let s = {};
    const [i] = this.quill.getLine(t.index);
    let o = new R().retain(t.index - r).delete(r);
    if (e.offset === 0) {
      const [a] = this.quill.getLine(t.index - 1);
      if (a && !(a.statics.blotName === "block" && a.length() <= 1)) {
        const h = i.formats(), f = this.quill.getFormat(t.index - 1, 1);
        if (s = Rt.AttributeMap.diff(h, f) || {}, Object.keys(s).length > 0) {
          const b = new R().retain(t.index + i.length() - 2).retain(1, s);
          o = o.compose(b);
        }
      }
    }
    this.quill.updateContents(o, T.sources.USER), this.quill.focus();
  }
  handleDelete(t, e) {
    const r = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(e.suffix) ? 2 : 1;
    if (t.index >= this.quill.getLength() - r) return;
    let s = {};
    const [i] = this.quill.getLine(t.index);
    let o = new R().retain(t.index).delete(r);
    if (e.offset >= i.length() - 1) {
      const [a] = this.quill.getLine(t.index + 1);
      if (a) {
        const c = i.formats(), h = this.quill.getFormat(t.index, 1);
        s = Rt.AttributeMap.diff(c, h) || {}, Object.keys(s).length > 0 && (o = o.retain(a.length() - 1).retain(1, s));
      }
    }
    this.quill.updateContents(o, T.sources.USER), this.quill.focus();
  }
  handleDeleteRange(t) {
    $i({
      range: t,
      quill: this.quill
    }), this.quill.focus();
  }
  handleEnter(t, e) {
    const r = Object.keys(e.format).reduce((i, o) => (this.quill.scroll.query(o, I.BLOCK) && !Array.isArray(e.format[o]) && (i[o] = e.format[o]), i), {}), s = new R().retain(t.index).delete(t.length).insert(`
`, r);
    this.quill.updateContents(s, T.sources.USER), this.quill.setSelection(t.index + 1, T.sources.SILENT), this.quill.focus();
  }
}
const Fd = {
  bindings: {
    bold: Vs("bold"),
    italic: Vs("italic"),
    underline: Vs("underline"),
    indent: {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: "Tab",
      format: ["blockquote", "indent", "list"],
      handler(n, t) {
        return t.collapsed && t.offset !== 0 ? !0 : (this.quill.format("indent", "+1", T.sources.USER), !1);
      }
    },
    outdent: {
      key: "Tab",
      shiftKey: !0,
      format: ["blockquote", "indent", "list"],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler(n, t) {
        return t.collapsed && t.offset !== 0 ? !0 : (this.quill.format("indent", "-1", T.sources.USER), !1);
      }
    },
    "outdent backspace": {
      key: "Backspace",
      collapsed: !0,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ["indent", "list"],
      offset: 0,
      handler(n, t) {
        t.format.indent != null ? this.quill.format("indent", "-1", T.sources.USER) : t.format.list != null && this.quill.format("list", !1, T.sources.USER);
      }
    },
    "indent code-block": Do(!0),
    "outdent code-block": Do(!1),
    "remove tab": {
      key: "Tab",
      shiftKey: !0,
      collapsed: !0,
      prefix: /\t$/,
      handler(n) {
        this.quill.deleteText(n.index - 1, 1, T.sources.USER);
      }
    },
    tab: {
      key: "Tab",
      handler(n, t) {
        if (t.format.table) return !0;
        this.quill.history.cutoff();
        const e = new R().retain(n.index).delete(n.length).insert("	");
        return this.quill.updateContents(e, T.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(n.index + 1, T.sources.SILENT), !1;
      }
    },
    "blockquote empty enter": {
      key: "Enter",
      collapsed: !0,
      format: ["blockquote"],
      empty: !0,
      handler() {
        this.quill.format("blockquote", !1, T.sources.USER);
      }
    },
    "list empty enter": {
      key: "Enter",
      collapsed: !0,
      format: ["list"],
      empty: !0,
      handler(n, t) {
        const e = {
          list: !1
        };
        t.format.indent && (e.indent = !1), this.quill.formatLine(n.index, n.length, e, T.sources.USER);
      }
    },
    "checklist enter": {
      key: "Enter",
      collapsed: !0,
      format: {
        list: "checked"
      },
      handler(n) {
        const [t, e] = this.quill.getLine(n.index), r = {
          // @ts-expect-error Fix me later
          ...t.formats(),
          list: "checked"
        }, s = new R().retain(n.index).insert(`
`, r).retain(t.length() - e - 1).retain(1, {
          list: "unchecked"
        });
        this.quill.updateContents(s, T.sources.USER), this.quill.setSelection(n.index + 1, T.sources.SILENT), this.quill.scrollSelectionIntoView();
      }
    },
    "header enter": {
      key: "Enter",
      collapsed: !0,
      format: ["header"],
      suffix: /^$/,
      handler(n, t) {
        const [e, r] = this.quill.getLine(n.index), s = new R().retain(n.index).insert(`
`, t.format).retain(e.length() - r - 1).retain(1, {
          header: null
        });
        this.quill.updateContents(s, T.sources.USER), this.quill.setSelection(n.index + 1, T.sources.SILENT), this.quill.scrollSelectionIntoView();
      }
    },
    "table backspace": {
      key: "Backspace",
      format: ["table"],
      collapsed: !0,
      offset: 0,
      handler() {
      }
    },
    "table delete": {
      key: "Delete",
      format: ["table"],
      collapsed: !0,
      suffix: /^$/,
      handler() {
      }
    },
    "table enter": {
      key: "Enter",
      shiftKey: null,
      format: ["table"],
      handler(n) {
        const t = this.quill.getModule("table");
        if (t) {
          const [e, r, s, i] = t.getTable(n), o = zd(e, r, s, i);
          if (o == null) return;
          let a = e.offset();
          if (o < 0) {
            const c = new R().retain(a).insert(`
`);
            this.quill.updateContents(c, T.sources.USER), this.quill.setSelection(n.index + 1, n.length, T.sources.SILENT);
          } else if (o > 0) {
            a += e.length();
            const c = new R().retain(a).insert(`
`);
            this.quill.updateContents(c, T.sources.USER), this.quill.setSelection(a, T.sources.USER);
          }
        }
      }
    },
    "table tab": {
      key: "Tab",
      shiftKey: null,
      format: ["table"],
      handler(n, t) {
        const {
          event: e,
          line: r
        } = t, s = r.offset(this.quill.scroll);
        e.shiftKey ? this.quill.setSelection(s - 1, T.sources.USER) : this.quill.setSelection(s + r.length(), T.sources.USER);
      }
    },
    "list autofill": {
      key: " ",
      shiftKey: null,
      collapsed: !0,
      format: {
        "code-block": !1,
        blockquote: !1,
        table: !1
      },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler(n, t) {
        if (this.quill.scroll.query("list") == null) return !0;
        const {
          length: e
        } = t.prefix, [r, s] = this.quill.getLine(n.index);
        if (s > e) return !0;
        let i;
        switch (t.prefix.trim()) {
          case "[]":
          case "[ ]":
            i = "unchecked";
            break;
          case "[x]":
            i = "checked";
            break;
          case "-":
          case "*":
            i = "bullet";
            break;
          default:
            i = "ordered";
        }
        this.quill.insertText(n.index, " ", T.sources.USER), this.quill.history.cutoff();
        const o = new R().retain(n.index - s).delete(e + 1).retain(r.length() - 2 - s).retain(1, {
          list: i
        });
        return this.quill.updateContents(o, T.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(n.index - e, T.sources.SILENT), !1;
      }
    },
    "code exit": {
      key: "Enter",
      collapsed: !0,
      format: ["code-block"],
      prefix: /^$/,
      suffix: /^\s*$/,
      handler(n) {
        const [t, e] = this.quill.getLine(n.index);
        let r = 2, s = t;
        for (; s != null && s.length() <= 1 && s.formats()["code-block"]; )
          if (s = s.prev, r -= 1, r <= 0) {
            const i = new R().retain(n.index + t.length() - e - 2).retain(1, {
              "code-block": null
            }).delete(1);
            return this.quill.updateContents(i, T.sources.USER), this.quill.setSelection(n.index - 1, T.sources.SILENT), !1;
          }
        return !0;
      }
    },
    "embed left": Gn("ArrowLeft", !1),
    "embed left shift": Gn("ArrowLeft", !0),
    "embed right": Gn("ArrowRight", !1),
    "embed right shift": Gn("ArrowRight", !0),
    "table down": $o(!1),
    "table up": $o(!0)
  }
};
ds.DEFAULTS = Fd;
function Do(n) {
  return {
    key: "Tab",
    shiftKey: !n,
    format: {
      "code-block": !0
    },
    handler(t, e) {
      let {
        event: r
      } = e;
      const s = this.quill.scroll.query("code-block"), {
        TAB: i
      } = s;
      if (t.length === 0 && !r.shiftKey) {
        this.quill.insertText(t.index, i, T.sources.USER), this.quill.setSelection(t.index + i.length, T.sources.SILENT);
        return;
      }
      const o = t.length === 0 ? this.quill.getLines(t.index, 1) : this.quill.getLines(t);
      let {
        index: a,
        length: c
      } = t;
      o.forEach((h, f) => {
        n ? (h.insertAt(0, i), f === 0 ? a += i.length : c += i.length) : h.domNode.textContent.startsWith(i) && (h.deleteAt(0, i.length), f === 0 ? a -= i.length : c -= i.length);
      }), this.quill.update(T.sources.USER), this.quill.setSelection(a, c, T.sources.SILENT);
    }
  };
}
function Gn(n, t) {
  return {
    key: n,
    shiftKey: t,
    altKey: null,
    [n === "ArrowLeft" ? "prefix" : "suffix"]: /^$/,
    handler(r) {
      let {
        index: s
      } = r;
      n === "ArrowRight" && (s += r.length + 1);
      const [i] = this.quill.getLeaf(s);
      return i instanceof Tt ? (n === "ArrowLeft" ? t ? this.quill.setSelection(r.index - 1, r.length + 1, T.sources.USER) : this.quill.setSelection(r.index - 1, T.sources.USER) : t ? this.quill.setSelection(r.index, r.length + 1, T.sources.USER) : this.quill.setSelection(r.index + r.length + 1, T.sources.USER), !1) : !0;
    }
  };
}
function Vs(n) {
  return {
    key: n[0],
    shortKey: !0,
    handler(t, e) {
      this.quill.format(n, !e.format[n], T.sources.USER);
    }
  };
}
function $o(n) {
  return {
    key: n ? "ArrowUp" : "ArrowDown",
    collapsed: !0,
    format: ["table"],
    handler(t, e) {
      const r = n ? "prev" : "next", s = e.line, i = s.parent[r];
      if (i != null) {
        if (i.statics.blotName === "table-row") {
          let o = i.children.head, a = s;
          for (; a.prev != null; )
            a = a.prev, o = o.next;
          const c = o.offset(this.quill.scroll) + Math.min(e.offset, o.length() - 1);
          this.quill.setSelection(c, 0, T.sources.USER);
        }
      } else {
        const o = s.table()[r];
        o != null && (n ? this.quill.setSelection(o.offset(this.quill.scroll) + o.length() - 1, 0, T.sources.USER) : this.quill.setSelection(o.offset(this.quill.scroll), 0, T.sources.USER));
      }
      return !1;
    }
  };
}
function Hd(n) {
  if (typeof n == "string" || typeof n == "number")
    n = {
      key: n
    };
  else if (typeof n == "object")
    n = Hr(n);
  else
    return null;
  return n.shortKey && (n[Ud] = n.shortKey, delete n.shortKey), n;
}
function $i(n) {
  let {
    quill: t,
    range: e
  } = n;
  const r = t.getLines(e);
  let s = {};
  if (r.length > 1) {
    const i = r[0].formats(), o = r[r.length - 1].formats();
    s = Rt.AttributeMap.diff(o, i) || {};
  }
  t.deleteText(e, T.sources.USER), Object.keys(s).length > 0 && t.formatLine(e.index, 1, s, T.sources.USER), t.setSelection(e.index, T.sources.SILENT);
}
function zd(n, t, e, r) {
  return t.prev == null && t.next == null ? e.prev == null && e.next == null ? r === 0 ? -1 : 1 : e.prev == null ? -1 : 1 : t.prev == null ? -1 : t.next == null ? 1 : null;
}
const Kd = /font-weight:\s*normal/, Vd = ["P", "OL", "UL"], Uo = (n) => n && Vd.includes(n.tagName), Gd = (n) => {
  Array.from(n.querySelectorAll("br")).filter((t) => Uo(t.previousElementSibling) && Uo(t.nextElementSibling)).forEach((t) => {
    var e;
    (e = t.parentNode) == null || e.removeChild(t);
  });
}, Wd = (n) => {
  Array.from(n.querySelectorAll('b[style*="font-weight"]')).filter((t) => {
    var e;
    return (e = t.getAttribute("style")) == null ? void 0 : e.match(Kd);
  }).forEach((t) => {
    var r;
    const e = n.createDocumentFragment();
    e.append(...t.childNodes), (r = t.parentNode) == null || r.replaceChild(e, t);
  });
};
function Zd(n) {
  n.querySelector('[id^="docs-internal-guid-"]') && (Wd(n), Gd(n));
}
const Yd = /\bmso-list:[^;]*ignore/i, Xd = /\bmso-list:[^;]*\bl(\d+)/i, Jd = /\bmso-list:[^;]*\blevel(\d+)/i, Qd = (n, t) => {
  const e = n.getAttribute("style"), r = e == null ? void 0 : e.match(Xd);
  if (!r)
    return null;
  const s = Number(r[1]), i = e == null ? void 0 : e.match(Jd), o = i ? Number(i[1]) : 1, a = new RegExp(`@list l${s}:level${o}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, "i"), c = t.match(a), h = c && c[1] === "bullet" ? "bullet" : "ordered";
  return {
    id: s,
    indent: o,
    type: h,
    element: n
  };
}, tg = (n) => {
  var o, a;
  const t = Array.from(n.querySelectorAll("[style*=mso-list]")), e = [], r = [];
  t.forEach((c) => {
    (c.getAttribute("style") || "").match(Yd) ? e.push(c) : r.push(c);
  }), e.forEach((c) => {
    var h;
    return (h = c.parentNode) == null ? void 0 : h.removeChild(c);
  });
  const s = n.documentElement.innerHTML, i = r.map((c) => Qd(c, s)).filter((c) => c);
  for (; i.length; ) {
    const c = [];
    let h = i.shift();
    for (; h; )
      c.push(h), h = i.length && ((o = i[0]) == null ? void 0 : o.element) === h.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
      i[0].id === h.id ? i.shift() : null;
    const f = document.createElement("ul");
    c.forEach((m) => {
      const y = document.createElement("li");
      y.setAttribute("data-list", m.type), m.indent > 1 && y.setAttribute("class", `ql-indent-${m.indent - 1}`), y.innerHTML = m.element.innerHTML, f.appendChild(y);
    });
    const b = (a = c[0]) == null ? void 0 : a.element, {
      parentNode: d
    } = b ?? {};
    b && (d == null || d.replaceChild(f, b)), c.slice(1).forEach((m) => {
      let {
        element: y
      } = m;
      d == null || d.removeChild(y);
    });
  }
};
function eg(n) {
  n.documentElement.getAttribute("xmlns:w") === "urn:schemas-microsoft-com:office:word" && tg(n);
}
const rg = [eg, Zd], ng = (n) => {
  n.documentElement && rg.forEach((t) => {
    t(n);
  });
}, sg = Te("quill:clipboard"), ig = [[Node.TEXT_NODE, bg], [Node.TEXT_NODE, Ho], ["br", ug], [Node.ELEMENT_NODE, Ho], [Node.ELEMENT_NODE, cg], [Node.ELEMENT_NODE, ag], [Node.ELEMENT_NODE, pg], ["li", dg], ["ol, ul", gg], ["pre", hg], ["tr", mg], ["b", Gs("bold")], ["i", Gs("italic")], ["strike", Gs("strike")], ["style", fg]], og = [jd, zl].reduce((n, t) => (n[t.keyName] = t, n), {}), Fo = [Fl, Bi, ji, Vl, Zl, Xl].reduce((n, t) => (n[t.keyName] = t, n), {});
class Jl extends Wt {
  constructor(t, e) {
    super(t, e), this.quill.root.addEventListener("copy", (r) => this.onCaptureCopy(r, !1)), this.quill.root.addEventListener("cut", (r) => this.onCaptureCopy(r, !0)), this.quill.root.addEventListener("paste", this.onCapturePaste.bind(this)), this.matchers = [], ig.concat(this.options.matchers ?? []).forEach((r) => {
      let [s, i] = r;
      this.addMatcher(s, i);
    });
  }
  addMatcher(t, e) {
    this.matchers.push([t, e]);
  }
  convert(t) {
    let {
      html: e,
      text: r
    } = t, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (s[dt.blotName])
      return new R().insert(r || "", {
        [dt.blotName]: s[dt.blotName]
      });
    if (!e)
      return new R().insert(r || "", s);
    const i = this.convertHTML(e);
    return On(i, `
`) && (i.ops[i.ops.length - 1].attributes == null || s.table) ? i.compose(new R().retain(i.length() - 1).delete(1)) : i;
  }
  normalizeHTML(t) {
    ng(t);
  }
  convertHTML(t) {
    const e = new DOMParser().parseFromString(t, "text/html");
    this.normalizeHTML(e);
    const r = e.body, s = /* @__PURE__ */ new WeakMap(), [i, o] = this.prepareMatching(r, s);
    return Ui(this.quill.scroll, r, i, o, s);
  }
  dangerouslyPasteHTML(t, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : T.sources.API;
    if (typeof t == "string") {
      const s = this.convert({
        html: t,
        text: ""
      });
      this.quill.setContents(s, e), this.quill.setSelection(0, T.sources.SILENT);
    } else {
      const s = this.convert({
        html: e,
        text: ""
      });
      this.quill.updateContents(new R().retain(t).concat(s), r), this.quill.setSelection(t + s.length(), T.sources.SILENT);
    }
  }
  onCaptureCopy(t) {
    var o, a;
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (t.defaultPrevented) return;
    t.preventDefault();
    const [r] = this.quill.selection.getRange();
    if (r == null) return;
    const {
      html: s,
      text: i
    } = this.onCopy(r, e);
    (o = t.clipboardData) == null || o.setData("text/plain", i), (a = t.clipboardData) == null || a.setData("text/html", s), e && $i({
      range: r,
      quill: this.quill
    });
  }
  /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */
  normalizeURIList(t) {
    return t.split(/\r?\n/).filter((e) => e[0] !== "#").join(`
`);
  }
  onCapturePaste(t) {
    var o, a, c, h, f;
    if (t.defaultPrevented || !this.quill.isEnabled()) return;
    t.preventDefault();
    const e = this.quill.getSelection(!0);
    if (e == null) return;
    const r = (o = t.clipboardData) == null ? void 0 : o.getData("text/html");
    let s = (a = t.clipboardData) == null ? void 0 : a.getData("text/plain");
    if (!r && !s) {
      const b = (c = t.clipboardData) == null ? void 0 : c.getData("text/uri-list");
      b && (s = this.normalizeURIList(b));
    }
    const i = Array.from(((h = t.clipboardData) == null ? void 0 : h.files) || []);
    if (!r && i.length > 0) {
      this.quill.uploader.upload(e, i);
      return;
    }
    if (r && i.length > 0) {
      const b = new DOMParser().parseFromString(r, "text/html");
      if (b.body.childElementCount === 1 && ((f = b.body.firstElementChild) == null ? void 0 : f.tagName) === "IMG") {
        this.quill.uploader.upload(e, i);
        return;
      }
    }
    this.onPaste(e, {
      html: r,
      text: s
    });
  }
  onCopy(t) {
    const e = this.quill.getText(t);
    return {
      html: this.quill.getSemanticHTML(t),
      text: e
    };
  }
  onPaste(t, e) {
    let {
      text: r,
      html: s
    } = e;
    const i = this.quill.getFormat(t.index), o = this.convert({
      text: r,
      html: s
    }, i);
    sg.log("onPaste", o, {
      text: r,
      html: s
    });
    const a = new R().retain(t.index).delete(t.length).concat(o);
    this.quill.updateContents(a, T.sources.USER), this.quill.setSelection(a.length() - t.length, T.sources.SILENT), this.quill.scrollSelectionIntoView();
  }
  prepareMatching(t, e) {
    const r = [], s = [];
    return this.matchers.forEach((i) => {
      const [o, a] = i;
      switch (o) {
        case Node.TEXT_NODE:
          s.push(a);
          break;
        case Node.ELEMENT_NODE:
          r.push(a);
          break;
        default:
          Array.from(t.querySelectorAll(o)).forEach((c) => {
            if (e.has(c)) {
              const h = e.get(c);
              h == null || h.push(a);
            } else
              e.set(c, [a]);
          });
          break;
      }
    }), [r, s];
  }
}
L(Jl, "DEFAULTS", {
  matchers: []
});
function gr(n, t, e, r) {
  return r.query(t) ? n.reduce((s, i) => {
    if (!i.insert) return s;
    if (i.attributes && i.attributes[t])
      return s.push(i);
    const o = e ? {
      [t]: e
    } : {};
    return s.insert(i.insert, {
      ...o,
      ...i.attributes
    });
  }, new R()) : n;
}
function On(n, t) {
  let e = "";
  for (let r = n.ops.length - 1; r >= 0 && e.length < t.length; --r) {
    const s = n.ops[r];
    if (typeof s.insert != "string") break;
    e = s.insert + e;
  }
  return e.slice(-1 * t.length) === t;
}
function Fe(n, t) {
  if (!(n instanceof Element)) return !1;
  const e = t.query(n);
  return e && e.prototype instanceof Tt ? !1 : ["address", "article", "blockquote", "canvas", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "iframe", "li", "main", "nav", "ol", "output", "p", "pre", "section", "table", "td", "tr", "ul", "video"].includes(n.tagName.toLowerCase());
}
function lg(n, t) {
  return n.previousElementSibling && n.nextElementSibling && !Fe(n.previousElementSibling, t) && !Fe(n.nextElementSibling, t);
}
const Wn = /* @__PURE__ */ new WeakMap();
function Ql(n) {
  return n == null ? !1 : (Wn.has(n) || (n.tagName === "PRE" ? Wn.set(n, !0) : Wn.set(n, Ql(n.parentNode))), Wn.get(n));
}
function Ui(n, t, e, r, s) {
  return t.nodeType === t.TEXT_NODE ? r.reduce((i, o) => o(t, i, n), new R()) : t.nodeType === t.ELEMENT_NODE ? Array.from(t.childNodes || []).reduce((i, o) => {
    let a = Ui(n, o, e, r, s);
    return o.nodeType === t.ELEMENT_NODE && (a = e.reduce((c, h) => h(o, c, n), a), a = (s.get(o) || []).reduce((c, h) => h(o, c, n), a)), i.concat(a);
  }, new R()) : new R();
}
function Gs(n) {
  return (t, e, r) => gr(e, n, !0, r);
}
function ag(n, t, e) {
  const r = oe.keys(n), s = Vt.keys(n), i = Ge.keys(n), o = {};
  return r.concat(s).concat(i).forEach((a) => {
    let c = e.query(a, I.ATTRIBUTE);
    c != null && (o[c.attrName] = c.value(n), o[c.attrName]) || (c = og[a], c != null && (c.attrName === a || c.keyName === a) && (o[c.attrName] = c.value(n) || void 0), c = Fo[a], c != null && (c.attrName === a || c.keyName === a) && (c = Fo[a], o[c.attrName] = c.value(n) || void 0));
  }), Object.entries(o).reduce((a, c) => {
    let [h, f] = c;
    return gr(a, h, f, e);
  }, t);
}
function cg(n, t, e) {
  const r = e.query(n);
  if (r == null) return t;
  if (r.prototype instanceof Tt) {
    const s = {}, i = r.value(n);
    if (i != null)
      return s[r.blotName] = i, new R().insert(s, r.formats(n, e));
  } else if (r.prototype instanceof En && !On(t, `
`) && t.insert(`
`), "blotName" in r && "formats" in r && typeof r.formats == "function")
    return gr(t, r.blotName, r.formats(n, e), e);
  return t;
}
function ug(n, t) {
  return On(t, `
`) || t.insert(`
`), t;
}
function hg(n, t, e) {
  const r = e.query("code-block"), s = r && "formats" in r && typeof r.formats == "function" ? r.formats(n, e) : !0;
  return gr(t, "code-block", s, e);
}
function fg() {
  return new R();
}
function dg(n, t, e) {
  const r = e.query(n);
  if (r == null || // @ts-expect-error
  r.blotName !== "list" || !On(t, `
`))
    return t;
  let s = -1, i = n.parentNode;
  for (; i != null; )
    ["OL", "UL"].includes(i.tagName) && (s += 1), i = i.parentNode;
  return s <= 0 ? t : t.reduce((o, a) => a.insert ? a.attributes && typeof a.attributes.indent == "number" ? o.push(a) : o.insert(a.insert, {
    indent: s,
    ...a.attributes || {}
  }) : o, new R());
}
function gg(n, t, e) {
  const r = n;
  let s = r.tagName === "OL" ? "ordered" : "bullet";
  const i = r.getAttribute("data-checked");
  return i && (s = i === "true" ? "checked" : "unchecked"), gr(t, "list", s, e);
}
function Ho(n, t, e) {
  if (!On(t, `
`)) {
    if (Fe(n, e) && (n.childNodes.length > 0 || n instanceof HTMLParagraphElement))
      return t.insert(`
`);
    if (t.length() > 0 && n.nextSibling) {
      let r = n.nextSibling;
      for (; r != null; ) {
        if (Fe(r, e))
          return t.insert(`
`);
        const s = e.query(r);
        if (s && s.prototype instanceof qt)
          return t.insert(`
`);
        r = r.firstChild;
      }
    }
  }
  return t;
}
function pg(n, t, e) {
  var i;
  const r = {}, s = n.style || {};
  return s.fontStyle === "italic" && (r.italic = !0), s.textDecoration === "underline" && (r.underline = !0), s.textDecoration === "line-through" && (r.strike = !0), ((i = s.fontWeight) != null && i.startsWith("bold") || // @ts-expect-error Fix me later
  parseInt(s.fontWeight, 10) >= 700) && (r.bold = !0), t = Object.entries(r).reduce((o, a) => {
    let [c, h] = a;
    return gr(o, c, h, e);
  }, t), parseFloat(s.textIndent || 0) > 0 ? new R().insert("	").concat(t) : t;
}
function mg(n, t, e) {
  var s, i;
  const r = ((s = n.parentElement) == null ? void 0 : s.tagName) === "TABLE" ? n.parentElement : (i = n.parentElement) == null ? void 0 : i.parentElement;
  if (r != null) {
    const a = Array.from(r.querySelectorAll("tr")).indexOf(n) + 1;
    return gr(t, "table", a, e);
  }
  return t;
}
function bg(n, t, e) {
  var s;
  let r = n.data;
  if (((s = n.parentElement) == null ? void 0 : s.tagName) === "O:P")
    return t.insert(r.trim());
  if (!Ql(n)) {
    if (r.trim().length === 0 && r.includes(`
`) && !lg(n, e))
      return t;
    r = r.replace(/[^\S\u00a0]/g, " "), r = r.replace(/ {2,}/g, " "), (n.previousSibling == null && n.parentElement != null && Fe(n.parentElement, e) || n.previousSibling instanceof Element && Fe(n.previousSibling, e)) && (r = r.replace(/^ /, "")), (n.nextSibling == null && n.parentElement != null && Fe(n.parentElement, e) || n.nextSibling instanceof Element && Fe(n.nextSibling, e)) && (r = r.replace(/ $/, "")), r = r.replaceAll(" ", " ");
  }
  return t.insert(r);
}
class ta extends Wt {
  constructor(e, r) {
    super(e, r);
    L(this, "lastRecorded", 0);
    L(this, "ignoreChange", !1);
    L(this, "stack", {
      undo: [],
      redo: []
    });
    L(this, "currentRange", null);
    this.quill.on(T.events.EDITOR_CHANGE, (s, i, o, a) => {
      s === T.events.SELECTION_CHANGE ? i && a !== T.sources.SILENT && (this.currentRange = i) : s === T.events.TEXT_CHANGE && (this.ignoreChange || (!this.options.userOnly || a === T.sources.USER ? this.record(i, o) : this.transform(i)), this.currentRange = di(this.currentRange, i));
    }), this.quill.keyboard.addBinding({
      key: "z",
      shortKey: !0
    }, this.undo.bind(this)), this.quill.keyboard.addBinding({
      key: ["z", "Z"],
      shortKey: !0,
      shiftKey: !0
    }, this.redo.bind(this)), /Win/i.test(navigator.platform) && this.quill.keyboard.addBinding({
      key: "y",
      shortKey: !0
    }, this.redo.bind(this)), this.quill.root.addEventListener("beforeinput", (s) => {
      s.inputType === "historyUndo" ? (this.undo(), s.preventDefault()) : s.inputType === "historyRedo" && (this.redo(), s.preventDefault());
    });
  }
  change(e, r) {
    if (this.stack[e].length === 0) return;
    const s = this.stack[e].pop();
    if (!s) return;
    const i = this.quill.getContents(), o = s.delta.invert(i);
    this.stack[r].push({
      delta: o,
      range: di(s.range, o)
    }), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(s.delta, T.sources.USER), this.ignoreChange = !1, this.restoreSelection(s);
  }
  clear() {
    this.stack = {
      undo: [],
      redo: []
    };
  }
  cutoff() {
    this.lastRecorded = 0;
  }
  record(e, r) {
    if (e.ops.length === 0) return;
    this.stack.redo = [];
    let s = e.invert(r), i = this.currentRange;
    const o = Date.now();
    if (
      // @ts-expect-error Fix me later
      this.lastRecorded + this.options.delay > o && this.stack.undo.length > 0
    ) {
      const a = this.stack.undo.pop();
      a && (s = s.compose(a.delta), i = a.range);
    } else
      this.lastRecorded = o;
    s.length() !== 0 && (this.stack.undo.push({
      delta: s,
      range: i
    }), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift());
  }
  redo() {
    this.change("redo", "undo");
  }
  transform(e) {
    zo(this.stack.undo, e), zo(this.stack.redo, e);
  }
  undo() {
    this.change("undo", "redo");
  }
  restoreSelection(e) {
    if (e.range)
      this.quill.setSelection(e.range, T.sources.USER);
    else {
      const r = vg(this.quill.scroll, e.delta);
      this.quill.setSelection(r, T.sources.USER);
    }
  }
}
L(ta, "DEFAULTS", {
  delay: 1e3,
  maxStack: 100,
  userOnly: !1
});
function zo(n, t) {
  let e = t;
  for (let r = n.length - 1; r >= 0; r -= 1) {
    const s = n[r];
    n[r] = {
      delta: e.transform(s.delta, !0),
      range: s.range && di(s.range, e)
    }, e = s.delta.transform(e), n[r].delta.length() === 0 && n.splice(r, 1);
  }
}
function yg(n, t) {
  const e = t.ops[t.ops.length - 1];
  return e == null ? !1 : e.insert != null ? typeof e.insert == "string" && e.insert.endsWith(`
`) : e.attributes != null ? Object.keys(e.attributes).some((r) => n.query(r, I.BLOCK) != null) : !1;
}
function vg(n, t) {
  const e = t.reduce((s, i) => s + (i.delete || 0), 0);
  let r = t.length() - e;
  return yg(n, t) && (r -= 1), r;
}
function di(n, t) {
  if (!n) return n;
  const e = t.transformPosition(n.index), r = t.transformPosition(n.index + n.length);
  return {
    index: e,
    length: r - e
  };
}
class ea extends Wt {
  constructor(t, e) {
    super(t, e), t.root.addEventListener("drop", (r) => {
      var o;
      r.preventDefault();
      let s = null;
      if (document.caretRangeFromPoint)
        s = document.caretRangeFromPoint(r.clientX, r.clientY);
      else if (document.caretPositionFromPoint) {
        const a = document.caretPositionFromPoint(r.clientX, r.clientY);
        s = document.createRange(), s.setStart(a.offsetNode, a.offset), s.setEnd(a.offsetNode, a.offset);
      }
      const i = s && t.selection.normalizeNative(s);
      if (i) {
        const a = t.selection.normalizedToRange(i);
        (o = r.dataTransfer) != null && o.files && this.upload(a, r.dataTransfer.files);
      }
    });
  }
  upload(t, e) {
    const r = [];
    Array.from(e).forEach((s) => {
      var i;
      s && ((i = this.options.mimetypes) != null && i.includes(s.type)) && r.push(s);
    }), r.length > 0 && this.options.handler.call(this, t, r);
  }
}
ea.DEFAULTS = {
  mimetypes: ["image/png", "image/jpeg"],
  handler(n, t) {
    if (!this.quill.scroll.query("image"))
      return;
    const e = t.map((r) => new Promise((s) => {
      const i = new FileReader();
      i.onload = () => {
        s(i.result);
      }, i.readAsDataURL(r);
    }));
    Promise.all(e).then((r) => {
      const s = r.reduce((i, o) => i.insert({
        image: o
      }), new R().retain(n.index).delete(n.length));
      this.quill.updateContents(s, q.sources.USER), this.quill.setSelection(n.index + r.length, q.sources.SILENT);
    });
  }
};
const Eg = ["insertText", "insertReplacementText"];
class wg extends Wt {
  constructor(t, e) {
    super(t, e), t.root.addEventListener("beforeinput", (r) => {
      this.handleBeforeInput(r);
    }), /Android/i.test(navigator.userAgent) || t.on(T.events.COMPOSITION_BEFORE_START, () => {
      this.handleCompositionStart();
    });
  }
  deleteRange(t) {
    $i({
      range: t,
      quill: this.quill
    });
  }
  replaceText(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (t.length === 0) return !1;
    if (e) {
      const r = this.quill.getFormat(t.index, 1);
      this.deleteRange(t), this.quill.updateContents(new R().retain(t.index).insert(e, r), T.sources.USER);
    } else
      this.deleteRange(t);
    return this.quill.setSelection(t.index + e.length, 0, T.sources.SILENT), !0;
  }
  handleBeforeInput(t) {
    if (this.quill.composition.isComposing || t.defaultPrevented || !Eg.includes(t.inputType))
      return;
    const e = t.getTargetRanges ? t.getTargetRanges()[0] : null;
    if (!e || e.collapsed === !0)
      return;
    const r = Ag(t);
    if (r == null)
      return;
    const s = this.quill.selection.normalizeNative(e), i = s ? this.quill.selection.normalizedToRange(s) : null;
    i && this.replaceText(i, r) && t.preventDefault();
  }
  handleCompositionStart() {
    const t = this.quill.getSelection();
    t && this.replaceText(t);
  }
}
function Ag(n) {
  var t;
  return typeof n.data == "string" ? n.data : (t = n.dataTransfer) != null && t.types.includes("text/plain") ? n.dataTransfer.getData("text/plain") : null;
}
const Tg = /Mac/i.test(navigator.platform), xg = 100, Ng = (n) => !!(n.key === "ArrowLeft" || n.key === "ArrowRight" || // RTL scripts or moving from the end of the previous line
n.key === "ArrowUp" || n.key === "ArrowDown" || n.key === "Home" || Tg && n.key === "a" && n.ctrlKey === !0);
class _g extends Wt {
  constructor(e, r) {
    super(e, r);
    L(this, "isListening", !1);
    L(this, "selectionChangeDeadline", 0);
    this.handleArrowKeys(), this.handleNavigationShortcuts();
  }
  handleArrowKeys() {
    this.quill.keyboard.addBinding({
      key: ["ArrowLeft", "ArrowRight"],
      offset: 0,
      shiftKey: null,
      handler(e, r) {
        let {
          line: s,
          event: i
        } = r;
        if (!(s instanceof zt) || !s.uiNode)
          return !0;
        const o = getComputedStyle(s.domNode).direction === "rtl";
        return o && i.key !== "ArrowRight" || !o && i.key !== "ArrowLeft" ? !0 : (this.quill.setSelection(e.index - 1, e.length + (i.shiftKey ? 1 : 0), T.sources.USER), !1);
      }
    });
  }
  handleNavigationShortcuts() {
    this.quill.root.addEventListener("keydown", (e) => {
      !e.defaultPrevented && Ng(e) && this.ensureListeningToSelectionChange();
    });
  }
  /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */
  ensureListeningToSelectionChange() {
    if (this.selectionChangeDeadline = Date.now() + xg, this.isListening) return;
    this.isListening = !0;
    const e = () => {
      this.isListening = !1, Date.now() <= this.selectionChangeDeadline && this.handleSelectionChange();
    };
    document.addEventListener("selectionchange", e, {
      once: !0
    });
  }
  handleSelectionChange() {
    const e = document.getSelection();
    if (!e) return;
    const r = e.getRangeAt(0);
    if (r.collapsed !== !0 || r.startOffset !== 0) return;
    const s = this.quill.scroll.find(r.startContainer);
    if (!(s instanceof zt) || !s.uiNode) return;
    const i = document.createRange();
    i.setStartAfter(s.uiNode), i.setEndAfter(s.uiNode), e.removeAllRanges(), e.addRange(i);
  }
}
T.register({
  "blots/block": at,
  "blots/block/embed": qt,
  "blots/break": Gt,
  "blots/container": fr,
  "blots/cursor": Wr,
  "blots/embed": ki,
  "blots/inline": le,
  "blots/scroll": Fr,
  "blots/text": Kt,
  "modules/clipboard": Jl,
  "modules/history": ta,
  "modules/keyboard": ds,
  "modules/uploader": ea,
  "modules/input": wg,
  "modules/uiNode": _g
});
class Sg extends Vt {
  add(t, e) {
    let r = 0;
    if (e === "+1" || e === "-1") {
      const s = this.value(t) || 0;
      r = e === "+1" ? s + 1 : s - 1;
    } else typeof e == "number" && (r = e);
    return r === 0 ? (this.remove(t), !0) : super.add(t, r.toString());
  }
  canAdd(t, e) {
    return super.canAdd(t, e) || super.canAdd(t, parseInt(e, 10));
  }
  value(t) {
    return parseInt(super.value(t), 10) || void 0;
  }
}
const Og = new Sg("indent", "ql-indent", {
  scope: I.BLOCK,
  // @ts-expect-error
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});
class gi extends at {
}
L(gi, "blotName", "blockquote"), L(gi, "tagName", "blockquote");
class pi extends at {
  static formats(t) {
    return this.tagName.indexOf(t.tagName) + 1;
  }
}
L(pi, "blotName", "header"), L(pi, "tagName", ["H1", "H2", "H3", "H4", "H5", "H6"]);
class Ln extends fr {
}
Ln.blotName = "list-container";
Ln.tagName = "OL";
class Cn extends at {
  static create(t) {
    const e = super.create();
    return e.setAttribute("data-list", t), e;
  }
  static formats(t) {
    return t.getAttribute("data-list") || void 0;
  }
  static register() {
    T.register(Ln);
  }
  constructor(t, e) {
    super(t, e);
    const r = e.ownerDocument.createElement("span"), s = (i) => {
      if (!t.isEnabled()) return;
      const o = this.statics.formats(e, t);
      o === "checked" ? (this.format("list", "unchecked"), i.preventDefault()) : o === "unchecked" && (this.format("list", "checked"), i.preventDefault());
    };
    r.addEventListener("mousedown", s), r.addEventListener("touchstart", s), this.attachUI(r);
  }
  format(t, e) {
    t === this.statics.blotName && e ? this.domNode.setAttribute("data-list", e) : super.format(t, e);
  }
}
Cn.blotName = "list";
Cn.tagName = "LI";
Ln.allowedChildren = [Cn];
Cn.requiredContainer = Ln;
class Tn extends le {
  static create() {
    return super.create();
  }
  static formats() {
    return !0;
  }
  optimize(t) {
    super.optimize(t), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName);
  }
}
L(Tn, "blotName", "bold"), L(Tn, "tagName", ["STRONG", "B"]);
class mi extends Tn {
}
L(mi, "blotName", "italic"), L(mi, "tagName", ["EM", "I"]);
class He extends le {
  static create(t) {
    const e = super.create(t);
    return e.setAttribute("href", this.sanitize(t)), e.setAttribute("rel", "noopener noreferrer"), e.setAttribute("target", "_blank"), e;
  }
  static formats(t) {
    return t.getAttribute("href");
  }
  static sanitize(t) {
    return ra(t, this.PROTOCOL_WHITELIST) ? t : this.SANITIZED_URL;
  }
  format(t, e) {
    t !== this.statics.blotName || !e ? super.format(t, e) : this.domNode.setAttribute("href", this.constructor.sanitize(e));
  }
}
L(He, "blotName", "link"), L(He, "tagName", "A"), L(He, "SANITIZED_URL", "about:blank"), L(He, "PROTOCOL_WHITELIST", ["http", "https", "mailto", "tel", "sms"]);
function ra(n, t) {
  const e = document.createElement("a");
  e.href = n;
  const r = e.href.slice(0, e.href.indexOf(":"));
  return t.indexOf(r) > -1;
}
class bi extends le {
  static create(t) {
    return t === "super" ? document.createElement("sup") : t === "sub" ? document.createElement("sub") : super.create(t);
  }
  static formats(t) {
    if (t.tagName === "SUB") return "sub";
    if (t.tagName === "SUP") return "super";
  }
}
L(bi, "blotName", "script"), L(bi, "tagName", ["SUB", "SUP"]);
class yi extends Tn {
}
L(yi, "blotName", "strike"), L(yi, "tagName", ["S", "STRIKE"]);
class vi extends le {
}
L(vi, "blotName", "underline"), L(vi, "tagName", "U");
class Yn extends ki {
  static create(t) {
    if (window.katex == null)
      throw new Error("Formula module requires KaTeX.");
    const e = super.create(t);
    return typeof t == "string" && (window.katex.render(t, e, {
      throwOnError: !1,
      errorColor: "#f00"
    }), e.setAttribute("data-value", t)), e;
  }
  static value(t) {
    return t.getAttribute("data-value");
  }
  html() {
    const {
      formula: t
    } = this.value();
    return `<span>${t}</span>`;
  }
}
L(Yn, "blotName", "formula"), L(Yn, "className", "ql-formula"), L(Yn, "tagName", "SPAN");
const Ko = ["alt", "height", "width"];
class Ei extends Tt {
  static create(t) {
    const e = super.create(t);
    return typeof t == "string" && e.setAttribute("src", this.sanitize(t)), e;
  }
  static formats(t) {
    return Ko.reduce((e, r) => (t.hasAttribute(r) && (e[r] = t.getAttribute(r)), e), {});
  }
  static match(t) {
    return /\.(jpe?g|gif|png)$/.test(t) || /^data:image\/.+;base64/.test(t);
  }
  static sanitize(t) {
    return ra(t, ["http", "https", "data"]) ? t : "//:0";
  }
  static value(t) {
    return t.getAttribute("src");
  }
  format(t, e) {
    Ko.indexOf(t) > -1 ? e ? this.domNode.setAttribute(t, e) : this.domNode.removeAttribute(t) : super.format(t, e);
  }
}
L(Ei, "blotName", "image"), L(Ei, "tagName", "IMG");
const Vo = ["height", "width"];
class Xn extends qt {
  static create(t) {
    const e = super.create(t);
    return e.setAttribute("frameborder", "0"), e.setAttribute("allowfullscreen", "true"), e.setAttribute("src", this.sanitize(t)), e;
  }
  static formats(t) {
    return Vo.reduce((e, r) => (t.hasAttribute(r) && (e[r] = t.getAttribute(r)), e), {});
  }
  static sanitize(t) {
    return He.sanitize(t);
  }
  static value(t) {
    return t.getAttribute("src");
  }
  format(t, e) {
    Vo.indexOf(t) > -1 ? e ? this.domNode.setAttribute(t, e) : this.domNode.removeAttribute(t) : super.format(t, e);
  }
  html() {
    const {
      video: t
    } = this.value();
    return `<a href="${t}">${t}</a>`;
  }
}
L(Xn, "blotName", "video"), L(Xn, "className", "ql-video"), L(Xn, "tagName", "IFRAME");
const fn = new Vt("code-token", "hljs", {
  scope: I.INLINE
});
class Ee extends le {
  static formats(t, e) {
    for (; t != null && t !== e.domNode; ) {
      if (t.classList && t.classList.contains(dt.className))
        return super.formats(t, e);
      t = t.parentNode;
    }
  }
  constructor(t, e, r) {
    super(t, e, r), fn.add(this.domNode, r);
  }
  format(t, e) {
    t !== Ee.blotName ? super.format(t, e) : e ? fn.add(this.domNode, e) : (fn.remove(this.domNode), this.domNode.classList.remove(this.statics.className));
  }
  optimize() {
    super.optimize(...arguments), fn.value(this.domNode) || this.unwrap();
  }
}
Ee.blotName = "code-token";
Ee.className = "ql-token";
class Ct extends dt {
  static create(t) {
    const e = super.create(t);
    return typeof t == "string" && e.setAttribute("data-language", t), e;
  }
  static formats(t) {
    return t.getAttribute("data-language") || "plain";
  }
  static register() {
  }
  // Syntax module will register
  format(t, e) {
    t === this.statics.blotName && e ? this.domNode.setAttribute("data-language", e) : super.format(t, e);
  }
  replaceWith(t, e) {
    return this.formatAt(0, this.length(), Ee.blotName, !1), super.replaceWith(t, e);
  }
}
class gn extends dr {
  attach() {
    super.attach(), this.forceNext = !1, this.scroll.emitMount(this);
  }
  format(t, e) {
    t === Ct.blotName && (this.forceNext = !0, this.children.forEach((r) => {
      r.format(t, e);
    }));
  }
  formatAt(t, e, r, s) {
    r === Ct.blotName && (this.forceNext = !0), super.formatAt(t, e, r, s);
  }
  highlight(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (this.children.head == null) return;
    const s = `${Array.from(this.domNode.childNodes).filter((o) => o !== this.uiNode).map((o) => o.textContent).join(`
`)}
`, i = Ct.formats(this.children.head.domNode);
    if (e || this.forceNext || this.cachedText !== s) {
      if (s.trim().length > 0 || this.cachedText == null) {
        const o = this.children.reduce((c, h) => c.concat(Pl(h, !1)), new R()), a = t(s, i);
        o.diff(a).reduce((c, h) => {
          let {
            retain: f,
            attributes: b
          } = h;
          return f ? (b && Object.keys(b).forEach((d) => {
            [Ct.blotName, Ee.blotName].includes(d) && this.formatAt(c, f, d, b[d]);
          }), c + f) : c;
        }, 0);
      }
      this.cachedText = s, this.forceNext = !1;
    }
  }
  html(t, e) {
    const [r] = this.children.find(t);
    return `<pre data-language="${r ? Ct.formats(r.domNode) : "plain"}">
${fs(this.code(t, e))}
</pre>`;
  }
  optimize(t) {
    if (super.optimize(t), this.parent != null && this.children.head != null && this.uiNode != null) {
      const e = Ct.formats(this.children.head.domNode);
      e !== this.uiNode.value && (this.uiNode.value = e);
    }
  }
}
gn.allowedChildren = [Ct];
Ct.requiredContainer = gn;
Ct.allowedChildren = [Ee, Wr, Kt, Gt];
const Lg = (n, t, e) => {
  if (typeof n.versionString == "string") {
    const r = n.versionString.split(".")[0];
    if (parseInt(r, 10) >= 11)
      return n.highlight(e, {
        language: t
      }).value;
  }
  return n.highlight(t, e).value;
};
class na extends Wt {
  static register() {
    T.register(Ee, !0), T.register(Ct, !0), T.register(gn, !0);
  }
  constructor(t, e) {
    if (super(t, e), this.options.hljs == null)
      throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
    this.languages = this.options.languages.reduce((r, s) => {
      let {
        key: i
      } = s;
      return r[i] = !0, r;
    }, {}), this.highlightBlot = this.highlightBlot.bind(this), this.initListener(), this.initTimer();
  }
  initListener() {
    this.quill.on(T.events.SCROLL_BLOT_MOUNT, (t) => {
      if (!(t instanceof gn)) return;
      const e = this.quill.root.ownerDocument.createElement("select");
      this.options.languages.forEach((r) => {
        let {
          key: s,
          label: i
        } = r;
        const o = e.ownerDocument.createElement("option");
        o.textContent = i, o.setAttribute("value", s), e.appendChild(o);
      }), e.addEventListener("change", () => {
        t.format(Ct.blotName, e.value), this.quill.root.focus(), this.highlight(t, !0);
      }), t.uiNode == null && (t.attachUI(e), t.children.head && (e.value = Ct.formats(t.children.head.domNode)));
    });
  }
  initTimer() {
    let t = null;
    this.quill.on(T.events.SCROLL_OPTIMIZE, () => {
      t && clearTimeout(t), t = setTimeout(() => {
        this.highlight(), t = null;
      }, this.options.interval);
    });
  }
  highlight() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (this.quill.selection.composing) return;
    this.quill.update(T.sources.USER);
    const r = this.quill.getSelection();
    (t == null ? this.quill.scroll.descendants(gn) : [t]).forEach((i) => {
      i.highlight(this.highlightBlot, e);
    }), this.quill.update(T.sources.SILENT), r != null && this.quill.setSelection(r, T.sources.SILENT);
  }
  highlightBlot(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "plain";
    if (e = this.languages[e] ? e : "plain", e === "plain")
      return fs(t).split(`
`).reduce((s, i, o) => (o !== 0 && s.insert(`
`, {
        [dt.blotName]: e
      }), s.insert(i)), new R());
    const r = this.quill.root.ownerDocument.createElement("div");
    return r.classList.add(dt.className), r.innerHTML = Lg(this.options.hljs, e, t), Ui(this.quill.scroll, r, [(s, i) => {
      const o = fn.value(s);
      return o ? i.compose(new R().retain(i.length(), {
        [Ee.blotName]: o
      })) : i;
    }], [(s, i) => s.data.split(`
`).reduce((o, a, c) => (c !== 0 && o.insert(`
`, {
      [dt.blotName]: e
    }), o.insert(a)), i)], /* @__PURE__ */ new WeakMap());
  }
}
na.DEFAULTS = {
  hljs: window.hljs,
  interval: 1e3,
  languages: [{
    key: "plain",
    label: "Plain"
  }, {
    key: "bash",
    label: "Bash"
  }, {
    key: "cpp",
    label: "C++"
  }, {
    key: "cs",
    label: "C#"
  }, {
    key: "css",
    label: "CSS"
  }, {
    key: "diff",
    label: "Diff"
  }, {
    key: "xml",
    label: "HTML/XML"
  }, {
    key: "java",
    label: "Java"
  }, {
    key: "javascript",
    label: "JavaScript"
  }, {
    key: "markdown",
    label: "Markdown"
  }, {
    key: "php",
    label: "PHP"
  }, {
    key: "python",
    label: "Python"
  }, {
    key: "ruby",
    label: "Ruby"
  }, {
    key: "sql",
    label: "SQL"
  }]
};
const mn = class mn extends at {
  static create(t) {
    const e = super.create();
    return t ? e.setAttribute("data-row", t) : e.setAttribute("data-row", Fi()), e;
  }
  static formats(t) {
    if (t.hasAttribute("data-row"))
      return t.getAttribute("data-row");
  }
  cellOffset() {
    return this.parent ? this.parent.children.indexOf(this) : -1;
  }
  format(t, e) {
    t === mn.blotName && e ? this.domNode.setAttribute("data-row", e) : super.format(t, e);
  }
  row() {
    return this.parent;
  }
  rowOffset() {
    return this.row() ? this.row().rowOffset() : -1;
  }
  table() {
    return this.row() && this.row().table();
  }
};
L(mn, "blotName", "table"), L(mn, "tagName", "TD");
let Ht = mn;
class we extends fr {
  checkMerge() {
    if (super.checkMerge() && this.next.children.head != null) {
      const t = this.children.head.formats(), e = this.children.tail.formats(), r = this.next.children.head.formats(), s = this.next.children.tail.formats();
      return t.table === e.table && t.table === r.table && t.table === s.table;
    }
    return !1;
  }
  optimize(t) {
    super.optimize(t), this.children.forEach((e) => {
      if (e.next == null) return;
      const r = e.formats(), s = e.next.formats();
      if (r.table !== s.table) {
        const i = this.splitAfter(e);
        i && i.optimize(), this.prev && this.prev.optimize();
      }
    });
  }
  rowOffset() {
    return this.parent ? this.parent.children.indexOf(this) : -1;
  }
  table() {
    return this.parent && this.parent.parent;
  }
}
L(we, "blotName", "table-row"), L(we, "tagName", "TR");
class ie extends fr {
}
L(ie, "blotName", "table-body"), L(ie, "tagName", "TBODY");
class Yr extends fr {
  balanceCells() {
    const t = this.descendants(we), e = t.reduce((r, s) => Math.max(s.children.length, r), 0);
    t.forEach((r) => {
      new Array(e - r.children.length).fill(0).forEach(() => {
        let s;
        r.children.head != null && (s = Ht.formats(r.children.head.domNode));
        const i = this.scroll.create(Ht.blotName, s);
        r.appendChild(i), i.optimize();
      });
    });
  }
  cells(t) {
    return this.rows().map((e) => e.children.at(t));
  }
  deleteColumn(t) {
    const [e] = this.descendant(ie);
    e == null || e.children.head == null || e.children.forEach((r) => {
      const s = r.children.at(t);
      s != null && s.remove();
    });
  }
  insertColumn(t) {
    const [e] = this.descendant(ie);
    e == null || e.children.head == null || e.children.forEach((r) => {
      const s = r.children.at(t), i = Ht.formats(r.children.head.domNode), o = this.scroll.create(Ht.blotName, i);
      r.insertBefore(o, s);
    });
  }
  insertRow(t) {
    const [e] = this.descendant(ie);
    if (e == null || e.children.head == null) return;
    const r = Fi(), s = this.scroll.create(we.blotName);
    e.children.head.children.forEach(() => {
      const o = this.scroll.create(Ht.blotName, r);
      s.appendChild(o);
    });
    const i = e.children.at(t);
    e.insertBefore(s, i);
  }
  rows() {
    const t = this.children.head;
    return t == null ? [] : t.children.map((e) => e);
  }
}
L(Yr, "blotName", "table-container"), L(Yr, "tagName", "TABLE");
Yr.allowedChildren = [ie];
ie.requiredContainer = Yr;
ie.allowedChildren = [we];
we.requiredContainer = ie;
we.allowedChildren = [Ht];
Ht.requiredContainer = we;
function Fi() {
  return `row-${Math.random().toString(36).slice(2, 6)}`;
}
class Cg extends Wt {
  static register() {
    T.register(Ht), T.register(we), T.register(ie), T.register(Yr);
  }
  constructor() {
    super(...arguments), this.listenBalanceCells();
  }
  balanceTables() {
    this.quill.scroll.descendants(Yr).forEach((t) => {
      t.balanceCells();
    });
  }
  deleteColumn() {
    const [t, , e] = this.getTable();
    e != null && (t.deleteColumn(e.cellOffset()), this.quill.update(T.sources.USER));
  }
  deleteRow() {
    const [, t] = this.getTable();
    t != null && (t.remove(), this.quill.update(T.sources.USER));
  }
  deleteTable() {
    const [t] = this.getTable();
    if (t == null) return;
    const e = t.offset();
    t.remove(), this.quill.update(T.sources.USER), this.quill.setSelection(e, T.sources.SILENT);
  }
  getTable() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.quill.getSelection();
    if (t == null) return [null, null, null, -1];
    const [e, r] = this.quill.getLine(t.index);
    if (e == null || e.statics.blotName !== Ht.blotName)
      return [null, null, null, -1];
    const s = e.parent;
    return [s.parent.parent, s, e, r];
  }
  insertColumn(t) {
    const e = this.quill.getSelection();
    if (!e) return;
    const [r, s, i] = this.getTable(e);
    if (i == null) return;
    const o = i.cellOffset();
    r.insertColumn(o + t), this.quill.update(T.sources.USER);
    let a = s.rowOffset();
    t === 0 && (a += 1), this.quill.setSelection(e.index + a, e.length, T.sources.SILENT);
  }
  insertColumnLeft() {
    this.insertColumn(0);
  }
  insertColumnRight() {
    this.insertColumn(1);
  }
  insertRow(t) {
    const e = this.quill.getSelection();
    if (!e) return;
    const [r, s, i] = this.getTable(e);
    if (i == null) return;
    const o = s.rowOffset();
    r.insertRow(o + t), this.quill.update(T.sources.USER), t > 0 ? this.quill.setSelection(e, T.sources.SILENT) : this.quill.setSelection(e.index + s.children.length, e.length, T.sources.SILENT);
  }
  insertRowAbove() {
    this.insertRow(0);
  }
  insertRowBelow() {
    this.insertRow(1);
  }
  insertTable(t, e) {
    const r = this.quill.getSelection();
    if (r == null) return;
    const s = new Array(t).fill(0).reduce((i) => {
      const o = new Array(e).fill(`
`).join("");
      return i.insert(o, {
        table: Fi()
      });
    }, new R().retain(r.index));
    this.quill.updateContents(s, T.sources.USER), this.quill.setSelection(r.index, T.sources.SILENT), this.balanceTables();
  }
  listenBalanceCells() {
    this.quill.on(T.events.SCROLL_OPTIMIZE, (t) => {
      t.some((e) => ["TD", "TR", "TBODY", "TABLE"].includes(e.target.tagName) ? (this.quill.once(T.events.TEXT_CHANGE, (r, s, i) => {
        i === T.sources.USER && this.balanceTables();
      }), !0) : !1);
    });
  }
}
const Go = Te("quill:toolbar");
class Hi extends Wt {
  constructor(t, e) {
    var r, s;
    if (super(t, e), Array.isArray(this.options.container)) {
      const i = document.createElement("div");
      i.setAttribute("role", "toolbar"), qg(i, this.options.container), (s = (r = t.container) == null ? void 0 : r.parentNode) == null || s.insertBefore(i, t.container), this.container = i;
    } else typeof this.options.container == "string" ? this.container = document.querySelector(this.options.container) : this.container = this.options.container;
    if (!(this.container instanceof HTMLElement)) {
      Go.error("Container required for toolbar", this.options);
      return;
    }
    this.container.classList.add("ql-toolbar"), this.controls = [], this.handlers = {}, this.options.handlers && Object.keys(this.options.handlers).forEach((i) => {
      var a;
      const o = (a = this.options.handlers) == null ? void 0 : a[i];
      o && this.addHandler(i, o);
    }), Array.from(this.container.querySelectorAll("button, select")).forEach((i) => {
      this.attach(i);
    }), this.quill.on(T.events.EDITOR_CHANGE, () => {
      const [i] = this.quill.selection.getRange();
      this.update(i);
    });
  }
  addHandler(t, e) {
    this.handlers[t] = e;
  }
  attach(t) {
    let e = Array.from(t.classList).find((s) => s.indexOf("ql-") === 0);
    if (!e) return;
    if (e = e.slice(3), t.tagName === "BUTTON" && t.setAttribute("type", "button"), this.handlers[e] == null && this.quill.scroll.query(e) == null) {
      Go.warn("ignoring attaching to nonexistent format", e, t);
      return;
    }
    const r = t.tagName === "SELECT" ? "change" : "click";
    t.addEventListener(r, (s) => {
      let i;
      if (t.tagName === "SELECT") {
        if (t.selectedIndex < 0) return;
        const a = t.options[t.selectedIndex];
        a.hasAttribute("selected") ? i = !1 : i = a.value || !1;
      } else
        t.classList.contains("ql-active") ? i = !1 : i = t.value || !t.hasAttribute("value"), s.preventDefault();
      this.quill.focus();
      const [o] = this.quill.selection.getRange();
      if (this.handlers[e] != null)
        this.handlers[e].call(this, i);
      else if (
        // @ts-expect-error
        this.quill.scroll.query(e).prototype instanceof Tt
      ) {
        if (i = prompt(`Enter ${e}`), !i) return;
        this.quill.updateContents(new R().retain(o.index).delete(o.length).insert({
          [e]: i
        }), T.sources.USER);
      } else
        this.quill.format(e, i, T.sources.USER);
      this.update(o);
    }), this.controls.push([e, t]);
  }
  update(t) {
    const e = t == null ? {} : this.quill.getFormat(t);
    this.controls.forEach((r) => {
      const [s, i] = r;
      if (i.tagName === "SELECT") {
        let o = null;
        if (t == null)
          o = null;
        else if (e[s] == null)
          o = i.querySelector("option[selected]");
        else if (!Array.isArray(e[s])) {
          let a = e[s];
          typeof a == "string" && (a = a.replace(/"/g, '\\"')), o = i.querySelector(`option[value="${a}"]`);
        }
        o == null ? (i.value = "", i.selectedIndex = -1) : o.selected = !0;
      } else if (t == null)
        i.classList.remove("ql-active"), i.setAttribute("aria-pressed", "false");
      else if (i.hasAttribute("value")) {
        const o = e[s], a = o === i.getAttribute("value") || o != null && o.toString() === i.getAttribute("value") || o == null && !i.getAttribute("value");
        i.classList.toggle("ql-active", a), i.setAttribute("aria-pressed", a.toString());
      } else {
        const o = e[s] != null;
        i.classList.toggle("ql-active", o), i.setAttribute("aria-pressed", o.toString());
      }
    });
  }
}
Hi.DEFAULTS = {};
function Wo(n, t, e) {
  const r = document.createElement("button");
  r.setAttribute("type", "button"), r.classList.add(`ql-${t}`), r.setAttribute("aria-pressed", "false"), e != null ? (r.value = e, r.setAttribute("aria-label", `${t}: ${e}`)) : r.setAttribute("aria-label", t), n.appendChild(r);
}
function qg(n, t) {
  Array.isArray(t[0]) || (t = [t]), t.forEach((e) => {
    const r = document.createElement("span");
    r.classList.add("ql-formats"), e.forEach((s) => {
      if (typeof s == "string")
        Wo(r, s);
      else {
        const i = Object.keys(s)[0], o = s[i];
        Array.isArray(o) ? Rg(r, i, o) : Wo(r, i, o);
      }
    }), n.appendChild(r);
  });
}
function Rg(n, t, e) {
  const r = document.createElement("select");
  r.classList.add(`ql-${t}`), e.forEach((s) => {
    const i = document.createElement("option");
    s !== !1 ? i.setAttribute("value", String(s)) : i.setAttribute("selected", "selected"), r.appendChild(i);
  }), n.appendChild(r);
}
Hi.DEFAULTS = {
  container: null,
  handlers: {
    clean() {
      const n = this.quill.getSelection();
      if (n != null)
        if (n.length === 0) {
          const t = this.quill.getFormat();
          Object.keys(t).forEach((e) => {
            this.quill.scroll.query(e, I.INLINE) != null && this.quill.format(e, !1, T.sources.USER);
          });
        } else
          this.quill.removeFormat(n.index, n.length, T.sources.USER);
    },
    direction(n) {
      const {
        align: t
      } = this.quill.getFormat();
      n === "rtl" && t == null ? this.quill.format("align", "right", T.sources.USER) : !n && t === "right" && this.quill.format("align", !1, T.sources.USER), this.quill.format("direction", n, T.sources.USER);
    },
    indent(n) {
      const t = this.quill.getSelection(), e = this.quill.getFormat(t), r = parseInt(e.indent || 0, 10);
      if (n === "+1" || n === "-1") {
        let s = n === "+1" ? 1 : -1;
        e.direction === "rtl" && (s *= -1), this.quill.format("indent", r + s, T.sources.USER);
      }
    },
    link(n) {
      n === !0 && (n = prompt("Enter link URL:")), this.quill.format("link", n, T.sources.USER);
    },
    list(n) {
      const t = this.quill.getSelection(), e = this.quill.getFormat(t);
      n === "check" ? e.list === "checked" || e.list === "unchecked" ? this.quill.format("list", !1, T.sources.USER) : this.quill.format("list", "unchecked", T.sources.USER) : this.quill.format("list", n, T.sources.USER);
    }
  }
};
const Ig = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"/></svg>', kg = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"/><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"/></svg>', Mg = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"/></svg>', jg = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"/></svg>', Bg = '<svg viewbox="0 0 18 18"><g class="ql-fill ql-color-label"><polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"/><rect height="1" width="1" x="4" y="4"/><polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"/><rect height="1" width="1" x="2" y="6"/><rect height="1" width="1" x="3" y="5"/><rect height="1" width="1" x="4" y="7"/><polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"/><rect height="1" width="1" x="2" y="12"/><rect height="1" width="1" x="2" y="9"/><rect height="1" width="1" x="2" y="15"/><polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"/><rect height="1" width="1" x="3" y="8"/><path d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"/><path d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"/><path d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"/><rect height="1" width="1" x="12" y="2"/><rect height="1" width="1" x="11" y="3"/><path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"/><rect height="1" width="1" x="2" y="3"/><rect height="1" width="1" x="6" y="2"/><rect height="1" width="1" x="3" y="2"/><rect height="1" width="1" x="5" y="3"/><rect height="1" width="1" x="9" y="2"/><rect height="1" width="1" x="15" y="14"/><polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"/><rect height="1" width="1" x="13" y="7"/><rect height="1" width="1" x="15" y="5"/><rect height="1" width="1" x="14" y="6"/><rect height="1" width="1" x="15" y="8"/><rect height="1" width="1" x="14" y="9"/><path d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"/><rect height="1" width="1" x="14" y="3"/><polygon points="12 6.868 12 6 11.62 6 12 6.868"/><rect height="1" width="1" x="15" y="2"/><rect height="1" width="1" x="12" y="5"/><rect height="1" width="1" x="13" y="4"/><polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"/><rect height="1" width="1" x="9" y="14"/><rect height="1" width="1" x="8" y="15"/><path d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"/><rect height="1" width="1" x="5" y="15"/><path d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"/><rect height="1" width="1" x="11" y="15"/><path d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"/><rect height="1" width="1" x="14" y="15"/><rect height="1" width="1" x="15" y="11"/></g><polyline class="ql-stroke" points="5.5 13 9 5 12.5 13"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="11" y2="11"/></svg>', Pg = '<svg viewbox="0 0 18 18"><rect class="ql-fill ql-stroke" height="3" width="3" x="4" y="5"/><rect class="ql-fill ql-stroke" height="3" width="3" x="11" y="5"/><path class="ql-even ql-fill ql-stroke" d="M7,8c0,4.031-3,5-3,5"/><path class="ql-even ql-fill ql-stroke" d="M14,8c0,4.031-3,5-3,5"/></svg>', Dg = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"/><path class="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"/></svg>', $g = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="5" x2="13" y1="3" y2="3"/><line class="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"/><line class="ql-stroke" x1="11" x2="15" y1="11" y2="15"/><line class="ql-stroke" x1="15" x2="11" y1="11" y2="15"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="7" x="2" y="14"/></svg>', Zo = '<svg viewbox="0 0 18 18"><polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"/><polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"/><line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"/></svg>', Ug = '<svg viewbox="0 0 18 18"><line class="ql-color-label ql-stroke ql-transparent" x1="3" x2="15" y1="15" y2="15"/><polyline class="ql-stroke" points="5.5 11 9 3 12.5 11"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="9" y2="9"/></svg>', Fg = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"/><line class="ql-stroke ql-fill" x1="15" x2="11" y1="4" y2="4"/><path class="ql-fill" d="M11,3a3,3,0,0,0,0,6h1V3H11Z"/><rect class="ql-fill" height="11" width="1" x="11" y="4"/><rect class="ql-fill" height="11" width="1" x="13" y="4"/></svg>', Hg = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"/><line class="ql-stroke ql-fill" x1="9" x2="5" y1="4" y2="4"/><path class="ql-fill" d="M5,3A3,3,0,0,0,5,9H6V3H5Z"/><rect class="ql-fill" height="11" width="1" x="5" y="4"/><rect class="ql-fill" height="11" width="1" x="7" y="4"/></svg>', zg = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z"/><rect class="ql-fill" height="1.6" rx="0.8" ry="0.8" width="5" x="5.15" y="6.2"/><path class="ql-fill" d="M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z"/></svg>', Kg = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z"/></svg>', Vg = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', Gg = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', Wg = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z"/></svg>', Zg = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', Yg = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z"/></svg>', Xg = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"/><line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"/><line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"/></svg>', Jg = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="10" width="12" x="3" y="4"/><circle class="ql-fill" cx="6" cy="7" r="1"/><polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"/></svg>', Qg = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"/></svg>', tp = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="5 7 5 11 3 9 5 7"/></svg>', ep = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"/><path class="ql-even ql-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"/><path class="ql-even ql-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"/></svg>', rp = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"/><line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"/></svg>', np = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="9" x2="15" y1="4" y2="4"/><polyline class="ql-stroke" points="3 4 4 5 6 3"/><line class="ql-stroke" x1="9" x2="15" y1="14" y2="14"/><polyline class="ql-stroke" points="3 14 4 15 6 13"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="3 9 4 10 6 8"/></svg>', sp = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"/><line class="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"/><path class="ql-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"/><path class="ql-stroke ql-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"/><path class="ql-stroke ql-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"/></svg>', ip = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z"/><path class="ql-fill" d="M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z"/></svg>', op = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z"/><path class="ql-fill" d="M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z"/></svg>', lp = '<svg viewbox="0 0 18 18"><line class="ql-stroke ql-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"/><path class="ql-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"/><path class="ql-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"/></svg>', ap = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="2" width="3" x="5" y="5"/><rect class="ql-fill" height="2" width="4" x="9" y="5"/><g class="ql-fill ql-transparent"><rect height="2" width="3" x="5" y="8"/><rect height="2" width="4" x="9" y="8"/><rect height="2" width="3" x="5" y="11"/><rect height="2" width="4" x="9" y="11"/></g></svg>', cp = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"/></svg>', up = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="12" width="1" x="5" y="3"/><rect class="ql-fill" height="12" width="1" x="12" y="3"/><rect class="ql-fill" height="2" width="8" x="5" y="8"/><rect class="ql-fill" height="1" width="3" x="3" y="5"/><rect class="ql-fill" height="1" width="3" x="3" y="7"/><rect class="ql-fill" height="1" width="3" x="3" y="10"/><rect class="ql-fill" height="1" width="3" x="3" y="12"/><rect class="ql-fill" height="1" width="3" x="12" y="5"/><rect class="ql-fill" height="1" width="3" x="12" y="7"/><rect class="ql-fill" height="1" width="3" x="12" y="10"/><rect class="ql-fill" height="1" width="3" x="12" y="12"/></svg>', xn = {
  align: {
    "": Ig,
    center: kg,
    right: Mg,
    justify: jg
  },
  background: Bg,
  blockquote: Pg,
  bold: Dg,
  clean: $g,
  code: Zo,
  "code-block": Zo,
  color: Ug,
  direction: {
    "": Fg,
    rtl: Hg
  },
  formula: zg,
  header: {
    1: Kg,
    2: Vg,
    3: Gg,
    4: Wg,
    5: Zg,
    6: Yg
  },
  italic: Xg,
  image: Jg,
  indent: {
    "+1": Qg,
    "-1": tp
  },
  link: ep,
  list: {
    bullet: rp,
    check: np,
    ordered: sp
  },
  script: {
    sub: ip,
    super: op
  },
  strike: lp,
  table: ap,
  underline: cp,
  video: up
}, hp = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"/><polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"/></svg>';
let Yo = 0;
function Xo(n, t) {
  n.setAttribute(t, `${n.getAttribute(t) !== "true"}`);
}
class gs {
  constructor(t) {
    this.select = t, this.container = document.createElement("span"), this.buildPicker(), this.select.style.display = "none", this.select.parentNode.insertBefore(this.container, this.select), this.label.addEventListener("mousedown", () => {
      this.togglePicker();
    }), this.label.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "Enter":
          this.togglePicker();
          break;
        case "Escape":
          this.escape(), e.preventDefault();
          break;
      }
    }), this.select.addEventListener("change", this.update.bind(this));
  }
  togglePicker() {
    this.container.classList.toggle("ql-expanded"), Xo(this.label, "aria-expanded"), Xo(this.options, "aria-hidden");
  }
  buildItem(t) {
    const e = document.createElement("span");
    e.tabIndex = "0", e.setAttribute("role", "button"), e.classList.add("ql-picker-item");
    const r = t.getAttribute("value");
    return r && e.setAttribute("data-value", r), t.textContent && e.setAttribute("data-label", t.textContent), e.addEventListener("click", () => {
      this.selectItem(e, !0);
    }), e.addEventListener("keydown", (s) => {
      switch (s.key) {
        case "Enter":
          this.selectItem(e, !0), s.preventDefault();
          break;
        case "Escape":
          this.escape(), s.preventDefault();
          break;
      }
    }), e;
  }
  buildLabel() {
    const t = document.createElement("span");
    return t.classList.add("ql-picker-label"), t.innerHTML = hp, t.tabIndex = "0", t.setAttribute("role", "button"), t.setAttribute("aria-expanded", "false"), this.container.appendChild(t), t;
  }
  buildOptions() {
    const t = document.createElement("span");
    t.classList.add("ql-picker-options"), t.setAttribute("aria-hidden", "true"), t.tabIndex = "-1", t.id = `ql-picker-options-${Yo}`, Yo += 1, this.label.setAttribute("aria-controls", t.id), this.options = t, Array.from(this.select.options).forEach((e) => {
      const r = this.buildItem(e);
      t.appendChild(r), e.selected === !0 && this.selectItem(r);
    }), this.container.appendChild(t);
  }
  buildPicker() {
    Array.from(this.select.attributes).forEach((t) => {
      this.container.setAttribute(t.name, t.value);
    }), this.container.classList.add("ql-picker"), this.label = this.buildLabel(), this.buildOptions();
  }
  escape() {
    this.close(), setTimeout(() => this.label.focus(), 1);
  }
  close() {
    this.container.classList.remove("ql-expanded"), this.label.setAttribute("aria-expanded", "false"), this.options.setAttribute("aria-hidden", "true");
  }
  selectItem(t) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    const r = this.container.querySelector(".ql-selected");
    t !== r && (r != null && r.classList.remove("ql-selected"), t != null && (t.classList.add("ql-selected"), this.select.selectedIndex = Array.from(t.parentNode.children).indexOf(t), t.hasAttribute("data-value") ? this.label.setAttribute("data-value", t.getAttribute("data-value")) : this.label.removeAttribute("data-value"), t.hasAttribute("data-label") ? this.label.setAttribute("data-label", t.getAttribute("data-label")) : this.label.removeAttribute("data-label"), e && (this.select.dispatchEvent(new Event("change")), this.close())));
  }
  update() {
    let t;
    if (this.select.selectedIndex > -1) {
      const r = (
        // @ts-expect-error Fix me later
        this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex]
      );
      t = this.select.options[this.select.selectedIndex], this.selectItem(r);
    } else
      this.selectItem(null);
    const e = t != null && t !== this.select.querySelector("option[selected]");
    this.label.classList.toggle("ql-active", e);
  }
}
class sa extends gs {
  constructor(t, e) {
    super(t), this.label.innerHTML = e, this.container.classList.add("ql-color-picker"), Array.from(this.container.querySelectorAll(".ql-picker-item")).slice(0, 7).forEach((r) => {
      r.classList.add("ql-primary");
    });
  }
  buildItem(t) {
    const e = super.buildItem(t);
    return e.style.backgroundColor = t.getAttribute("value") || "", e;
  }
  selectItem(t, e) {
    super.selectItem(t, e);
    const r = this.label.querySelector(".ql-color-label"), s = t && t.getAttribute("data-value") || "";
    r && (r.tagName === "line" ? r.style.stroke = s : r.style.fill = s);
  }
}
class ia extends gs {
  constructor(t, e) {
    super(t), this.container.classList.add("ql-icon-picker"), Array.from(this.container.querySelectorAll(".ql-picker-item")).forEach((r) => {
      r.innerHTML = e[r.getAttribute("data-value") || ""];
    }), this.defaultItem = this.container.querySelector(".ql-selected"), this.selectItem(this.defaultItem);
  }
  selectItem(t, e) {
    super.selectItem(t, e);
    const r = t || this.defaultItem;
    if (r != null) {
      if (this.label.innerHTML === r.innerHTML) return;
      this.label.innerHTML = r.innerHTML;
    }
  }
}
const fp = (n) => {
  const {
    overflowY: t
  } = getComputedStyle(n, null);
  return t !== "visible" && t !== "clip";
};
class oa {
  constructor(t, e) {
    this.quill = t, this.boundsContainer = e || document.body, this.root = t.addContainer("ql-tooltip"), this.root.innerHTML = this.constructor.TEMPLATE, fp(this.quill.root) && this.quill.root.addEventListener("scroll", () => {
      this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
    }), this.hide();
  }
  hide() {
    this.root.classList.add("ql-hidden");
  }
  position(t) {
    const e = t.left + t.width / 2 - this.root.offsetWidth / 2, r = t.bottom + this.quill.root.scrollTop;
    this.root.style.left = `${e}px`, this.root.style.top = `${r}px`, this.root.classList.remove("ql-flip");
    const s = this.boundsContainer.getBoundingClientRect(), i = this.root.getBoundingClientRect();
    let o = 0;
    if (i.right > s.right && (o = s.right - i.right, this.root.style.left = `${e + o}px`), i.left < s.left && (o = s.left - i.left, this.root.style.left = `${e + o}px`), i.bottom > s.bottom) {
      const a = i.bottom - i.top, c = t.bottom - t.top + a;
      this.root.style.top = `${r - c}px`, this.root.classList.add("ql-flip");
    }
    return o;
  }
  show() {
    this.root.classList.remove("ql-editing"), this.root.classList.remove("ql-hidden");
  }
}
const dp = [!1, "center", "right", "justify"], gp = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"], pp = [!1, "serif", "monospace"], mp = ["1", "2", "3", !1], bp = ["small", !1, "large", "huge"];
class qn extends Zr {
  constructor(t, e) {
    super(t, e);
    const r = (s) => {
      if (!document.body.contains(t.root)) {
        document.body.removeEventListener("click", r);
        return;
      }
      this.tooltip != null && // @ts-expect-error
      !this.tooltip.root.contains(s.target) && // @ts-expect-error
      document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus() && this.tooltip.hide(), this.pickers != null && this.pickers.forEach((i) => {
        i.container.contains(s.target) || i.close();
      });
    };
    t.emitter.listenDOM("click", document.body, r);
  }
  addModule(t) {
    const e = super.addModule(t);
    return t === "toolbar" && this.extendToolbar(e), e;
  }
  buildButtons(t, e) {
    Array.from(t).forEach((r) => {
      (r.getAttribute("class") || "").split(/\s+/).forEach((i) => {
        if (i.startsWith("ql-") && (i = i.slice(3), e[i] != null))
          if (i === "direction")
            r.innerHTML = e[i][""] + e[i].rtl;
          else if (typeof e[i] == "string")
            r.innerHTML = e[i];
          else {
            const o = r.value || "";
            o != null && e[i][o] && (r.innerHTML = e[i][o]);
          }
      });
    });
  }
  buildPickers(t, e) {
    this.pickers = Array.from(t).map((s) => {
      if (s.classList.contains("ql-align") && (s.querySelector("option") == null && hn(s, dp), typeof e.align == "object"))
        return new ia(s, e.align);
      if (s.classList.contains("ql-background") || s.classList.contains("ql-color")) {
        const i = s.classList.contains("ql-background") ? "background" : "color";
        return s.querySelector("option") == null && hn(s, gp, i === "background" ? "#ffffff" : "#000000"), new sa(s, e[i]);
      }
      return s.querySelector("option") == null && (s.classList.contains("ql-font") ? hn(s, pp) : s.classList.contains("ql-header") ? hn(s, mp) : s.classList.contains("ql-size") && hn(s, bp)), new gs(s);
    });
    const r = () => {
      this.pickers.forEach((s) => {
        s.update();
      });
    };
    this.quill.on(q.events.EDITOR_CHANGE, r);
  }
}
qn.DEFAULTS = ze({}, Zr.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula() {
          this.quill.theme.tooltip.edit("formula");
        },
        image() {
          let n = this.container.querySelector("input.ql-image[type=file]");
          n == null && (n = document.createElement("input"), n.setAttribute("type", "file"), n.setAttribute("accept", this.quill.uploader.options.mimetypes.join(", ")), n.classList.add("ql-image"), n.addEventListener("change", () => {
            const t = this.quill.getSelection(!0);
            this.quill.uploader.upload(t, n.files), n.value = "";
          }), this.container.appendChild(n)), n.click();
        },
        video() {
          this.quill.theme.tooltip.edit("video");
        }
      }
    }
  }
});
class la extends oa {
  constructor(t, e) {
    super(t, e), this.textbox = this.root.querySelector('input[type="text"]'), this.listen();
  }
  listen() {
    this.textbox.addEventListener("keydown", (t) => {
      t.key === "Enter" ? (this.save(), t.preventDefault()) : t.key === "Escape" && (this.cancel(), t.preventDefault());
    });
  }
  cancel() {
    this.hide(), this.restoreFocus();
  }
  edit() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link", e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (this.root.classList.remove("ql-hidden"), this.root.classList.add("ql-editing"), this.textbox == null) return;
    e != null ? this.textbox.value = e : t !== this.root.getAttribute("data-mode") && (this.textbox.value = "");
    const r = this.quill.getBounds(this.quill.selection.savedRange);
    r != null && this.position(r), this.textbox.select(), this.textbox.setAttribute("placeholder", this.textbox.getAttribute(`data-${t}`) || ""), this.root.setAttribute("data-mode", t);
  }
  restoreFocus() {
    this.quill.focus({
      preventScroll: !0
    });
  }
  save() {
    let {
      value: t
    } = this.textbox;
    switch (this.root.getAttribute("data-mode")) {
      case "link": {
        const {
          scrollTop: e
        } = this.quill.root;
        this.linkRange ? (this.quill.formatText(this.linkRange, "link", t, q.sources.USER), delete this.linkRange) : (this.restoreFocus(), this.quill.format("link", t, q.sources.USER)), this.quill.root.scrollTop = e;
        break;
      }
      case "video":
        t = yp(t);
      case "formula": {
        if (!t) break;
        const e = this.quill.getSelection(!0);
        if (e != null) {
          const r = e.index + e.length;
          this.quill.insertEmbed(
            r,
            // @ts-expect-error Fix me later
            this.root.getAttribute("data-mode"),
            t,
            q.sources.USER
          ), this.root.getAttribute("data-mode") === "formula" && this.quill.insertText(r + 1, " ", q.sources.USER), this.quill.setSelection(r + 2, q.sources.USER);
        }
        break;
      }
    }
    this.textbox.value = "", this.hide();
  }
}
function yp(n) {
  let t = n.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || n.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  return t ? `${t[1] || "https"}://www.youtube.com/embed/${t[2]}?showinfo=0` : (t = n.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) ? `${t[1] || "https"}://player.vimeo.com/video/${t[2]}/` : n;
}
function hn(n, t) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  t.forEach((r) => {
    const s = document.createElement("option");
    r === e ? s.setAttribute("selected", "selected") : s.setAttribute("value", String(r)), n.appendChild(s);
  });
}
const vp = [["bold", "italic", "link"], [{
  header: 1
}, {
  header: 2
}, "blockquote"]];
class aa extends la {
  constructor(t, e) {
    super(t, e), this.quill.on(q.events.EDITOR_CHANGE, (r, s, i, o) => {
      if (r === q.events.SELECTION_CHANGE)
        if (s != null && s.length > 0 && o === q.sources.USER) {
          this.show(), this.root.style.left = "0px", this.root.style.width = "", this.root.style.width = `${this.root.offsetWidth}px`;
          const a = this.quill.getLines(s.index, s.length);
          if (a.length === 1) {
            const c = this.quill.getBounds(s);
            c != null && this.position(c);
          } else {
            const c = a[a.length - 1], h = this.quill.getIndex(c), f = Math.min(c.length() - 1, s.index + s.length - h), b = this.quill.getBounds(new ar(h, f));
            b != null && this.position(b);
          }
        } else document.activeElement !== this.textbox && this.quill.hasFocus() && this.hide();
    });
  }
  listen() {
    super.listen(), this.root.querySelector(".ql-close").addEventListener("click", () => {
      this.root.classList.remove("ql-editing");
    }), this.quill.on(q.events.SCROLL_OPTIMIZE, () => {
      setTimeout(() => {
        if (this.root.classList.contains("ql-hidden")) return;
        const t = this.quill.getSelection();
        if (t != null) {
          const e = this.quill.getBounds(t);
          e != null && this.position(e);
        }
      }, 1);
    });
  }
  cancel() {
    this.show();
  }
  position(t) {
    const e = super.position(t), r = this.root.querySelector(".ql-tooltip-arrow");
    return r.style.marginLeft = "", e !== 0 && (r.style.marginLeft = `${-1 * e - r.offsetWidth / 2}px`), e;
  }
}
L(aa, "TEMPLATE", ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join(""));
class ca extends qn {
  constructor(t, e) {
    e.modules.toolbar != null && e.modules.toolbar.container == null && (e.modules.toolbar.container = vp), super(t, e), this.quill.container.classList.add("ql-bubble");
  }
  extendToolbar(t) {
    this.tooltip = new aa(this.quill, this.options.bounds), t.container != null && (this.tooltip.root.appendChild(t.container), this.buildButtons(t.container.querySelectorAll("button"), xn), this.buildPickers(t.container.querySelectorAll("select"), xn));
  }
}
ca.DEFAULTS = ze({}, qn.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link(n) {
          n ? this.quill.theme.tooltip.edit() : this.quill.format("link", !1, T.sources.USER);
        }
      }
    }
  }
});
const Ep = [[{
  header: ["1", "2", "3", !1]
}], ["bold", "italic", "underline", "link"], [{
  list: "ordered"
}, {
  list: "bullet"
}], ["clean"]];
class ua extends la {
  constructor() {
    super(...arguments);
    L(this, "preview", this.root.querySelector("a.ql-preview"));
  }
  listen() {
    super.listen(), this.root.querySelector("a.ql-action").addEventListener("click", (e) => {
      this.root.classList.contains("ql-editing") ? this.save() : this.edit("link", this.preview.textContent), e.preventDefault();
    }), this.root.querySelector("a.ql-remove").addEventListener("click", (e) => {
      if (this.linkRange != null) {
        const r = this.linkRange;
        this.restoreFocus(), this.quill.formatText(r, "link", !1, q.sources.USER), delete this.linkRange;
      }
      e.preventDefault(), this.hide();
    }), this.quill.on(q.events.SELECTION_CHANGE, (e, r, s) => {
      if (e != null) {
        if (e.length === 0 && s === q.sources.USER) {
          const [i, o] = this.quill.scroll.descendant(He, e.index);
          if (i != null) {
            this.linkRange = new ar(e.index - o, i.length());
            const a = He.formats(i.domNode);
            this.preview.textContent = a, this.preview.setAttribute("href", a), this.show();
            const c = this.quill.getBounds(this.linkRange);
            c != null && this.position(c);
            return;
          }
        } else
          delete this.linkRange;
        this.hide();
      }
    });
  }
  show() {
    super.show(), this.root.removeAttribute("data-mode");
  }
}
L(ua, "TEMPLATE", ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join(""));
class ha extends qn {
  constructor(t, e) {
    e.modules.toolbar != null && e.modules.toolbar.container == null && (e.modules.toolbar.container = Ep), super(t, e), this.quill.container.classList.add("ql-snow");
  }
  extendToolbar(t) {
    t.container != null && (t.container.classList.add("ql-snow"), this.buildButtons(t.container.querySelectorAll("button"), xn), this.buildPickers(t.container.querySelectorAll("select"), xn), this.tooltip = new ua(this.quill, this.options.bounds), t.container.querySelector(".ql-link") && this.quill.keyboard.addBinding({
      key: "k",
      shortKey: !0
    }, (e, r) => {
      t.handlers.link.call(t, !r.format.link);
    }));
  }
}
ha.DEFAULTS = ze({}, qn.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link(n) {
          if (n) {
            const t = this.quill.getSelection();
            if (t == null || t.length === 0) return;
            let e = this.quill.getText(t);
            /^\S+@\S+\.\S+$/.test(e) && e.indexOf("mailto:") !== 0 && (e = `mailto:${e}`);
            const {
              tooltip: r
            } = this.quill.theme;
            r.edit("link", e);
          } else
            this.quill.format("link", !1, T.sources.USER);
        }
      }
    }
  }
});
T.register({
  "attributors/attribute/direction": zl,
  "attributors/class/align": Ul,
  "attributors/class/background": Pd,
  "attributors/class/color": Bd,
  "attributors/class/direction": Kl,
  "attributors/class/font": Wl,
  "attributors/class/size": Yl,
  "attributors/style/align": Fl,
  "attributors/style/background": Bi,
  "attributors/style/color": ji,
  "attributors/style/direction": Vl,
  "attributors/style/font": Zl,
  "attributors/style/size": Xl
}, !0);
T.register({
  "formats/align": Ul,
  "formats/direction": Kl,
  "formats/indent": Og,
  "formats/background": Bi,
  "formats/color": ji,
  "formats/font": Wl,
  "formats/size": Yl,
  "formats/blockquote": gi,
  "formats/code-block": dt,
  "formats/header": pi,
  "formats/list": Cn,
  "formats/bold": Tn,
  "formats/code": Pi,
  "formats/italic": mi,
  "formats/link": He,
  "formats/script": bi,
  "formats/strike": yi,
  "formats/underline": vi,
  "formats/formula": Yn,
  "formats/image": Ei,
  "formats/video": Xn,
  "modules/syntax": na,
  "modules/table": Cg,
  "modules/toolbar": Hi,
  "themes/bubble": ca,
  "themes/snow": ha,
  "ui/icons": xn,
  "ui/picker": gs,
  "ui/icon-picker": ia,
  "ui/color-picker": sa,
  "ui/tooltip": oa
}, !0);
class zi extends St.Component {
  constructor(t) {
    super(t), this.editingAreaRef = ga(), this.dirtyProps = [
      "modules",
      "formats",
      "bounds",
      "theme",
      "children"
    ], this.cleanProps = [
      "id",
      "className",
      "style",
      "placeholder",
      "tabIndex",
      "onChange",
      "onChangeSelection",
      "onFocus",
      "onBlur",
      "onKeyPress",
      "onKeyDown",
      "onKeyUp"
    ], this.state = {
      generation: 0
    }, this.selection = null, this.onEditorChange = (r, s, i, o) => {
      var a, c;
      r === "text-change" ? (a = this.onEditorChangeText) == null || a.call(this, this.editor.root.innerHTML, s, o, this.unprivilegedEditor) : r === "selection-change" && ((c = this.onEditorChangeSelection) == null || c.call(this, s, o, this.unprivilegedEditor));
    };
    const e = this.isControlled() ? t.value : t.defaultValue;
    this.value = e ?? "";
  }
  validateProps(t) {
    if (St.Children.count(t.children) > 1)
      throw new Error("The Quill editing area can only be composed of a single React element.");
    if (St.Children.count(t.children)) {
      const e = St.Children.only(t.children);
      if ((e == null ? void 0 : e.type) === "textarea")
        throw new Error("Quill does not support editing on a <textarea>. Use a <div> instead.");
    }
    if (this.lastDeltaChangeSet && t.value === this.lastDeltaChangeSet)
      throw new Error("You are passing the `delta` object from the `onChange` event back as `value`. You most probably want `editor.getContents()` instead. See: https://github.com/zenoamaro/react-quill#using-deltas");
  }
  shouldComponentUpdate(t, e) {
    if (this.validateProps(t), !this.editor || this.state.generation !== e.generation)
      return !0;
    if ("value" in t) {
      const r = this.getEditorContents(), s = t.value ?? "";
      this.isEqualValue(s, r) || this.setEditorContents(this.editor, s);
    }
    return t.readOnly !== this.props.readOnly && this.setEditorReadOnly(this.editor, t.readOnly), [...this.cleanProps, ...this.dirtyProps].some((r) => !$e(t[r], this.props[r]));
  }
  shouldComponentRegenerate(t) {
    return this.dirtyProps.some((e) => !$e(t[e], this.props[e]));
  }
  componentDidMount() {
    this.instantiateEditor(), this.setEditorContents(this.editor, this.getEditorContents());
  }
  componentWillUnmount() {
    this.destroyEditor();
  }
  componentDidUpdate(t, e) {
    if (this.editor && this.shouldComponentRegenerate(t)) {
      const r = this.editor.getContents(), s = this.editor.getSelection();
      this.regenerationSnapshot = { delta: r, selection: s }, this.setState({ generation: this.state.generation + 1 }), this.destroyEditor();
    }
    if (this.state.generation !== e.generation) {
      const { delta: r, selection: s } = this.regenerationSnapshot;
      delete this.regenerationSnapshot, this.instantiateEditor();
      const i = this.editor;
      i.setContents(r), Jo(() => this.setEditorSelection(i, s));
    }
  }
  instantiateEditor() {
    this.editor ? this.hookEditor(this.editor) : this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
  }
  destroyEditor() {
    var r;
    if (!this.editor)
      return;
    this.unhookEditor(this.editor);
    const t = (r = this.props.modules) == null ? void 0 : r.toolbar;
    if (!(typeof t == "object" && t && "container" in t && typeof t.container == "string" || typeof t == "string")) {
      const s = document.querySelector(".ql-toolbar");
      s && s.remove();
    }
    delete this.editor;
  }
  /*
  We consider the component to be controlled if `value` is being sent in props.
  */
  isControlled() {
    return "value" in this.props;
  }
  getEditorConfig() {
    return {
      bounds: this.props.bounds,
      formats: this.props.formats,
      modules: this.props.modules,
      placeholder: this.props.placeholder,
      readOnly: this.props.readOnly,
      tabIndex: this.props.tabIndex,
      theme: this.props.theme
    };
  }
  getEditor() {
    if (!this.editor)
      throw new Error("Accessing non-instantiated editor");
    return this.editor;
  }
  /**
  Creates an editor on the given element. The editor will be passed the
  configuration, have its events bound,
  */
  createEditor(t, e) {
    const r = new T(t, e);
    return e.tabIndex != null && this.setEditorTabIndex(r, e.tabIndex), this.hookEditor(r), r;
  }
  hookEditor(t) {
    this.unprivilegedEditor = this.makeUnprivilegedEditor(t), t.on("editor-change", this.onEditorChange);
  }
  unhookEditor(t) {
    t.off("editor-change", this.onEditorChange);
  }
  getEditorContents() {
    return this.value;
  }
  getEditorSelection() {
    return this.selection;
  }
  /*
  True if the value is a Delta instance or a Delta look-alike.
  */
  isDelta(t) {
    return t && t.ops;
  }
  /*
  Special comparison function that knows how to compare Deltas.
  */
  isEqualValue(t, e) {
    return this.isDelta(t) && this.isDelta(e) ? $e(t.ops, e.ops) : $e(t, e);
  }
  /*
  Replace the contents of the editor, but keep the previous selection hanging
  around so that the cursor won't move.
  */
  setEditorContents(t, e) {
    this.value = e;
    const r = this.getEditorSelection();
    typeof e == "string" ? t.setContents(t.clipboard.convert({ html: e })) : t.setContents(e), Jo(() => this.setEditorSelection(t, r));
  }
  setEditorSelection(t, e) {
    if (this.selection = e, e) {
      const r = t.getLength();
      e.index = Math.max(0, Math.min(e.index, r - 1)), e.length = Math.max(0, Math.min(e.length, r - 1 - e.index)), t.setSelection(e);
    }
  }
  setEditorTabIndex(t, e) {
    var r;
    (r = t == null ? void 0 : t.scroll) != null && r.domNode && (t.scroll.domNode.tabIndex = e);
  }
  setEditorReadOnly(t, e) {
    e ? t.disable() : t.enable();
  }
  /*
  Returns a weaker, unprivileged proxy object that only exposes read-only
  accessors found on the editor instance, without any state-modifying methods.
  */
  makeUnprivilegedEditor(t) {
    const e = t;
    return {
      getHTML: () => e.root.innerHTML,
      getSemanticHTML: e.getSemanticHTML.bind(e),
      getLength: e.getLength.bind(e),
      getText: e.getText.bind(e),
      getContents: e.getContents.bind(e),
      getSelection: e.getSelection.bind(e),
      getBounds: e.getBounds.bind(e)
    };
  }
  getEditingArea() {
    const t = this.editingAreaRef.current;
    if (!t)
      throw new Error("Cannot find element for editing area");
    if (t.nodeType === 3)
      throw new Error("Editing area cannot be a text node");
    return t;
  }
  /*
  Renders an editor area, unless it has been provided one to clone.
  */
  renderEditingArea() {
    const { children: t, preserveWhitespace: e } = this.props, { generation: r } = this.state, s = {
      key: r,
      ref: this.editingAreaRef
    };
    return St.Children.count(t) ? St.cloneElement(St.Children.only(t), s) : e ? St.createElement("pre", { ...s }) : St.createElement("div", { ...s });
  }
  render() {
    return St.createElement("div", { id: this.props.id, style: this.props.style, key: this.state.generation, className: `quill ${this.props.className ?? ""}`, onKeyPress: this.props.onKeyPress, onKeyDown: this.props.onKeyDown, onKeyUp: this.props.onKeyUp }, this.renderEditingArea());
  }
  onEditorChangeText(t, e, r, s) {
    var o, a;
    if (!this.editor)
      return;
    const i = this.isDelta(this.value) ? s.getContents() : s.getHTML();
    i !== this.getEditorContents() && (this.lastDeltaChangeSet = e, this.value = i, (a = (o = this.props).onChange) == null || a.call(o, t, e, r, s));
  }
  onEditorChangeSelection(t, e, r) {
    var a, c, h, f, b, d;
    if (!this.editor)
      return;
    const s = this.getEditorSelection(), i = !s && t, o = s && !t;
    $e(t, s) || (this.selection = t, (c = (a = this.props).onChangeSelection) == null || c.call(a, t, e, r), i ? (f = (h = this.props).onFocus) == null || f.call(h, t, e, r) : o && ((d = (b = this.props).onBlur) == null || d.call(b, s, e, r)));
  }
  focus() {
    this.editor && this.editor.focus();
  }
  blur() {
    this.editor && (this.selection = null, this.editor.blur());
  }
}
zi.displayName = "React Quill";
zi.Quill = T;
zi.defaultProps = {
  theme: "snow",
  modules: {},
  readOnly: !1
};
function Jo(n) {
  Promise.resolve().then(n);
}
function wp({
  message: n,
  closeModal: t,
  onConfirm: e,
  onCancel: r
}) {
  return /* @__PURE__ */ ot.jsxs("article", { className: "bg-white rounded p-4 flex flex-col gap-2 max-w-md w-11/12", children: [
    /* @__PURE__ */ ot.jsx("p", { className: "p-4", children: n }),
    /* @__PURE__ */ ot.jsxs("div", { className: "flex gap-2 justify-end", children: [
      /* @__PURE__ */ ot.jsx(
        Zi,
        {
          onClick: () => {
            r == null || r(), t();
          },
          children: "Cancelar"
        }
      ),
      /* @__PURE__ */ ot.jsx(
        Zi,
        {
          onClick: () => {
            e == null || e(), t();
          },
          children: "Confirmar"
        }
      )
    ] })
  ] });
}
function Ap() {
  return /* @__PURE__ */ ot.jsx("article", { className: "bg-white rounded p-4 flex flex-col gap-2 max-w-md w-11/12", children: /* @__PURE__ */ ot.jsx(el, {}) });
}
function jp({ children: n }) {
  const [t, e] = Qo([]);
  function r(o) {
    const a = Tp();
    return e((c) => [...c, { id: a, modal: o }]), a;
  }
  function s(o) {
    e(
      (a) => a.filter((c) => c.id !== o)
    );
  }
  const i = pa(
    (o, a, c) => {
      const h = r(
        /* @__PURE__ */ ot.jsx(
          wp,
          {
            message: o,
            onConfirm: a,
            onCancel: c,
            closeModal: () => s(h)
          }
        )
      );
    },
    []
  );
  return /* @__PURE__ */ ot.jsxs(
    Ea.Provider,
    {
      value: {
        showConfirmationModal: i,
        withLoadingModal: async (o) => {
          const a = r(/* @__PURE__ */ ot.jsx(Ap, {}));
          try {
            return await o();
          } finally {
            s(a);
          }
        }
      },
      children: [
        n,
        t.length > 0 && /* @__PURE__ */ ot.jsx("div", { className: "fixed top-0 left-0 right-0 bottom-0 z-50 w-screen bg-black bg-opacity-50 flex justify-center items-center", children: t.map((o) => /* @__PURE__ */ ot.jsx(ma, { children: o.modal }, o.id)) })
      ]
    }
  );
}
function Tp() {
  let n = "";
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = t.length;
  for (let r = 0; r < 10; r++)
    n += t.charAt(
      Math.floor(Math.random() * e)
    );
  return n;
}
const ps = Nn({
  call: () => Promise.resolve(void 0),
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  isLoggedIn: !1
});
function xp() {
  return _n(ps);
}
function Bp() {
  const { login: n } = _n(ps);
  return n;
}
function Pp() {
  const { logout: n } = _n(ps);
  return n;
}
function Np() {
  return _n(ps);
}
function Dp() {
  return Np().currentUser;
}
const $p = Nn({
  location: void 0,
  navigate: {
    toRoute: () => {
    },
    toUrl: () => {
    },
    back: () => {
    }
  }
});
function Ki(n, t) {
  let e = "pending", r;
  const s = n.then((i) => {
    e = "resolved", r = i;
  });
  return {
    read: () => {
      if (e === "pending")
        throw s;
      return r;
    },
    refresh: () => Ki(t(), t)
  };
}
const _p = Ki(
  Promise.resolve(void 0),
  () => Promise.resolve(void 0)
);
function Up() {
  return function(t, e) {
    const r = xp(), [s, i] = Qo(_p), o = s.read();
    return ba(() => {
      i(
        Ki(
          r.call(t, e),
          () => r.call(t, e)
        )
      );
    }, [JSON.stringify(e)]), [o, () => i(s.refresh())];
  };
}
export {
  Aa as B,
  Cp as E,
  wa as F,
  Ta as I,
  el as L,
  Ea as M,
  zi as R,
  $p as a,
  Dp as b,
  wi as c,
  ps as d,
  Zi as e,
  jp as f,
  Bp as g,
  Pp as h,
  Np as i,
  ot as j,
  Ki as k,
  Up as l,
  xp as u
};
